import { downloadSeasonStats, seasonExportDates } from "../../shared/utils/season-stats-export";
import { participationErrorKey } from '../../shared/utils/participation-error';
import { ScreenViewHistory } from "../../shared/screen-shell/screen-view-history";
import { navigateBackOrFallback } from "../../shared/screen-shell/screen-navigation.utils";
import { Component, DoCheck, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { BalanceTeamsResult, RecruitmentCampaign, EventPlayerBlock, Event, EventGameResult, InactiveEventPlayer, RemoveInactivePlayersResult } from "../../shared/models/event";
import { EventService } from "../../shared/services/event.service";
import { PlayerService } from "../../shared/services/player.service";
import { PlayerEventInfoService } from "../../shared/services/playereventinfo.service";
import { BehaviorSubject, Observable, Subscription, of, forkJoin } from "rxjs";
import { GuestParticipationRequest, PlayerEventInfo, PlayerEventInfoJersey, PlayerEventInfoSource, PlayerEventInfoStatus, TeamMemberType } from "../../shared/models/playerEventInfo";
import { GuestPlayerRequest, Player, PlayerType } from "../../shared/models/player";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { ClientNotificationService } from "../../shared/services/client-notification.service";
import { Chat } from "../../shared/models/chat";
import { ChatService } from "../../shared/services/chat.service";
import { ParamMap } from "@angular/router";
import { DelayedSpinnerService } from "../../shared/services/delayed-spinner.service";
import { TranslateService } from '@ngx-translate/core';
import { catchError, debounceTime, finalize, first, map, mergeMap, switchMap, timeout } from "rxjs/operators";
import { AuthenticatedRealtimeService } from "../../shared/services/authenticated-realtime.service";
import { AnalyticsService } from "../../shared/services/analytics.service";
import { PlaySpaceService } from "../../shared/services/playspace.service";
import { PlaySpace } from "../../shared/models/playSpace";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { environment } from "app/environments/environment";
import { MapAdvancedMarker, MapInfoWindow } from "@angular/google-maps";
import { StatsService } from "../../shared/services/stats.service";
import { EventStats } from "../../shared/models/eventStats";
import { SeasonStats } from "../../shared/models/seasonStats";
import { Stats } from "../../shared/models/stats";
import { LocalizationService } from "app/shared/services/localization.service";
import { DialogService } from "../../core/dialog/dialog.service";
import { nogoshIconClass, NogoshIconName } from "../../shared/icons/nogosh-icons.generated";

type MatchInfoEditorMode = "name" | "time" | "location" | "occurrence" | "manager" | "seasons" | "maxPlayers" | "rules" | "visibility" | "cancelMatch" | "addPlayers" | "inviteNewUsers" | "inviteViaEmail" | "directInvite" | "footballNetwork" | "footballerFriends" | "openProfiles" | "nogoshPlayers" | "guestPlayers" | "notifications" | "balanceTeams" | "stats" | "history" | "playerDetail" | "playerManagement" | "settings" | "result" | "changes" | null;
type FootballNetworkSource = "friends" | "references" | "openProfiles";
type StatsMetric = "playerScore" | "teamBoost";
type StatsPeriod = "season" | "allTime";
const PRAVI_FUDBALERI_ORIGINAL_EVENT_ID = "58d0311470592d6242f300db";

@Component({
    selector: "event-players",
    templateUrl: "./event-players.component.html",
    styleUrls: ["../event.component.css", "../event-history/event-history.component.css", "../match-home/match-overview.css"],
    standalone: false
})
export class EventPlayersComponent implements OnInit, OnDestroy, DoCheck {
  private stopRealtime: (() => void) = null;
  private realtimeRevision = 0;
  private realtimePending = false;
  private realtimeReading = false;
  private realtimeTimer: ReturnType<typeof setTimeout> = null;
  private destroyed = false;
  private resultLoadSubscription: Subscription = null;
  private inviteResponseSubscription: Subscription = null;
  @Input() public sendFinalEmailHref: string = "";
  @Input() public editMode: boolean = false;
  public event: Event;

  public autocompleteSelectedPlayer: Player;
  public selectedPlayerHolder: Player;
  public playerNameSelected: boolean;
  public typeaheadPlayerLoading: boolean;
  public typeaheadPlayerNoResults: boolean;
  public playerDataSource: Observable<any>;

  public fetchPlayerEventInfosInProgress: boolean;
  public newCandidatesFound: boolean;
  public newCandidatesInfoList: PlayerEventInfo[] = new Array<PlayerEventInfo>();
  public showHelp: boolean;

  public currentPlayer: Player;

  public loading = false;
  public readonly eventPlayersReady$ = new BehaviorSubject<boolean>(false);
  public loadingPlayersList = false;
  public countOfConfirmed: number = 0;
  public countOfNotAnswered: number = 0;
  public countOfDeclined: number = 0;
  public countOfNotNotified: number = 0;

  public playerEventInfoStatus: PlayerEventInfoStatus = new PlayerEventInfoStatus();
  public selectedPlayerListStatus: string = this.playerEventInfoStatus.CONFIRMED;
  public showPlayerListSearch: boolean = false;
  public playerListSearchText: string = "";
  public playerEventInfoJersey: PlayerEventInfoJersey = new PlayerEventInfoJersey();
  public playerEventInfoSource: PlayerEventInfoSource = new PlayerEventInfoSource();
  public teamMemberType: TeamMemberType = new TeamMemberType();
  public sendInviteEmailEvent: Event;
  public matchInfoEditorMode: MatchInfoEditorMode = null;
  public showRoster = false;
  public memberRosterTab = 'FIRST_TEAM';
  public memberRosterSearchOpen = false;
  public memberRosterSearch = '';
  public declinedPlayersExpanded = false;

  public declinedMatchPlayers(): PlayerEventInfo[] {
    return (this.event?.playerEventInfos || []).filter(info =>
      info.player?.id && info.status === this.playerEventInfoStatus.DECLINED);
  }

  public visibleDeclinedMatchPlayers(): PlayerEventInfo[] {
    const players = this.declinedMatchPlayers();
    return this.declinedPlayersExpanded ? players : players.slice(0, 2);
  }


  public memberRosterPlayers(search = true): PlayerEventInfo[] {
    const query = search && this.memberRosterSearchOpen ? this.memberRosterSearch.trim().toLocaleLowerCase() : '';
    return (this.event?.playerEventInfos || []).filter(info => info.player?.id &&
      (this.memberRosterTab === 'ALL' || info.teamMemberType === this.memberRosterTab) &&
      (!query || [info.player.nickName, info.player.name, info.player.email].filter(Boolean).join(' ').toLocaleLowerCase().includes(query)))
      .slice().sort((a, b) => this.teamMemberDisplayOrder(a.teamMemberType) - this.teamMemberDisplayOrder(b.teamMemberType) ||
        this.getPlayerDisplayName(a).localeCompare(this.getPlayerDisplayName(b)));
  }

  public memberRosterRating(ratings: Player['ratingOffence']): number | null {
    const valid = (ratings || []).filter(item => Number.isFinite(item?.rating) && item.rating >= 1 && item.rating <= 10);
    return valid.length ? Math.round(valid.reduce((sum, item) => sum + item.rating, 0) / valid.length) : null;
  }

  public memberRosterTitleKey(): string {
    return this.memberRosterTab === 'FIRST_TEAM' ? 'notifications.firstTeam' :
      this.memberRosterTab === 'RESERVE' ? 'notifications.reserves' : 'players.allPlayers';
  }

  public memberRosterStatusKey(status: string): string {
    return ({CONFIRMED: 'events.rosterStatusConfirmed', DECLINED: 'events.rosterStatusDeclined',
      NOT_ANSWERED: 'events.rosterStatusNotAnswered', NOT_NOTIFIED: 'events.rosterStatusNotNotified'})[status] || '';
  }
  private homeActionApplied = false;
  public matchInfoScreenEntering = false;
  public matchInfoScreenExiting = false;
  private resultReturnMode: MatchInfoEditorMode = null;
  private matchInfoTransitionTimer: number = null;
  private readonly screenTransitionMs = 150;
  public returnToSettingsAfterMatchInfoEdit: boolean = false;
  public playerManagementListChanged: boolean = false;
  public showMatchTimeEditor: boolean = false;
  public showMatchLocationEditor: boolean = false;
  public matchInfoSaving: boolean = false;
  public matchInfoErrorMsg: string = null;
  public directInviteEmail: string = "";
  public directInviteNickName: string = "";
  public directInviteInProgress: boolean = false;
  public directInviteSuccessMsg: string = null;
  public directInviteErrorMsg: string = null;
  public newUserInviteLinkLoading: boolean = false;
  public newUserInviteLinkUrl: string = "";
  public newUserInviteLinkErrorMsg: string = null;
  public newUserInviteLinkCopiedMsg: string = null;
  public emailInviteText: string = "";
  public emailInviteInProgress: boolean = false;
  public emailInviteSuccessMsg: string = null;
  public emailInviteErrorMsg: string = null;
  public readonly maxEmailInvites: number = 20;
  public matchNameDraft: string = "";
  public currentDate: Date = EventPlayersComponent.todayAtStartOfDay();
  public selectedDate: Date;
  public selectedHour: number = 0;
  public selectedMinute: number = 0;
  public recurringTypeDraft: string = "ONE_OFF";
  public readonly recurringTypeOptions: { value: string, labelKey: string, descriptionKey: string, icon: NogoshIconName }[] = [
    { value: "ONE_OFF", labelKey: "events.occurrenceOneOff", descriptionKey: "events.occurrenceOneOffDescription", icon: "match.time" },
    { value: "WEEKLY", labelKey: "events.weekly", descriptionKey: "events.occurrenceWeeklyDescription", icon: "match.recurring" },
    { value: "DAILY", labelKey: "events.daily", descriptionKey: "events.occurrenceDailyDescription", icon: "common.refresh" },
    { value: "MONTHLY", labelKey: "events.occurrenceMonthly", descriptionKey: "events.occurrenceMonthlyDescription", icon: "match.seasons" }
  ];

  public recurringTypeIconClass(icon: NogoshIconName): string {
    switch (icon) {
      case "match.time":
        return nogoshIconClass("match.time");
      case "match.recurring":
        return nogoshIconClass("match.recurring");
      case "common.refresh":
        return nogoshIconClass("common.refresh");
      case "match.seasons":
        return nogoshIconClass("match.seasons");
      default:
        return nogoshIconClass("match.time");
    }
  }
  public managerSearchText: string = "";
  public selectedManagerDraft: Player = null;
  public managerPlayerDataSource: Observable<any>;
  public seasonModeDraft: "YEARLY" | "INFINITE" | "CUSTOM" = "YEARLY";
  public season1StartDraft: Date = null;
  public season2StartDraft: Date = null;
  public seasonStartDateDrafts: Date[] = [];
  public maxPlayersDraft: number = null;
  public readonly maxPlayersQuickOptions: number[] = [8, 10, 12, 14];
  public rulesDraft: string = "";
  public ruleParagraphDrafts: string[] = [];
  public rulesReadOnly: boolean = false;
  public rulesEnabledDraft: boolean = false;
  public visibilityOpenDraft: boolean = false;
  public autocompletePlayspace: string;
  public selectedExistingPlaySpace: PlaySpace = null;
  public locationDetailPlaySpace: PlaySpace = null;
  public locationEditorMode: "name" | "existing" = "name";
  public locationPickerView: "list" | "map" = "list";
  public locationNameSelected: boolean = false;
  public locationRemovedDraft: boolean = false;
  public typeaheadLocationLoading: boolean = false;
  public typeaheadLocationNoResults: boolean = false;
  public locationDataSource: Observable<any>;
  public nearbyPlaySpaces: PlaySpace[] = [];
  public locatedNearbyPlaySpacesCache: PlaySpace[] = [];
  public nearbyLocationsMapOptionsCache: google.maps.MapOptions = {
    mapId: environment.GOOGLE_MAPS_MAP_ID,
    center: { lat: 45.815, lng: 15.9819 },
    zoom: 12,
    clickableIcons: false,
    streetViewControl: false,
    mapTypeControl: false
  };
  private nearbyLocationMarkerCache: {[key: string]: {position: google.maps.LatLngLiteral, options: google.maps.marker.AdvancedMarkerElementOptions}} = {};
  public nearbyPlaySpacesLoading: boolean = false;
  public nearbyPlaySpacesLoaded: boolean = false;
  public nearbyPlaySpacesError: boolean = false;
  public locationDetailMapOptionsCache: google.maps.MapOptions = {
    mapId: environment.GOOGLE_MAPS_MAP_ID,
    center: { lat: 45.815, lng: 15.9819 },
    zoom: 15,
    clickableIcons: false,
    streetViewControl: false,
    mapTypeControl: false
  };
  public locationDetailMarkerPositionCache: google.maps.LatLngLiteral = null;
  public bsConfig: Partial<BsDatepickerConfig>;
  public inlineStatsOpenSeasonIndexes: {[key: number]: boolean} = {};

  public showNotifyDialog: boolean = false;
  public showNotificationsSent: boolean = false;
  public showNotificationLimitReached: boolean = false;
  public notificationsSentGroupLabel: string = null;
  public showNotifyConfirmDialog: boolean = false;
  public notifyConfirmEvent: Event = null;
  public notifyConfirmMemberType: string = null;
  public notifyConfirmGroupLabel: string = null;
  public notifyConfirmNoResponse: boolean = false;

  public showNotifyAllOpenProfiles: boolean = false;
  public showNotifyTeammateOpenProfiles: boolean = false;
  public addNewPeopleToNogosh: boolean = false;
  public showAddPlayersDialog: boolean = false;
  public notifyAllOpenProfilesEvent: Event;
  public notifyTeammateOpenProfilesEvent: Event;
  public showNewNogoshUserDialog: boolean = false;
  public showInvitePlayersToMatchDialog: boolean = false;
  public showGuestPlayersDialog: boolean = false;
  public nogoshPlayersSearchErrorMsg: string = null;
  public nogoshPlayersAddSuccessMsg: string = null;
  public addedNogoshPlayers: Player[] = new Array<Player>();
  public selectedPlayers: Player[] = new Array<Player>();
  public inviteCandidateSearchText: string = "";
  public inviteCandidatePlayers: Player[] = new Array<Player>();
  public inviteCandidateLoading: boolean = false;
  public footballNetworkSource: FootballNetworkSource = "friends";
  public eventId: string = null;
  public guestPlayers: Player[] = new Array<Player>();
  public guestForm: GuestPlayerRequest = { name: "", nickName: "" };
  public selectedGuestForEdit: Player = null;
  public guestErrorMsg: string = null;
  public guestActionInProgress: boolean = false;
  public showDeactivateGuestDialog: boolean = false;
  public guestForDeactivate: Player = null;
  public playerType: PlayerType = new PlayerType();
  public selectedPlayerDetailEventInfo: PlayerEventInfo = null;
  public responseSaving: boolean = false;
  public pendingInviteStatus: string = null;
  public responseConfirmStatus: string = null;
  public responseResetOpen: boolean = false;
  public responseFeedbackStatus: string = null;
  public responseError: boolean = false;
  public lastFailedInviteStatus: string = null;
  private responseFeedbackTimer: ReturnType<typeof setTimeout> = null;
  public balanceTeamsInProgress: boolean = false;
  public balanceTeamsErrorMsg: string = null;
  public balanceTeamsResult: BalanceTeamsResult = null;
  public showBalanceTeamsDialog: boolean = false;
  public showBalanceTeamsDetails: boolean = false;
  public showResultDialog: boolean = false;
  public resultEvent: Event = null;
  public resultGames: EventGameResult[] = [];
  public resultLoading: boolean = false;
  public resultSaving: boolean = false;
  public resultErrorMsg: string;
  public showInactiveCleanupDialog: boolean = false;
  public inactiveCleanupMonthOptions: number[] = [1, 2, 3, 6, 12];
  public inactiveCleanupMonths: number = 3;
  public inactiveCleanupPlayers: InactiveEventPlayer[] = [];
  public selectedInactivePlayerIds: {[playerId: string]: boolean} = {};
  public inactiveCleanupSummaryCount: number = null;
  public inactiveCleanupSummaryEventId: string = null;
  public inactiveCleanupSummaryLoading: boolean = false;
  public inactiveCleanupLoading: boolean = false;
  public inactiveCleanupRemoving: boolean = false;
  public inactiveCleanupErrorMsg: string = null;
  public inactiveCleanupWarningMsg: string = null;
  public inactiveCleanupSuccessMsg: string = null;
  public showInactiveCleanupConfirm: boolean = false;
  public showDeleteMatchDialog: boolean = false;
  public showLeaveTeamDialog: boolean = false;
  public leaveTeamInProgress: boolean = false;
  public deleteMatchLoading: boolean = false;
  public deleteMatchErrorMsg: string = null;
  public cancelMatchReason: string = "";
  public cancelMatchInProgress: boolean = false;
  public cancelMatchErrorMsg: string = null;
  public uncancelMatchInProgress: boolean = false;
  public uncancelMatchErrorMsg: string = null;
  public inlineEventStats: EventStats = null;
  public inlineStatsLoading: boolean = false;
  public inlineStatsErrorMsg: string = null;
  public showStatsScoreInfoDialog: boolean = false;
  public showStatsExportDialog = false;
  public selectedStatsExportSeason: SeasonStats = null;
  public statsExportBusy = false;
  public statsExportError = "";
  public activeStatsMetric: StatsMetric = "playerScore";
  public activeStatsPeriod: StatsPeriod = "season";
  public inlineHistoryEvents: Event[] = [];
  public inlineHistoryLoading: boolean = false;
  public inlineHistoryErrorMsg: string = null;
  public inlineHistoryPage: number = 0;
  public inlineHistoryPageSize: number = 20;
  private inlineHistoryParentEvent: Event = null;

  @ViewChild("newPlayer")
  playerAutocomplete: ElementRef;
  @ViewChildren(MapInfoWindow) locationInfoWindows: QueryList<MapInfoWindow>;
  private boundLocationMarkers = new Set<google.maps.marker.AdvancedMarkerElement>();

  public navigateHref: string = "";

  constructor(
    public playerService: PlayerService,
    private chatService: ChatService,
    public eventService: EventService,
    private playerEventInfoService: PlayerEventInfoService,
    public route: ActivatedRoute,
    public router: Router,
    public location: Location,
    private _location: Location,
    private spinner: DelayedSpinnerService,
    private translate: TranslateService,
    private analytics: AnalyticsService,
    private playSpaceService: PlaySpaceService,
    private statsService: StatsService,
    private localizationService: LocalizationService,
    private dialogService: DialogService,
    private realtime: AuthenticatedRealtimeService,
    private clientNotifications: ClientNotificationService
  ) {
    this.loading = true;
    this.spinner.show();
    this.newCandidatesFound = false;
    this.bsConfig = {
      containerClass: 'theme-dark-blue',
      showWeekNumbers: false,
      selectFromOtherMonth: true,
    };

    this.playerDataSource = new Observable((observer: any) => {
      observer.next(this.autocompleteSelectedPlayer);
    })
    .pipe(
      debounceTime(500),
      mergeMap((token: string) => this.getPlayersAsObservable(token))
    );

    this.managerPlayerDataSource = new Observable((observer: any) => {
      observer.next(this.managerSearchText);
    })
    .pipe(
      debounceTime(500),
      mergeMap((token: string) => this.getPlayersAsObservable(token))
    );

    this.locationDataSource = new Observable((observer: any) => {
      observer.next(this.autocompletePlayspace);
    })
    .pipe(
      debounceTime(500),
      mergeMap((token: string) => this.getPlaySpacesAsObservable(token))
    );
  }

  ngOnInit() {

    this.loading = true;
    this.eventPlayersReady$.next(false);
    this.spinner.show();
    this.newCandidatesFound = false;

    this.event = JSON.parse(localStorage.getItem("event"));
    const editSelectedEvent = this.route.snapshot.params["editSelectedEvent"];
    this.editMode = editSelectedEvent ? JSON.parse(editSelectedEvent) : false;
    this.currentPlayer = this.playerService.getCurrentPlayer();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.eventId = params.get("eventId");
    });

    if (!localStorage.getItem("event") && this.eventId === null) {
      this.router.navigate(["/event-list"]);
      return;
    }

    const prepared = this.route.snapshot.data['match'];
    if (prepared) {
      this.event = prepared.event;
      this.homeChat = prepared.chat;
      this.preparedBlockedPlayers = prepared.blocked || [];
      this.homeRosterPrepared = prepared.blocked !== null;
      this.configureManagerView();
      this.applyReturnedPlaySpaceIfPresent();
      this.applyPlayerEventInfos(prepared.event.playerEventInfos);
      this.startRealtime();
      this.applyHomeAction();
      this.initViewHistory();
      return;
    }
    if (this.eventId !== null) {
      this.loadEventPlayersScreen(this.eventId);
    } else {
      if (!this.event || !this.event.id) {
        this.openEventListAfterMissingMatch();
        return;
      }
      this.loadEventPlayersScreen(this.event.id);
    }
  }

  ngOnDestroy(): void {
    this.cancelInviteResponse();
    this.cancelResultLoad();
    this.viewHistory?.destroy();
    this.destroyed = true;
    this.stopRealtime?.();
    clearTimeout(this.realtimeTimer);
    this.clearResponseFeedbackTimer();
    this.clearMatchInfoTransitionTimer();
  }

  private loadEventPlayersScreen(eventId: string): void {
    this.cancelInviteResponse();
    this.eventService.getRichEvent(eventId).subscribe((event) => {
      this.event = event;
      localStorage.setItem("event", JSON.stringify(this.event));
      this.configureManagerView();
      this.startRealtime();
      this.applyReturnedPlaySpaceIfPresent();
      if (this.canUseCachedHistoryPlayerEventInfos(this.event)) {
        this.applyPlayerEventInfos(this.event.playerEventInfos);
      } else {
        this.fetchPlayerEventInfos(this.event);
      }
    }, () => this.openEventListAfterMissingMatch());
  }

  private openEventListAfterMissingMatch(): void {
    this.stopRealtime?.();
    this.stopRealtime = null;
    this.realtimePending = false;
    localStorage.removeItem("event");
    this.loading = false;
    this.spinner.hide();
    this.router.navigate(["/event-list"]);
  }

  private startRealtime(): void {
    if (this.stopRealtime || !this.event?.active || this.event.historyEvent) return;
    this.stopRealtime = this.realtime.subscribe(({ type, data }) => {
      if (type === "connected" || (data?.eventId === this.event?.id &&
        ["participants.changed", "event.updated", "event.deleted", "manager.announcement.changed"].includes(type))) {
        this.realtimeRevision++;
        this.realtimePending = true;
        this.ngDoCheck();
      }
    });
  }

  private realtimeBusy(): boolean {
    return this.loading || this.fetchPlayerEventInfosInProgress || this.responseSaving ||
      !!this.responseConfirmStatus || this.responseResetOpen || this.matchInfoSaving ||
      this.resultSaving || this.announcementOpen || this.announcementSaving || this.editMode || !!this.matchInfoEditorMode;
  }

  ngDoCheck(): void {
    if (this.destroyed || !this.realtimePending || this.realtimeReading || this.realtimeTimer || this.realtimeBusy()) return;
    // Coalesce bursts; defer updates while an editor or RSVP confirmation is open.
    this.realtimeTimer = setTimeout(() => {
      this.realtimeTimer = null;
      if (this.destroyed || this.realtimeBusy()) return;
      this.refreshFromRealtime();
    }, 150);
  }

  private refreshFromRealtime(): void {
    const eventId = this.event?.id;
    const playerId = this.currentPlayer?.id;
    const revision = this.realtimeRevision;
    const current = () => !this.destroyed && this.event?.id === eventId &&
      this.playerService.getCurrentPlayer()?.id === playerId;
    this.realtimePending = false;
    this.realtimeReading = true;
    this.eventService.getRichEvent(eventId).pipe(
      switchMap(event => forkJoin({
        chat: event.chat?.id ? this.chatService.getOptionalMatchChat(event.chat.id) : of(null)
      }).pipe(map(({chat}) => ({event, players: event.playerEventInfos || [], chat}))))
    ).subscribe(({ event, players, chat }) => {
      this.realtimeReading = false;
      if (!current()) return;
      if (revision !== this.realtimeRevision || this.realtimeBusy()) {
        this.realtimePending = true;
        this.ngDoCheck();
        return;
      }
      this.event = event;
      this.homeChat = chat;
      this.configureManagerView();
      this.applyPlayerEventInfos(players);
      localStorage.setItem("event", JSON.stringify(this.event));
    }, error => {
      this.realtimeReading = false;
      if (!current()) return;
      if (revision !== this.realtimeRevision) {
        this.realtimePending = true;
        this.ngDoCheck();
        return;
      }
      if ([403, 404].includes(error?.status)) this.openEventListAfterMissingMatch();
      // Transient failure keeps the last view; reconnect/next event retries.
    });
  }

  private viewHistory: ScreenViewHistory<any>;
  private readonly viewFields = ['matchInfoEditorMode', 'showRoster', 'memberRosterTab', 'memberRosterSearch',
    'returnToSettingsAfterMatchInfoEdit', 'returnToRosterAfterPlayerDetail', 'rulesReadOnly',
    'selectedPlayerDetailEventInfo', 'locationDetailPlaySpace', 'locationPickerView',
    'footballNetworkSource', 'inviteCandidateSearchText', 'inviteCandidatePlayers',
    'inactiveCleanupSummaryCount', 'inactiveCleanupSummaryEventId', 'memberRosterSearchOpen',
    'selectedPlayerListStatus', 'showPlayerListSearch', 'playerListSearchText', 'preparedBlockedPlayers',
    'guestPlayers', 'rulesDraft', 'ruleParagraphDrafts', 'rulesEnabledDraft', 'resultReturnMode'];

  private captureView(): any {
    const value: any = {scrollY: window.scrollY, event: this.event, inlineHistoryParentEvent: this.inlineHistoryParentEvent};
    [...this.viewFields, ...Object.keys(this).filter(key => /Draft|^inline|^selected(Date|Hour|Minute)$/.test(key))]
      .forEach(key => value[key] = this[key]);
    return value;
  }

  private initViewHistory(): void {
    this.viewHistory = new ScreenViewHistory(this._location, this.router,
      `${this.currentPlayer.id}:match:${this.event.id}`, () => this.captureView(), value => {
        this.cancelResultLoad();
        this.clearMatchInfoTransitionTimer();
        if (value.event && value.event.id !== this.event.id) this.event = value.event;
        this.inlineHistoryParentEvent = value.inlineHistoryParentEvent;
        Object.keys(value).filter(key => !["event", "scrollY", "inlineHistoryParentEvent"].includes(key))
          .forEach(key => this[key] = value[key]);
        this.matchInfoScreenEntering = false;
        this.matchInfoScreenExiting = false;
        this.matchInfoErrorMsg = null;
        requestAnimationFrame(() => window.scrollTo(0, value.scrollY || 0));
      });
  }

  public openConfigurationEditor(field: string): void {
    if (!this.canEditMatchInfo()) return;
    switch (field) {
      case 'time': this.openMatchTimeEditor(); break;
      case 'location': this.openMatchLocationEditor(); break;
      case 'maxPlayers': this.openMatchMaxPlayersEditor(); break;
      case 'occurrence': this.openMatchOccurrenceEditor(); break;
      case 'visibility': this.openMatchVisibilityEditor(); break;
      case 'seasons': this.openMatchSeasonsEditor(); break;
    }
    this.returnToSettingsAfterMatchInfoEdit = false;
  }

  private playerDetailRequest = 0;

  private setMatchInfoEditorMode(mode: MatchInfoEditorMode): void {
    this.cancelResultLoad();
    this.matchInfoSaved = false;
    const revision = ++this.playerDetailRequest;
    const player = this.selectedPlayerDetailEventInfo?.player;
    if (mode !== "playerDetail" || !player?.id || player.id === this.currentPlayer?.id || this.isGuestOrManagedProfile(player)) {
      if (player && mode === "playerDetail") player.canRate = false;
      this.activateMatchInfoEditorMode(mode);
      return;
    }
    this.spinner.show();
    forkJoin({
      capabilities: this.playerService.getDetailCapabilities(player.id),
      summary: this.statsService.getPlayerProfileSummary(player.id)
    }).subscribe({
      next: ({capabilities, summary}) => {
        this.spinner.hide();
        if (this.destroyed || revision !== this.playerDetailRequest) return;
        player.canRate = capabilities.canRate === true;
        player.profileStatsSummary = summary;
        this.activateMatchInfoEditorMode(mode);
      },
      error: () => {
        this.spinner.hide();
        if (this.destroyed || revision !== this.playerDetailRequest) return;
        this.dialogService.alert({title: this.translate.instant('common.alert'), text: this.translate.instant('errors.generic')});
      }
    });
  }

  private isGuestOrManagedProfile(player: Player): boolean {
    return !!(player.guest || player.managedPlayer || ['GUEST', 'MANAGED_PLAYER'].includes(player.playerType));
  }

  private activateMatchInfoEditorMode(mode: MatchInfoEditorMode): void {
    if (this.matchInfoEditorMode === mode && !this.matchInfoScreenExiting) {
      this.resetDocumentScroll();
      return;
    }

    this.viewHistory?.push({...this.captureView(), matchInfoEditorMode: mode, scrollY: 0});
    this.clearMatchInfoTransitionTimer();

    if (!this.matchInfoEditorMode) {
      this.matchInfoEditorMode = mode;
      this.matchInfoScreenExiting = false;
      this.startMatchInfoEnterTransition();
      this.resetDocumentScroll();
      return;
    }

    this.matchInfoScreenEntering = false;
    this.matchInfoScreenExiting = true;
    this.matchInfoTransitionTimer = window.setTimeout(() => {
      this.matchInfoEditorMode = mode;
      this.matchInfoScreenExiting = false;
      this.startMatchInfoEnterTransition();
      this.resetDocumentScroll();
      this.matchInfoTransitionTimer = null;
    }, this.screenTransitionMs);
  }

  private startMatchInfoEnterTransition(): void {
    this.matchInfoScreenEntering = !!this.matchInfoEditorMode;
    if (!this.matchInfoScreenEntering) {
      return;
    }

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => this.matchInfoScreenEntering = false);
    });
  }

  private clearMatchInfoTransitionTimer(): void {
    if (this.matchInfoTransitionTimer !== null) {
      window.clearTimeout(this.matchInfoTransitionTimer);
      this.matchInfoTransitionTimer = null;
    }
  }

  private resetDocumentScroll(): void {
    window.setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      window.requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
    }, 0);
  }

  private homeRosterPrepared = false;

  private applyHomeAction(): void {
    if (this.homeActionApplied) return;
    this.homeActionApplied = true;
    let request;
    try { request = JSON.parse(sessionStorage.getItem("matchHomeAction") || "null"); } catch { request = null; }
    sessionStorage.removeItem("matchHomeAction");
    if (request?.eventId === this.event.id) {
      if (request.action === 'players' && this.event.viewedByManager && this.homeRosterPrepared) this.setMatchInfoEditorMode('playerManagement');
      else this.overviewAction(request.action);
    }
  }

  public overviewAttendance(status: string): void {
    if (this.responseSaving || !this.canRespondToInvite(this.event) || this.event.currentPlayerInviteStatus === status) return;
    if (this.hasSavedInviteResponse(this.event)) {
      this.dialogService.alert({title: this.translate.instant('events.changeAnswer'), text: this.translate.instant(status === 'CONFIRMED' ? 'events.confirmComingPrompt' : 'events.confirmNotComingPrompt'), closeLabel: this.translate.instant('common.cancel'), actionLabel: this.translate.instant('events.changeResponse'), action: () => this.saveInviteResponse(this.event, status)});
    } else this.saveInviteResponse(this.event, status);
  }

  public overviewAction(action: string): void {
    if (action === "invited") { this.realtimeRevision++; this.realtimePending = true; this.ngDoCheck(); return; }
    if (action === "overview") { this.showRoster = false; this.setMatchInfoEditorMode(null); return; }
    if (action === "chat") {
      if (this.homeChat?.id) this.router.navigate(["/messages", {chatId: this.homeChat.id}]);
      return;
    }
    if (action === "players") { this.openOverviewRoster(); return; }
    if (action === "response") { this.showRoster = true; this.resetDocumentScroll(); return; }
    if (!this.event.viewedByManager) return;
    switch (action) {
      case "fill": this.openAddPlayersDialog(); break;
      case "settings": this.openSettingsPage(); break;
      case "time": this.openMatchTimeEditor(true); break;
      case "location": this.openMatchLocationEditor(true); break;
      case "balance": this.openBalanceTeamsPage(); break;
      case "changes": this.setMatchInfoEditorMode("changes"); break;
      case "discard":
        this.dialogService.alert({ title: this.translate.instant("events.incompleteSetupTitle"), text: this.translate.instant("events.deleteTeamCannotUndo"), closeLabel: this.translate.instant("common.cancel"), actionLabel: this.translate.instant("events.deleteTeam"), action: () => this.cancelIncompleteSetupMatch() });
        break;
    }
  }

  public openOverviewRoster(): void {
    if (this.event.viewedByManager && this.canUseLiveMatchActions(this.event)) {
      this.openPlayerManagementEditor(this.event);
      this.returnToSettingsAfterMatchInfoEdit = false;
    } else {
      this.setMatchInfoEditorMode(null);
      this.viewHistory?.push({...this.captureView(), showRoster: true, scrollY: 0});
      this.showRoster = true;
      this.resetDocumentScroll();
    }
  }

  public openMngPlayerDetail(playerEventInfo: PlayerEventInfo, event: Event) {
    localStorage.setItem("peiForPlayerDetail", JSON.stringify(playerEventInfo));
    localStorage.setItem("eventForPlayerDetail", JSON.stringify(event));

    this.selectedPlayerDetailEventInfo = playerEventInfo;
    this.setMatchInfoEditorMode("playerDetail");
  }

  public openManagerPlayerDetail(): void {
    const managerPlayerEventInfo = this.managerPlayerEventInfo();
    if (!managerPlayerEventInfo) {
      return;
    }

    const managerDetailInfo = Object.assign(new PlayerEventInfo(), managerPlayerEventInfo, {
      player: Object.assign({}, managerPlayerEventInfo.player, this.event.manager)
    });
    this.openMngPlayerDetail(managerDetailInfo, this.event);
  }

  public managerPlayerEventInfo(): PlayerEventInfo {
    if (!this.event || !this.event.manager || !this.event.playerEventInfos) {
      return null;
    }

    return this.event.playerEventInfos.find((playerEventInfo) =>
      playerEventInfo && playerEventInfo.player && playerEventInfo.player.id === this.event.manager.id
    );
  }

  public openAddPlayersDialog() {
    if (!this.canUseLiveMatchActions(this.event) && !this.canAddHistoryAttendees(this.event)) {
      return;
    }

    this.setMatchInfoEditorMode("addPlayers");
  }

  public openNotificationsPage(): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    this.showNotificationsSent = false;
    this.showNotifyDialog = false;
    this.showNotifyAllOpenProfiles = false;
    this.showNotifyTeammateOpenProfiles = false;
    this.setMatchInfoEditorMode("notifications");
  }

  public openBalanceTeamsPage(): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    this.balanceTeamsErrorMsg = null;
    if (!this.balanceTeamsResult) {
      this.showBalanceTeamsDetails = false;
    }
    this.setMatchInfoEditorMode("balanceTeams");
  }

  public balanceRosterChanged(players: PlayerEventInfo[]): void {
    this.applyPlayerEventInfos(players);
    localStorage.setItem('event', JSON.stringify(this.event));
  }

  public openSettingsPage(): void {
    this.matchInfoErrorMsg = null;
    this.setMatchInfoEditorMode("settings");
    if (this.event && this.event.viewedByManager) {
      this.loadInactiveCleanupSummary();
    }
  }

  private openRulebookFromNotificationIfNeeded(): void {
    if (!this.event || sessionStorage.getItem("openRulebookForEventId") !== this.event.id) {
      return;
    }

    sessionStorage.removeItem("openRulebookForEventId");
    this.openMatchRulesViewer();
  }

  public openAddPlayersPage(mode: "inviteNewUsers" | "inviteViaEmail" | "directInvite" | "footballNetwork" | "footballerFriends" | "openProfiles" | "nogoshPlayers" | "guestPlayers"): void {
    if (mode === 'inviteNewUsers') {
      if (this.event?.viewedByManager && this.canUseLiveMatchActions(this.event)) this.showNewNogoshUserDialog = true;
      return;
    }
    if (!this.canUseLiveMatchActions(this.event) && !this.canAddHistoryAttendees(this.event)) {
      return;
    }

    if (this.canAddHistoryAttendees(this.event) && mode !== "footballerFriends" && mode !== "guestPlayers") {
      return;
    }

    this.matchInfoErrorMsg = null;
    this.nogoshPlayersSearchErrorMsg = null;
    this.autocompleteSelectedPlayer = null;
    this.selectedPlayerHolder = null;
    this.selectedPlayers = [];
    this.inviteCandidateSearchText = "";
    this.inviteCandidatePlayers = [];
    this.nogoshPlayersAddSuccessMsg = null;
    this.typeaheadPlayerNoResults = false;
    this.directInviteSuccessMsg = null;
    this.directInviteErrorMsg = null;
    this.newUserInviteLinkErrorMsg = null;
    this.newUserInviteLinkCopiedMsg = null;
    this.emailInviteSuccessMsg = null;
    this.emailInviteErrorMsg = null;
    let preparation: Observable<unknown>;
    if (mode === 'footballNetwork' || mode === 'footballerFriends' || mode === 'nogoshPlayers' || mode === 'openProfiles') {
      this.footballNetworkSource = 'friends';
      preparation = this.getAddablePlayersForCurrentInviteScreen('', mode).pipe(map(players => {
        this.inviteCandidatePlayers = players || [];
        this.typeaheadPlayerNoResults = !this.inviteCandidatePlayers.length;
      }));
    } else if (mode === 'guestPlayers') {
      this.cancelGuestEdit();
      preparation = this.playerService.getGuestPlayers(this.event.id).pipe(map(players => {
        this.guestPlayers = (players || []).filter(player => this.canAddGuestToEvents(player));
      }));
    } else {
      this.setMatchInfoEditorMode(mode);
      return;
    }
    this.spinner.show();
    preparation.subscribe({
      next: () => { this.spinner.hide(); if (!this.destroyed) this.setMatchInfoEditorMode(mode); },
      error: () => { this.spinner.hide(); this.dialogService.alert({title: this.translate.instant('common.alert'), text: this.translate.instant('errors.generic')}); }
    });
  }

  public closeAddPlayersPage(): void {
    if (this.guestActionInProgress || this.loadingPlayersList || this.directInviteInProgress || this.emailInviteInProgress || this.newUserInviteLinkLoading) {
      return;
    }

    if (this.viewHistory?.back()) return;
    this.cancelGuestEdit();
    this.setMatchInfoEditorMode("addPlayers");
  }

  private configureManagerView(): void {
    if (this.event && this.event.manager && this.currentPlayer.id === this.event.manager.id) {
      this.event.viewedByManager = true;
      if (this.canUseLiveMatchActions(this.event)) {
        this.loadGuestPlayers();
      }
    }
  }

  public canUseLiveMatchActions(event: Event): boolean {
    return !!event && event.historyEvent !== true && event.active !== false && event.cancelled !== true;
  }

  public canAddHistoryAttendees(event: Event): boolean {
    return !!event && event.historyEvent === true && event.active === false && event.viewedByManager;
  }

  public openInactiveCleanupDialog(): void {
    if (!this.event || !this.event.viewedByManager || !this.canUseLiveMatchActions(this.event)) {
      return;
    }

    this.showInactiveCleanupDialog = true;
    this.showInactiveCleanupConfirm = false;
    this.inactiveCleanupWarningMsg = null;
    this.inactiveCleanupSuccessMsg = null;
    this.loadInactiveCleanupPlayers();
  }

  public closeInactiveCleanupDialog(): void {
    if (this.inactiveCleanupLoading || this.inactiveCleanupRemoving) {
      return;
    }

    this.showInactiveCleanupDialog = false;
    this.showInactiveCleanupConfirm = false;
    this.inactiveCleanupErrorMsg = null;
  }

  public loadInactiveCleanupPlayers(): void {
    if (!this.event || !this.event.viewedByManager || !this.canUseLiveMatchActions(this.event)) {
      return;
    }

    this.inactiveCleanupLoading = true;
    this.inactiveCleanupErrorMsg = null;
    this.inactiveCleanupWarningMsg = null;
    this.inactiveCleanupSuccessMsg = null;
    this.showInactiveCleanupConfirm = false;

    this.eventService.getInactivePlayersForCleanup(this.event.id, this.inactiveCleanupMonths).subscribe(
      (players) => {
        this.inactiveCleanupPlayers = players || [];
this.selectedInactivePlayerIds = {};
for (let player of this.inactiveCleanupPlayers) {
  this.selectedInactivePlayerIds[player.playerId] = true;
}
this.inactiveCleanupLoading = false;
      },
      (error) => {
        this.inactiveCleanupErrorMsg = this.getInactiveCleanupErrorMessage(error);
this.inactiveCleanupPlayers = [];
this.selectedInactivePlayerIds = {};
this.inactiveCleanupLoading = false;
      }
    );
  }

  public loadInactiveCleanupSummary(): void {
    if (!this.event || !this.event.id || !this.event.viewedByManager || !this.canUseLiveMatchActions(this.event)) {
      return;
    }

    if (this.inactiveCleanupSummaryEventId === this.event.id && this.inactiveCleanupSummaryCount !== null) {
      return;
    }

    this.inactiveCleanupSummaryLoading = true;
    this.eventService.getInactivePlayersForCleanup(this.event.id, 3).subscribe(
      (players) => {
        this.inactiveCleanupSummaryCount = (players || []).length;
        this.inactiveCleanupSummaryEventId = this.event.id;
        this.inactiveCleanupSummaryLoading = false;
      },
      () => {
        this.inactiveCleanupSummaryCount = null;
        this.inactiveCleanupSummaryEventId = this.event.id;
        this.inactiveCleanupSummaryLoading = false;
      }
    );
  }

  public getSelectedInactivePlayersCount(): number {
    return this.getSelectedInactivePlayerIds().length;
  }

  public areAllInactiveCleanupPlayersSelected(): boolean {
    return this.inactiveCleanupPlayers.length > 0 &&
      this.getSelectedInactivePlayersCount() === this.inactiveCleanupPlayers.length;
  }

  public toggleAllInactiveCleanupPlayers(selected: boolean): void {
    for (let player of this.inactiveCleanupPlayers) {
      this.selectedInactivePlayerIds[player.playerId] = selected;
    }
    this.showInactiveCleanupConfirm = false;
  }

  public inactiveCleanupSelectionChanged(): void {
    this.showInactiveCleanupConfirm = false;
    this.inactiveCleanupSuccessMsg = null;
    this.inactiveCleanupWarningMsg = null;
  }

  public confirmInactiveCleanupRemoval(): void {
    if (this.getSelectedInactivePlayersCount() === 0) {
      return;
    }

    this.showInactiveCleanupConfirm = true;
  }

  public removeSelectedInactivePlayers(): void {
    const playerIds = this.getSelectedInactivePlayerIds();
    if (!this.event || playerIds.length === 0 || this.inactiveCleanupRemoving) {
      return;
    }

    this.inactiveCleanupRemoving = true;
    this.inactiveCleanupErrorMsg = null;
    this.inactiveCleanupWarningMsg = null;
    this.inactiveCleanupSuccessMsg = null;

    this.eventService.removeInactivePlayers(this.event.id, playerIds).subscribe(
      (result) => {
        this.handleInactiveCleanupResult(result);
      },
      (error) => {
        this.inactiveCleanupErrorMsg = this.getInactiveCleanupErrorMessage(error);
this.inactiveCleanupRemoving = false;
      }
    );
  }

  private getSelectedInactivePlayerIds(): string[] {
    return Object.keys(this.selectedInactivePlayerIds).filter((playerId) => this.selectedInactivePlayerIds[playerId]);
  }

  private handleInactiveCleanupResult(result: RemoveInactivePlayersResult): void {
    const missingPlayerIds = result && result.missingPlayerIds ? result.missingPlayerIds : [];
    if (missingPlayerIds.length > 0) {
      this.inactiveCleanupWarningMsg = this.translate.instant('playerManagement.messages.playersMissing', { ids: missingPlayerIds.join(", ") });
    }

    const removedCount = result && result.removedCount ? result.removedCount : 0;
    const removedPlayerIds = result && result.removedPlayerIds ? result.removedPlayerIds : [];
    this.inactiveCleanupSuccessMsg = this.translate.instant('playerManagement.messages.playersRemoved', { count: removedCount });
    this.showInactiveCleanupConfirm = false;
    this.inactiveCleanupPlayers = this.inactiveCleanupPlayers.filter((player) => removedPlayerIds.indexOf(player.playerId) === -1);
    this.inactiveCleanupSummaryCount = this.inactiveCleanupPlayers.length;
    this.inactiveCleanupSummaryEventId = this.event.id;
    this.selectedInactivePlayerIds = {};
    for (let player of this.inactiveCleanupPlayers) {
      this.selectedInactivePlayerIds[player.playerId] = true;
    }

    this.eventService.getEvent(this.event.id).subscribe(
      (event) => {
        event.viewedByManager = true;
this.event = event;
this.fetchPlayerEventInfos(this.event);
this.inactiveCleanupRemoving = false;
      },
      (error) => {
        console.log(error);
        this.fetchPlayerEventInfos(this.event);
this.inactiveCleanupRemoving = false;
      }
    );
  }

  private getInactiveCleanupErrorMessage(error: any): string {
    if (error && error.status === 403) {
      return this.translate.instant('playerManagement.errors.cleanupInactiveManagerOnly');
    }
    if (error && error.status === 404) {
      return this.translate.instant('playerManagement.errors.matchNotFound');
    }
    if (error && error.status === 400) {
      return this.translate.instant('playerManagement.errors.invalidThreshold');
    }

    return this.getErrorMessage(error);
  }

  public notifyPlayers(event: Event, notifyMemberType: string): void {
    if (!this.canUseLiveMatchActions(event)) {
      return;
    }

    let me = this;
    const notifiedGroupLabel = this.getNotificationGroupLabel(notifyMemberType);

    event.sendingNotificationsInProgress = true;
    event.locationId = event.playSpace ? event.playSpace.id : event.locationId;
    if (event.playSpace) {
      event.playSpace.location = null;
    }

    me.eventService.notifyPlayers(event, notifyMemberType).subscribe(
      (res) => {
        setTimeout(() => {
          event.sendingNotificationsInProgress = false;

          me.playerEventInfoService.fetchForEvent(event.id).subscribe(
            (playerEventInfoList) => {
              event.playerEventInfos = Array<PlayerEventInfo>();

for (let playerEventInfo of playerEventInfoList) {
  event.playerEventInfos.push(playerEventInfo);
}
              this.refreshEventPlayerState();
            },
            (res) => {
              console.log(res.error);
            }
          );
        }, 2700);
        this.handleInvitationDispatchResult(res, notifiedGroupLabel);
      },
      (error) => {
        console.log("notifications error: " + error);
        event.sendingNotificationsInProgress = false;
me.spinner.hide();
me.loading = false;
      }
    );
  }

  public notifyPlayersWithNoResponse(event: Event): void {
    if (!this.canUseLiveMatchActions(event)) {
      return;
    }

    this.eventService.notifyNotAnsweredEventPlayers(event.id).subscribe(
      (result) => {
        this.loading = false;
this.spinner.hide();
this.refreshNotificationParticipants(event);
this.handleInvitationDispatchResult(result, this.translate.instant('notifications.remindInvited'));
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
this.loading = false;
      }
    );
  }

  public dialogNotifyPlayers(event: Event, notifyMemberType: string): void {
    if (!this.canUseLiveMatchActions(event)) {
      return;
    }

    this.notifyConfirmEvent = event;
    this.notifyConfirmMemberType = notifyMemberType;
    this.notifyConfirmGroupLabel = this.getNotificationGroupLabel(notifyMemberType);
    this.notifyConfirmNoResponse = false;
    this.showNotifyConfirmDialog = true;
  }

  public invitationEligibleCount(event: Event, notifyMemberType: string = null): number {
    return (event && event.playerEventInfos ? event.playerEventInfos : []).filter((participation) =>
      participation.status === this.playerEventInfoStatus.NOT_NOTIFIED
      && !participation.invitationSentAt
      && participation.teamMemberType !== this.teamMemberType.CANDIDATE
      && (!notifyMemberType || participation.teamMemberType === notifyMemberType)
      && !this.isGuestPlayer(participation.player)
      && participation.player && participation.player.active !== false
      && !!participation.player.email
    ).length;
  }

  public reminderEligibleCount(event: Event): number {
    return (event && event.playerEventInfos ? event.playerEventInfos : []).filter((participation) =>
      participation.status === this.playerEventInfoStatus.NOT_ANSWERED
      && !participation.reminderSentAt
      && participation.teamMemberType !== this.teamMemberType.CANDIDATE
      && !this.isGuestPlayer(participation.player)
      && participation.player && participation.player.active !== false
      && !!participation.player.email
    ).length;
  }

  public standardInvitationsExhausted(event: Event): boolean {
    return this.invitationEligibleCount(event) === 0 && this.reminderEligibleCount(event) === 0;
  }

  public dialogNotifyPlayersWithNoResponse(event: Event): void {
    if (!this.canUseLiveMatchActions(event)) {
      return;
    }

    this.notifyConfirmEvent = event;
    this.notifyConfirmMemberType = null;
    this.notifyConfirmGroupLabel = this.translate.instant('notifications.remindInvited');
    this.notifyConfirmNoResponse = true;
    this.showNotifyConfirmDialog = true;
  }

  public confirmNotifyPlayers(): void {
    const event = this.notifyConfirmEvent;
    const notifyMemberType = this.notifyConfirmMemberType;
    const notifyNoResponse = this.notifyConfirmNoResponse;

    this.showNotifyConfirmDialog = false;
    this.notifyConfirmEvent = null;
    this.notifyConfirmMemberType = null;
    this.notifyConfirmNoResponse = false;

    if (!event) {
      return;
    }

    if (notifyNoResponse) {
      this.notifyPlayersWithNoResponse(event);
    } else {
      this.notifyPlayers(event, notifyMemberType);
    }
  }

  public dialogNotifyAllOpenProfiles(event: Event): void {
    this.showNotifyAllOpenProfiles = true;
    this.notifyAllOpenProfilesEvent = event;
  }

  public dialogNotifyTeammateOpenProfiles(event: Event): void {
    this.showNotifyTeammateOpenProfiles = true;
    this.notifyTeammateOpenProfilesEvent = event;
  }

  public notifyAllOpenProfiles(): void {
    let event: Event = this.notifyAllOpenProfilesEvent;

    if (!this.canUseLiveMatchActions(event)) {
      return;
    }

    if (event.sosUsed) {
      this.showSosAlreadyUsedAlert();
    } else {
      this.spinner.show();
      this.loading = true;
      this.eventService.notifyAllOpenProfiles(event.id).subscribe(
        (updatedPc) => {
          this.loading = false;
this.spinner.hide();
          event.sosUsed = true;
          event.openToPublic = true;
this.markNotificationsSent(this.translate.instant('notifications.sosOther'));
        },
        (res) => {
          console.log(res.error);
          this.loading = false;
this.spinner.hide();
          if (res.status === 406) {
            event.sosUsed = true;
            this.showSosAlreadyUsedAlert();
          }
        }
      );
    }
  }

  public notifyTeammateOpenProfiles(): void {
    let me = this;
    let event: Event = me.notifyTeammateOpenProfilesEvent;

    if (!this.canUseLiveMatchActions(event)) {
      return;
    }

    if (event.teammateSosUsed) {
      this.showSosAlreadyUsedAlert();
      return;
    }

    me.loading = true;
    me.spinner.show();

    me.eventService.notifyTeammateOpenProfiles(event.id).subscribe(
      (updatedPc) => {
        me.loading = false;
me.spinner.hide();
        event.teammateSosUsed = true;
        event.openToPublic = true;
this.markNotificationsSent(this.translate.instant('notifications.sosContacts'));
      },
      (res) => {
        console.log(res.error);
        me.loading = false;
me.spinner.hide();
        if (res.status === 406) {
          event.teammateSosUsed = true;
          this.showSosAlreadyUsedAlert();
        }
      }
    );
  }

  private showSosAlreadyUsedAlert(): void {
    this.dialogService.alert({
      title: this.translate.instant('common.alert'),
      text: this.translate.instant('errors.sosAlreadyUsed')
    });
  }

  private markNotificationsSent(groupLabel: string): void {
	this.showNotificationLimitReached = false;
    this.notificationsSentGroupLabel = groupLabel;
    this.showNotificationsSent = true;
  }

  private handleInvitationDispatchResult(result: any, groupLabel: string): void {
    if (result && result.sentCount > 0) {
      this.markNotificationsSent(groupLabel);
      return;
    }
    this.showNotificationsSent = false;
    this.showNotificationLimitReached = true;
  }

  private refreshNotificationParticipants(event: Event): void {
    this.playerEventInfoService.fetchForEvent(event.id).subscribe((participations) => {
      event.playerEventInfos = participations || [];
      this.refreshEventPlayerState();
    });
  }

  private getNotificationGroupLabel(notifyMemberType: string): string {
    if (notifyMemberType === this.teamMemberType.FIRST_TEAM) {
      return this.translate.instant('notifications.firstTeam');
    }
    if (notifyMemberType === this.teamMemberType.RESERVE) {
      return this.translate.instant('notifications.reserves');
    }
    return this.translate.instant('notifications.allPlayers');
  }

  public sendFinalEmail(event: Event): void {
    let me = this;

    let recepient = "";

    let options = {
      bcc: function (playerEventInfoStatus: PlayerEventInfoStatus, event: Event) {
        let bcc = "";
        for (let pei of event.playerEventInfos) {
          if (pei.status === playerEventInfoStatus.CONFIRMED && pei.player.email) {
            bcc += pei.player.email + ";";
          }
        }

        return bcc;
      },

      subject: event.name + " at " + this.formatEmailDate(event.nextOccurrenceTimestamp) + ". Teams are: ",
      body: "Hi,\nThis is an email pre-populated from angular-mailto.",
    };

    me.sendFinalEmailHref = "mailto:" + recepient + "?" + "bcc=" + options.bcc(me.playerEventInfoStatus, event) + "&subject=" + options.subject + "&body=" + options.body;
  }

  private formatEmailDate(value: string | Date): string {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return String(value || "");
    }

    return new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit"
    }).format(date);
  }

  public openMap(): void {
    if (!this.hasPrecisePlaySpaceLocation()) {
      this.navigateHref = "";
      return;
    }

    if (navigator.platform.indexOf("iPhone") != -1 || navigator.platform.indexOf("iPod") != -1 || navigator.platform.indexOf("iPad") != -1) {
      this.navigateHref = "http://maps.apple.com/?q=" + this.event.playSpace.latitude + "," + this.event.playSpace.longitude;
    } else {
      this.navigateHref = "https://maps.google.com/maps?daddr=" + this.event.playSpace.latitude + "," + this.event.playSpace.longitude + "&amp;ll=";
    }
  }

  public viewEvent(event: Event): void {
    localStorage.setItem("event", JSON.stringify(event));
    this.analytics.track("match_viewed", {
      screen: "match_players",
      entityType: "event",
      entityId: event && event.id
    });
    this.router.navigate(["/event-detail", false]);
  }

  public openMatchManagerEditor(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.returnToSettingsAfterMatchInfoEdit = true;
    this.matchInfoErrorMsg = null;
    this.selectedManagerDraft = null;
    this.managerSearchText = "";
    this.setMatchInfoEditorMode("manager");
  }

  public openMatchSeasonsEditor(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.returnToSettingsAfterMatchInfoEdit = true;
    this.matchInfoErrorMsg = null;
    this.seasonModeDraft = this.eventSeasonMode();
    this.seasonStartDateDrafts = this.eventSeasonStartDatesDrafts();
    this.season1StartDraft = this.seasonStartDateDrafts[0] || this.defaultSeasonStart(0);
    this.season2StartDraft = this.seasonStartDateDrafts[1] || this.defaultSeasonStart(6);
    this.setMatchInfoEditorMode("seasons");
  }

  public setSeasonModeDraft(mode: "YEARLY" | "INFINITE" | "CUSTOM"): void {
    this.seasonModeDraft = mode;
    if (mode === "CUSTOM" && this.seasonStartDateDrafts.length < 2) {
      this.seasonStartDateDrafts = [this.defaultSeasonStart(0), this.defaultSeasonStart(6)];
    }
  }

  public addSeasonStartDraft(): void {
    if (this.seasonStartDateDrafts.length >= 12) {
      return;
    }

    const nextMonth = (this.seasonStartDateDrafts.length * 3) % 12;
    this.seasonStartDateDrafts = this.seasonStartDateDrafts.concat([this.defaultSeasonStart(nextMonth)]);
  }

  public removeSeasonStartDraft(index: number): void {
    if (this.seasonStartDateDrafts.length <= 2) {
      return;
    }

    this.seasonStartDateDrafts = this.seasonStartDateDrafts.filter((_date, dateIndex) => dateIndex !== index);
  }

  public openMatchMaxPlayersEditor(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.returnToSettingsAfterMatchInfoEdit = true;
    this.matchInfoErrorMsg = null;
    this.maxPlayersDraft = this.event && this.event.maxPlayers ? this.event.maxPlayers : null;
    this.setMatchInfoEditorMode("maxPlayers");
  }

  public openMatchOccurrenceEditor(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.returnToSettingsAfterMatchInfoEdit = true;
    this.matchInfoErrorMsg = null;
    this.recurringTypeDraft = this.event && this.event.recurringType ? this.event.recurringType : "ONE_OFF";
    this.setMatchInfoEditorMode("occurrence");
  }

  public openMatchRulesEditor(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.returnToSettingsAfterMatchInfoEdit = true;
    this.matchInfoErrorMsg = null;
    this.rulesDraft = this.event && this.event.rulebook ? this.event.rulebook : "";
    this.ruleParagraphDrafts = this.rulebookToParagraphs(this.rulesDraft);
    this.rulesReadOnly = false;
    this.rulesEnabledDraft = this.ruleParagraphDrafts.length > 0;
    this.setMatchInfoEditorMode("rules");
  }

  public openMatchVisibilityEditor(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.returnToSettingsAfterMatchInfoEdit = true;
    this.matchInfoErrorMsg = null;
    this.visibilityOpenDraft = this.event && this.event.openToPublic === true;
    this.setMatchInfoEditorMode("visibility");
  }

  public openMatchRulesViewer(): void {
    this.returnToSettingsAfterMatchInfoEdit = false;
    this.matchInfoErrorMsg = null;
    this.rulesReadOnly = true;
    this.rulesDraft = this.event && this.event.rulebook ? this.event.rulebook : "";
    this.ruleParagraphDrafts = this.rulebookToParagraphs(this.rulesDraft);
    this.rulesEnabledDraft = this.ruleParagraphDrafts.length > 0;
    this.setMatchInfoEditorMode("rules");
  }

  public eventPlayers(event: Event): void {
    event.historyEvent = true;
    localStorage.setItem("event", JSON.stringify(event));

    if (this.router.url && this.router.url.indexOf("/event-players") === 0) {
      this.openEventPlayersInPlace(event);
      return;
    }

    this.router.navigate(["/event-players", false]);
  }

  private openEventPlayersInPlace(event: Event): void {
    if (this.matchInfoEditorMode === "history" && this.event && this.event.historyEvent !== true) {
      this.inlineHistoryParentEvent = this.event;
    }

    this.loading = true;
    this.eventPlayersReady$.next(false);
    this.setMatchInfoEditorMode(null);
    this.selectedPlayerDetailEventInfo = null;
    this.editMode = false;
    this.event = event;
    this.configureManagerView();
    this.applyReturnedPlaySpaceIfPresent();
    this.loadHistoryGameResults(event);

    if (this.canUseCachedHistoryPlayerEventInfos(event)) {
      this.applyPlayerEventInfos(event.playerEventInfos);
    } else {
      this.fetchPlayerEventInfos(event);
    }

    window.scrollTo(0, 0);
  }

  public openMatchTimeEditor(returnToSettings: boolean = false): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.returnToSettingsAfterMatchInfoEdit = returnToSettings;
    this.matchInfoErrorMsg = null;
    const occurrence = this.event && this.event.nextOccurrenceTimestamp
      ? new Date(this.event.nextOccurrenceTimestamp)
      : new Date();
    this.selectedDate = occurrence;
    this.selectedHour = occurrence.getHours();
    this.selectedMinute = occurrence.getMinutes();
    this.setMatchInfoEditorMode("time");
  }

  public openMatchNameEditor(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.matchInfoErrorMsg = null;
    this.matchNameDraft = this.event && this.event.name ? this.event.name : "";
    this.setMatchInfoEditorMode("name");
  }

  public handleMatchTitleClick(): void {
    if (this.matchInfoEditorMode) {
      if (this.matchInfoEditorMode === "playerDetail") {
        this.selectedPlayerDetailEventInfo = null;
      }
      this.setMatchInfoEditorMode(null);
      this.matchInfoErrorMsg = null;
      return;
    }

    this.openMatchNameEditor();
  }

  public matchScreenTitle(): string {
    if (this.showRoster && !this.event?.viewedByManager && !this.event?.historyEvent && !this.matchInfoEditorMode) {
      return this.translate.instant('events.players');
    }
    if (this.locationDetailPlaySpace && this.locationDetailPlaySpace.name) {
      return this.locationDetailPlaySpace.name;
    }

    return this.event && this.event.name ? this.event.name : "";
  }

  public isMatchTitleActionable(): boolean {
    return !this.locationDetailPlaySpace && (!!this.matchInfoEditorMode || this.canEditMatchInfo());
  }

  public handleMatchScreenBack(): void {
    if (this.showHelp) {
      this.showHelp = false;
      return;
    }

    if (this.locationDetailPlaySpace) {
      this.closeMatchLocationDetail();
      return;
    }

    if (this.matchInfoEditorMode) {
      this.closeMatchInfoEditor();
      return;
    }

    if (this.viewHistory) {
      if (!this.viewHistory.back()) this.goBack();
      return;
    }
    if (this.showRoster && !this.event.historyEvent) { this.showRoster = false; return; }
    this.goBack();
  }

  public openMatchLocationEditor(returnToSettings: boolean = false): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.returnToSettingsAfterMatchInfoEdit = returnToSettings;
    this.matchInfoErrorMsg = null;
    this.locationEditorMode = "existing";
    this.locationPickerView = "list";
    this.locationDetailPlaySpace = null;
    this.selectedExistingPlaySpace = this.event && this.event.playSpace ? this.event.playSpace : null;
    this.locationNameSelected = !!this.selectedExistingPlaySpace;
    this.locationRemovedDraft = false;
    this.autocompletePlayspace = this.eventLocationValue();
    this.setMatchInfoEditorMode("location");
    this.refreshNearbyPlaySpaceMapState();

    this.loadNearbyPlaySpaces();
  }

  public selectLocationEditorMode(mode: "name" | "existing"): void {
    if (mode === "existing" && !this.canSelectExistingLocations()) {
      this.locationEditorMode = "existing";
      this.selectedExistingPlaySpace = null;
      this.locationNameSelected = false;
      this.autocompletePlayspace = "";
      this.matchInfoErrorMsg = null;
      this.typeaheadLocationNoResults = false;
      this.typeaheadLocationLoading = false;
      return;
    }

    this.locationEditorMode = mode;
    this.matchInfoErrorMsg = null;
    this.locationRemovedDraft = false;
    this.typeaheadLocationNoResults = false;
    this.typeaheadLocationLoading = false;

    if (mode === "name") {
      this.selectedExistingPlaySpace = null;
      this.locationNameSelected = false;
      this.autocompletePlayspace = this.event && this.event.playSpace ? "" : this.eventLocationValue();
      return;
    }

    this.selectedExistingPlaySpace = this.event && this.event.playSpace ? this.event.playSpace : null;
    this.locationNameSelected = !!this.selectedExistingPlaySpace;
    this.autocompletePlayspace = this.selectedExistingPlaySpace && this.selectedExistingPlaySpace.name ? this.selectedExistingPlaySpace.name : "";
    this.refreshNearbyPlaySpaceMapState();
    this.loadNearbyPlaySpaces();
  }

  public createNewMapLocation(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    localStorage.setItem("event", JSON.stringify(this.event));
    sessionStorage.setItem("playspaceReturnRoute", "/event-players/false");
    this.router.navigate(["/playspace", true]);
  }

  public setLocationPickerView(view: "list" | "map"): void {
    this.locationPickerView = view;
    this.loadNearbyPlaySpaces();
  }

  public canSelectExistingLocations(): boolean {
    const location = this.currentPlayer && this.currentPlayer.location;
    const coordinates = location && location.coordinates;
    return !!this.currentPlayer && !!this.currentPlayer.city && Array.isArray(coordinates) &&
      coordinates.length >= 2 &&
      isFinite(Number(coordinates[0])) &&
      isFinite(Number(coordinates[1]));
  }

  public currentPlayerCityLabel(): string {
    return (this.currentPlayer && this.currentPlayer.city) ||
      (this.currentPlayer && this.currentPlayer.locationInfo && this.currentPlayer.locationInfo.city) ||
      "";
  }

  public selectExistingPlaySpace(playSpace: PlaySpace): void {
    if (!playSpace) {
      return;
    }

    this.closeLocationInfoWindows();
    this.locationNameSelected = true;
    this.locationRemovedDraft = false;
    this.selectedExistingPlaySpace = playSpace;
    this.autocompletePlayspace = playSpace.name || "";
    this.typeaheadLocationNoResults = false;
    this.refreshNearbyPlaySpaceMapState();
  }

  public openMatchLocationDetail(playSpace: PlaySpace): void {
    if (!playSpace) {
      return;
    }

    this.closeLocationInfoWindows();
    this.locationDetailPlaySpace = playSpace;
    const coordinates = this.playSpaceCoordinates(playSpace);
    this.locationDetailMarkerPositionCache = coordinates ? { lat: coordinates.latitude, lng: coordinates.longitude } : null;
    this.locationDetailMapOptionsCache = {
      mapId: environment.GOOGLE_MAPS_MAP_ID,
      center: this.locationDetailMarkerPositionCache || this.nearbyLocationsMapOptionsCache.center as google.maps.LatLngLiteral,
      zoom: 15,
      clickableIcons: false,
      streetViewControl: false,
      mapTypeControl: false
    };
  }

  public closeMatchLocationDetail(): void {
    this.locationDetailPlaySpace = null;
  }

  public useLocationDetailPlaySpace(): void {
    if (!this.locationDetailPlaySpace) {
      return;
    }

    this.selectExistingPlaySpace(this.locationDetailPlaySpace);
    this.locationDetailPlaySpace = null;
  }

  public playSpaceAddressLine(playSpace: PlaySpace): string {
    return playSpace && playSpace.address ? playSpace.address.trim() : "";
  }

  public playSpaceDetailLine(playSpace: PlaySpace): string {
    if (!playSpace) {
      return "";
    }

    return playSpace.address ? playSpace.address.trim() : "";
  }

  public hasPlaySpaceText(value: string): boolean {
    return !!(value || "").trim();
  }

  public visibleNearbyPlaySpaces(): PlaySpace[] {
    const query = (this.autocompletePlayspace || "").trim().toLowerCase();
    const playSpaces = this.locatedNearbyPlaySpacesCache || [];
    if (!query || this.locationNameSelected) {
      return playSpaces;
    }

    return playSpaces.filter((playSpace) => {
      const searchable = [
        playSpace && playSpace.name,
        playSpace && playSpace.address,
        playSpace && playSpace.city
      ].filter(Boolean).join(" ").toLowerCase();
      return searchable.indexOf(query) > -1;
    });
  }

  public shouldShowLocationNameOnlyOption(): boolean {
    return !!(this.autocompletePlayspace || "").trim() && !this.selectedExistingPlaySpace;
  }

  public shouldShowMatchLocationClearDraft(): boolean {
    return !this.locationRemovedDraft &&
      (!!this.selectedExistingPlaySpace || !!(this.autocompletePlayspace || "").trim());
  }

  public selectExistingPlaySpaceFromMap(playSpace: PlaySpace, marker: MapAdvancedMarker, markerNo: number): void {
    this.closeLocationInfoWindows();
    const infoWindow = this.locationInfoWindows.get(markerNo);
    if (infoWindow) {
      infoWindow.open(marker);
    }
  }

  private closeLocationInfoWindows(): void {
    if (!this.locationInfoWindows) {
      return;
    }

    this.locationInfoWindows.forEach((infoWindow) => infoWindow.close());
  }

  public isSelectedExistingPlaySpace(playSpace: PlaySpace): boolean {
    return !!playSpace && !!this.selectedExistingPlaySpace &&
      ((!!playSpace.id && playSpace.id === this.selectedExistingPlaySpace.id) ||
        (!!playSpace.name && playSpace.name === this.selectedExistingPlaySpace.name));
  }

  public shouldShowNearbyPlaySpaces(): boolean {
    return this.locationEditorMode === "existing" && this.canSelectExistingLocations();
  }

  public locatedNearbyPlaySpaces(): PlaySpace[] {
    return this.locatedNearbyPlaySpacesCache;
  }

  public nearbyLocationsMapOptions(): google.maps.MapOptions {
    return this.nearbyLocationsMapOptionsCache;
  }

  public playSpaceMapPosition(playSpace: PlaySpace): google.maps.LatLngLiteral {
    const markerState = this.nearbyLocationMarkerCache[this.playSpaceCacheKey(playSpace)];
    return markerState ? markerState.position : null;
  }

  public locationMarkerOptions(playSpace: PlaySpace): google.maps.marker.AdvancedMarkerElementOptions {
    const markerState = this.nearbyLocationMarkerCache[this.playSpaceCacheKey(playSpace)];
    return markerState ? markerState.options : null;
  }

  public hasPlaySpaceLocation(playSpace: PlaySpace): boolean {
    return this.playSpaceCoordinates(playSpace) !== null;
  }

  public bindLocationMarkerClick(marker: MapAdvancedMarker, advancedMarker: google.maps.marker.AdvancedMarkerElement, playSpace: PlaySpace, markerNo: number): void {
    if (this.boundLocationMarkers.has(advancedMarker)) {
      return;
    }

    this.boundLocationMarkers.add(advancedMarker);
    advancedMarker.addEventListener("gmp-click", () => this.selectExistingPlaySpaceFromMap(playSpace, marker, markerNo));
  }

  public bindLocationDetailMarkerClick(advancedMarker: google.maps.marker.AdvancedMarkerElement, playSpace: PlaySpace): void {
    if (this.boundLocationMarkers.has(advancedMarker)) {
      return;
    }

    this.boundLocationMarkers.add(advancedMarker);
    advancedMarker.addEventListener("gmp-click", () => this.openMatchLocationDetail(playSpace));
  }

  private nearbyLocationsMapCenter(): google.maps.LatLngLiteral {
    const selectedCoordinates = this.playSpaceCoordinates(this.selectedExistingPlaySpace);
    if (selectedCoordinates) {
      return { lat: selectedCoordinates.latitude, lng: selectedCoordinates.longitude };
    }

    const locatedPlaySpaces = (this.nearbyPlaySpaces || [])
      .map((playSpace) => this.playSpaceCoordinates(playSpace))
      .filter((coordinates) => coordinates !== null);

    if (locatedPlaySpaces.length > 0) {
      const totals = locatedPlaySpaces.reduce((result, coordinates) => {
        result.latitude += coordinates.latitude;
        result.longitude += coordinates.longitude;
        return result;
      }, { latitude: 0, longitude: 0 });

      return {
        lat: totals.latitude / locatedPlaySpaces.length,
        lng: totals.longitude / locatedPlaySpaces.length
      };
    }

    const playerCoordinates = this.currentPlayer && this.currentPlayer.location && this.currentPlayer.location.coordinates;
    if (Array.isArray(playerCoordinates) && playerCoordinates.length >= 2) {
      return {
        lat: Number(playerCoordinates[0]),
        lng: Number(playerCoordinates[1])
      };
    }

    return { lat: 45.815, lng: 15.9819 };
  }

  private refreshNearbyPlaySpaceMapState(): void {
    this.locatedNearbyPlaySpacesCache = (this.nearbyPlaySpaces || []).filter((playSpace) => this.hasPlaySpaceLocation(playSpace));
    this.nearbyLocationsMapOptionsCache = {
      mapId: environment.GOOGLE_MAPS_MAP_ID,
      center: this.nearbyLocationsMapCenter(),
      zoom: 12,
      clickableIcons: false,
      streetViewControl: false,
      mapTypeControl: false
    };

    const markerCache: {[key: string]: {position: google.maps.LatLngLiteral, options: google.maps.marker.AdvancedMarkerElementOptions}} = {};
    this.locatedNearbyPlaySpacesCache.forEach((playSpace) => {
      const coordinates = this.playSpaceCoordinates(playSpace);
      if (!coordinates) {
        return;
      }

      markerCache[this.playSpaceCacheKey(playSpace)] = {
        position: {
          lat: coordinates.latitude,
          lng: coordinates.longitude
        },
        options: {
          gmpClickable: true,
          content: this.locationMarkerContent(this.isSelectedExistingPlaySpace(playSpace)),
          zIndex: this.isSelectedExistingPlaySpace(playSpace) ? 1000 : 1
        }
      };
    });
    this.nearbyLocationMarkerCache = markerCache;
  }

  private locationMarkerContent(selected: boolean): HTMLElement {
    if (google && google.maps && google.maps.marker && google.maps.marker.PinElement) {
      return new google.maps.marker.PinElement({
        scale: selected ? 1.35 : 1
      }).element;
    }

    const fallback = document.createElement("span");
    fallback.className = selected ? "match-location-map-pin match-location-map-pin-selected" : "match-location-map-pin";
    return fallback;
  }

  private playSpaceCacheKey(playSpace: PlaySpace): string {
    if (!playSpace) {
      return "";
    }

    const coordinates = this.playSpaceCoordinates(playSpace);
    return [
      playSpace.id || "",
      playSpace.name || "",
      coordinates ? coordinates.latitude : "",
      coordinates ? coordinates.longitude : ""
    ].join("|");
  }

  private playSpaceCoordinates(playSpace: PlaySpace): {latitude: number, longitude: number} | null {
    if (!playSpace) {
      return null;
    }

    const latitude = Number(playSpace.latitude);
    const longitude = Number(playSpace.longitude);
    if (isFinite(latitude) && isFinite(longitude)) {
      return { latitude, longitude };
    }

    const geoJsonCoordinates = playSpace.location && playSpace.location.coordinates;
    if (Array.isArray(geoJsonCoordinates) && geoJsonCoordinates.length >= 2) {
      const geoJsonLongitude = Number(geoJsonCoordinates[0]);
      const geoJsonLatitude = Number(geoJsonCoordinates[1]);
      if (isFinite(geoJsonLatitude) && isFinite(geoJsonLongitude)) {
        return { latitude: geoJsonLatitude, longitude: geoJsonLongitude };
      }
    }

    return null;
  }

  private loadNearbyPlaySpaces(): void {
    if (!this.canSelectExistingLocations() || this.nearbyPlaySpacesLoading || this.nearbyPlaySpacesLoaded) {
      return;
    }

    this.nearbyPlaySpacesLoading = true;
    this.nearbyPlaySpacesError = false;

    this.playSpaceService.getCurrentLocations().subscribe(
      (playSpaces) => {
        this.nearbyPlaySpaces = (playSpaces || []).slice().sort((a, b) => (a.name || "").localeCompare(b.name || ""));
this.refreshNearbyPlaySpaceMapState();
this.nearbyPlaySpacesLoading = false;
this.nearbyPlaySpacesLoaded = true;
      },
      () => {
        this.nearbyPlaySpaces = [];
this.refreshNearbyPlaySpaceMapState();
this.nearbyPlaySpacesLoading = false;
this.nearbyPlaySpacesLoaded = true;
this.nearbyPlaySpacesError = true;
      }
    );
  }

  public closeMatchInfoEditor(): void {
    if (this.matchInfoSaving) {
      return;
    }
    this.cancelResultLoad();

    if (this.matchInfoEditorMode === "guestPlayers" && this.selectedGuestForEdit) {
      this.closeGuestDetail();
      return;
    }

    if (this.viewHistory) {
      if (!this.viewHistory.back()) this.goBack();
      return;
    }

    if (this.matchInfoEditorMode === "playerManagement" && this.playerManagementListChanged) {
      this.fetchPlayerEventInfos(this.event);
      this.playerManagementListChanged = false;
    }

    if (this.matchInfoEditorMode === "inviteViaEmail" || this.matchInfoEditorMode === "footballNetwork" || this.matchInfoEditorMode === "inviteNewUsers" || this.matchInfoEditorMode === "directInvite" || this.matchInfoEditorMode === "footballerFriends"
      || this.matchInfoEditorMode === "openProfiles" || this.matchInfoEditorMode === "nogoshPlayers" || this.matchInfoEditorMode === "guestPlayers") {
      this.closeAddPlayersPage();
      return;
    }

    if (this.matchInfoEditorMode === "playerDetail") {
      this.selectedPlayerDetailEventInfo = null;
      if (this.returnToRosterAfterPlayerDetail) {
        this.returnToRosterAfterPlayerDetail = false;
        this.openOverviewRoster();
        return;
      }
    }

    if (this.matchInfoEditorMode === "rules") {
      this.rulesReadOnly = false;
    }

    if (this.returnToSettingsAfterMatchInfoEdit) {
      this.setMatchInfoEditorMode("settings");
      this.returnToSettingsAfterMatchInfoEdit = false;
    } else {
      this.setMatchInfoEditorMode(null);
    }
    this.matchInfoErrorMsg = null;
  }

  public matchInfoSaved = false;

  private completeMatchInfoSave(): void {
    this.matchInfoErrorMsg = null;
    this.matchInfoSaved = true;
  }

  public saveMatchName(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const name = (this.matchNameDraft || "").trim();
    if (!name) {
      this.matchInfoErrorMsg = this.translate.instant("validation.matchName");
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.name = name;
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public saveMatchTime(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.nextOccurrenceTimestamp = this.buildSelectedOccurrence();
    updatedEvent.nextOccurrenceTimestampZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public clearMatchTime(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.nextOccurrenceTimestamp = null;
    updatedEvent.nextOccurrenceTimestampZone = null;
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public saveMatchLocation(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    if (this.locationRemovedDraft) {
      updatedEvent.playSpace = null;
      updatedEvent.locationName = null;
      updatedEvent.locationId = null;
    } else if (this.selectedExistingPlaySpace) {
      updatedEvent.playSpace = this.selectedExistingPlaySpace;
      updatedEvent.locationName = this.selectedExistingPlaySpace && this.selectedExistingPlaySpace.name ? this.selectedExistingPlaySpace.name : null;
      updatedEvent.locationId = this.selectedExistingPlaySpace && this.selectedExistingPlaySpace.id ? this.selectedExistingPlaySpace.id : null;
    } else {
      updatedEvent.playSpace = null;
      updatedEvent.locationName = (this.autocompletePlayspace || "").trim() || null;
      updatedEvent.locationId = null;
    }
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public clearMatchLocation(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.locationName = null;
    updatedEvent.locationId = null;
    updatedEvent.playSpace = null;
    this.autocompletePlayspace = "";
    this.selectedExistingPlaySpace = null;
    this.locationNameSelected = false;
    this.locationEditorMode = "name";
    this.refreshNearbyPlaySpaceMapState();
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public removeMatchLocationDraft(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    this.autocompletePlayspace = "";
    this.selectedExistingPlaySpace = null;
    this.locationNameSelected = false;
    this.locationRemovedDraft = true;
    this.locationDetailPlaySpace = null;
    this.typeaheadLocationNoResults = false;
    this.typeaheadLocationLoading = false;
    this.matchInfoErrorMsg = null;
    this.refreshNearbyPlaySpaceMapState();
  }

  public onMatchLocationSearchChanged(): void {
    this.locationRemovedDraft = false;
    if (!this.selectedExistingPlaySpace) {
      this.locationNameSelected = false;
      return;
    }

    const selectedName = (this.selectedExistingPlaySpace.name || "").trim();
    const currentValue = (this.autocompletePlayspace || "").trim();
    if (selectedName !== currentValue) {
      this.selectedExistingPlaySpace = null;
      this.locationNameSelected = false;
      this.refreshNearbyPlaySpaceMapState();
    }
  }

  public typeaheadManagerSelected(selectedObject: any): void {
    this.selectedManagerDraft = selectedObject.item;
    this.managerSearchText = this.selectedManagerDraft ? this.selectedManagerDraft.name || this.selectedManagerDraft.nickName || "" : "";
    this.matchInfoErrorMsg = null;
  }

  public managerCandidateEventInfos(): PlayerEventInfo[] {
    const seenPlayerIds: {[playerId: string]: boolean} = {};
    const query = (this.managerSearchText || "").trim().toLowerCase();
    return (this.event && this.event.playerEventInfos ? this.event.playerEventInfos : []).filter((playerEventInfo) => {
      const player = playerEventInfo && playerEventInfo.player;
      if (!player || !player.id || this.isGuestPlayer(player) || player.active === false || seenPlayerIds[player.id]) {
        return false;
      }

      seenPlayerIds[player.id] = true;
      if (query) {
        const searchable = [
          player.nickName,
          player.name,
          player.email,
          player.phoneNumber
        ].filter(Boolean).join(" ").toLowerCase();
        if (searchable.indexOf(query) === -1) {
          return false;
        }
      }

      return true;
    });
  }

  public selectManagerCandidate(player: Player): void {
    if (!player || !player.id || this.isGuestPlayer(player)) {
      return;
    }

    this.selectedManagerDraft = player;
    this.matchInfoErrorMsg = null;
  }

  public isSelectedManagerCandidate(playerEventInfo: PlayerEventInfo): boolean {
    return !!playerEventInfo && !!playerEventInfo.player && !!this.selectedManagerDraft &&
      playerEventInfo.player.id === this.selectedManagerDraft.id;
  }

  public clearManagerSearch(): void {
    this.managerSearchText = "";
  }

  public currentManagerDisplayName(): string {
    return this.event && this.event.manager
      ? this.event.manager.nickName || this.event.manager.name || this.translate.instant("events.managerNotSet")
      : this.translate.instant("events.managerNotSet");
  }

  public selectedManagerDraftDisplayName(): string {
    return this.selectedManagerDraft
      ? this.selectedManagerDraft.nickName || this.selectedManagerDraft.name || ""
      : "";
  }

  public selectedManagerDraftIsCurrentManager(): boolean {
    return !!this.selectedManagerDraft && !!this.event && !!this.event.manager &&
      this.selectedManagerDraft.id === this.event.manager.id;
  }

  public saveMatchManager(): void {
    if (!this.canEditMatchInfo() || !this.selectedManagerDraft || !this.selectedManagerDraft.id) {
      this.matchInfoErrorMsg = this.translate.instant("validation.selectManager");
      return;
    }

    this.matchInfoSaving = true;
    this.matchInfoSaved = false;
    this.matchInfoErrorMsg = null;
    this.eventService.changeManager(this.event.id, this.selectedManagerDraft.id).subscribe(
      () => {
        this.event.manager = this.selectedManagerDraft;
this.event.viewedByManager = this.currentPlayer && this.event.manager && this.currentPlayer.id === this.event.manager.id;
localStorage.setItem("event", JSON.stringify(this.event));
this.matchInfoSaving = false;
this.returnToSettingsAfterMatchInfoEdit = false;
this.completeMatchInfoSave();
      },
      (response) => {
        this.matchInfoErrorMsg = this.getErrorMessage(response);
this.matchInfoSaving = false;
      }
    );
  }

  public saveMatchSeasons(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    const customSeasonStarts = this.normalizedSeasonStartDateDrafts();
    if (this.seasonModeDraft === "CUSTOM" && customSeasonStarts.length < 2) {
      this.matchInfoErrorMsg = this.translate.instant("events.seasonCustomMinimum");
      return;
    }
    updatedEvent.seasonMode = this.seasonModeDraft;
    updatedEvent.seasonStartDates = this.seasonModeDraft === "CUSTOM" ? customSeasonStarts : [];
    updatedEvent.season1StartDate = this.seasonModeDraft === "CUSTOM" ? customSeasonStarts[0] : null;
    updatedEvent.season2StartDate = this.seasonModeDraft === "CUSTOM" ? customSeasonStarts[1] : null;
    this.saveFullMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  private eventHasCustomSeasons(): boolean {
    return this.eventSeasonMode() === "CUSTOM";
  }

  private eventSeasonMode(): "YEARLY" | "INFINITE" | "CUSTOM" {
    if (this.event && (this.event.seasonMode === "YEARLY" || this.event.seasonMode === "INFINITE" || this.event.seasonMode === "CUSTOM")) {
      return this.event.seasonMode;
    }
    return this.event && this.event.season1StartDate && this.event.season2StartDate ? "CUSTOM" : "YEARLY";
  }

  private eventSeasonStartDatesDrafts(): Date[] {
    const starts = this.event && this.event.seasonStartDates && this.event.seasonStartDates.length > 0
      ? this.event.seasonStartDates
      : this.event && this.event.season1StartDate && this.event.season2StartDate
        ? [this.event.season1StartDate, this.event.season2StartDate]
        : [this.defaultSeasonStart(0), this.defaultSeasonStart(6)];

    return starts
      .filter((date) => !!date)
      .map((date) => new Date(date));
  }

  private normalizedSeasonStartDateDrafts(): Date[] {
    const startsByMonthDay = new Map<string, Date>();
    this.seasonStartDateDrafts
      .filter((date) => !!date)
      .forEach((date) => {
        const normalizedDate = new Date(date);
        const key = `${normalizedDate.getMonth()}-${normalizedDate.getDate()}`;
        startsByMonthDay.set(key, normalizedDate);
      });

    return Array.from(startsByMonthDay.values())
      .sort((firstDate, secondDate) => firstDate.getMonth() === secondDate.getMonth()
        ? firstDate.getDate() - secondDate.getDate()
        : firstDate.getMonth() - secondDate.getMonth());
  }

  private defaultSeasonStart(month: number): Date {
    const eventDate = this.event && this.event.nextOccurrenceTimestamp
      ? new Date(this.event.nextOccurrenceTimestamp)
      : new Date();
    return new Date(eventDate.getFullYear(), month, 1);
  }

  public saveMatchMaxPlayers(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const maxPlayers = Number(this.maxPlayersDraft);
    if (!Number.isFinite(maxPlayers) || maxPlayers <= 0) {
      this.matchInfoErrorMsg = this.translate.instant("validation.maxPlayers");
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.maxPlayers = Math.floor(maxPlayers);
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public adjustMaxPlayers(delta: number): void {
    const currentValue = Number(this.maxPlayersDraft);
    const nextValue = Number.isFinite(currentValue) ? currentValue + delta : 1;
    this.maxPlayersDraft = Math.max(1, Math.floor(nextValue));
    this.matchInfoErrorMsg = null;
  }

  public setMaxPlayersDraft(maxPlayers: number): void {
    if (!Number.isFinite(maxPlayers) || maxPlayers <= 0) {
      return;
    }

    this.maxPlayersDraft = Math.floor(maxPlayers);
    this.matchInfoErrorMsg = null;
  }

  public setRecurringTypeDraft(recurringType: string): void {
    if (!this.recurringTypeOptions.some((option) => option.value === recurringType)) {
      return;
    }

    this.recurringTypeDraft = recurringType;
    this.matchInfoErrorMsg = null;
  }

  public saveMatchOccurrence(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    if (!this.recurringTypeOptions.some((option) => option.value === this.recurringTypeDraft)) {
      this.matchInfoErrorMsg = this.translate.instant("events.occurrenceRequired");
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.recurringType = this.recurringTypeDraft;
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public saveMatchRules(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.rulebook = this.rulesEnabledDraft ? this.ruleParagraphsToRulebook() : "";
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public setVisibilityOpenDraft(open: boolean): void {
    this.visibilityOpenDraft = open;
    this.matchInfoErrorMsg = null;
  }

  public saveMatchVisibility(): void {
    if (!this.canEditMatchInfo()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.openToPublic = this.visibilityOpenDraft === true;
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  public enableRulebookDraft(): void {
    this.rulesEnabledDraft = true;
    if (this.ruleParagraphDrafts.length === 0) {
      this.ruleParagraphDrafts = [""];
    }
    this.matchInfoErrorMsg = null;
  }

  public disableRulebookDraft(): void {
    this.rulesEnabledDraft = false;
    this.matchInfoErrorMsg = null;
  }

  public addRuleParagraph(index: number = this.ruleParagraphDrafts.length - 1): void {
    const insertIndex = Math.max(0, Math.min(index + 1, this.ruleParagraphDrafts.length));
    this.ruleParagraphDrafts.splice(insertIndex, 0, "");
    this.matchInfoErrorMsg = null;
  }

  public removeRuleParagraph(index: number): void {
    if (this.ruleParagraphDrafts.length <= 1) {
      this.ruleParagraphDrafts = [""];
      return;
    }

    this.ruleParagraphDrafts.splice(index, 1);
    this.matchInfoErrorMsg = null;
  }

  public trackRuleParagraph(index: number): number {
    return index;
  }

  private rulebookToParagraphs(rulebook: string): string[] {
    return (rulebook || "")
      .split(/\n\s*\n/g)
      .map((paragraph) => paragraph.trim())
      .filter((paragraph) => paragraph.length > 0);
  }

  private ruleParagraphsToRulebook(): string {
    return (this.ruleParagraphDrafts || [])
      .map((paragraph) => (paragraph || "").trim())
      .filter((paragraph) => paragraph.length > 0)
      .join("\n\n");
  }

  public openDeleteMatchDialog(): void {
    this.deleteMatchErrorMsg = null;
    this.showDeleteMatchDialog = true;
  }

  public openCancelMatchEditor(): void {
    if (!this.event || !this.event.viewedByManager || !this.canUseLiveMatchActions(this.event)) {
      return;
    }

    this.cancelMatchReason = "";
    this.cancelMatchErrorMsg = null;
    this.setMatchInfoEditorMode("cancelMatch");
  }

  public cancelMatch(): void {
    if (!this.event || !this.event.viewedByManager || !this.canUseLiveMatchActions(this.event) || this.cancelMatchInProgress) {
      return;
    }

    this.cancelMatchInProgress = true;
    this.cancelMatchErrorMsg = null;
    this.eventService.cancelEvent(this.event.id, (this.cancelMatchReason || "").trim()).subscribe(
      (event) => {
        this.event = this.mergeRichEventUpdate(event, this.event);
        this.event.viewedByManager = true;
        localStorage.setItem("event", JSON.stringify(this.event));
        this.cancelMatchInProgress = false;
        this.setMatchInfoEditorMode(null);
      },
      (response) => {
        this.cancelMatchErrorMsg = this.getErrorMessage(response);
        this.cancelMatchInProgress = false;
      }
    );
  }

  public uncancelMatch(): void {
    if (!this.event || !this.event.viewedByManager || this.event.cancelled !== true || this.uncancelMatchInProgress) {
      return;
    }

    this.uncancelMatchInProgress = true;
    this.uncancelMatchErrorMsg = null;
    this.eventService.uncancelEvent(this.event.id).subscribe(
      (event) => {
        this.event = this.mergeRichEventUpdate(event, this.event);
        this.event.viewedByManager = true;
        localStorage.setItem("event", JSON.stringify(this.event));
        this.uncancelMatchInProgress = false;
        this.setMatchInfoEditorMode(null);
      },
      (response) => {
        this.uncancelMatchErrorMsg = this.getErrorMessage(response);
        this.uncancelMatchInProgress = false;
      }
    );
  }

  public cancelledMatchDescription(): string {
    if (!this.event || !this.event.cancelled) {
      return "";
    }

    return this.event.cancelReason
      ? this.event.cancelReason
      : this.translate.instant("events.cancelMatchDefaultReason");
  }

  public deleteMatchSeries(): void {
    if (!this.event || !this.event.viewedByManager || this.deleteMatchLoading) {
      return;
    }

    this.deleteMatchLoading = true;
    this.deleteMatchErrorMsg = null;
    this.eventService.removeManagedEventSeries(this.event.id).subscribe(
      () => {
        localStorage.removeItem("event");
this.deleteMatchLoading = false;
this.showDeleteMatchDialog = false;
this.router.navigate(["/event-list"]);
      },
      (response) => {
        this.deleteMatchErrorMsg = this.getErrorMessage(response);
this.deleteMatchLoading = false;
      }
    );
  }

  public cancelIncompleteSetupMatch(): void {
    if (!this.showIncompleteSetupNotice() || this.deleteMatchLoading || this.matchInfoSaving) {
      return;
    }

    this.deleteMatchLoading = true;
    this.matchInfoErrorMsg = null;
    this.eventService.removeManagedEventSeries(this.event.id).subscribe(
      () => {
        localStorage.removeItem("event");
        this.deleteMatchLoading = false;
        this.router.navigate(["/event-list"]);
      },
      (response) => {
        this.matchInfoErrorMsg = this.getErrorMessage(response);
        this.deleteMatchLoading = false;
      }
    );
  }

  public hasPrecisePlaySpaceLocation(): boolean {
    return !!this.event && !!this.event.playSpace &&
      this.event.playSpace.latitude !== null && this.event.playSpace.latitude !== undefined &&
      this.event.playSpace.longitude !== null && this.event.playSpace.longitude !== undefined &&
      isFinite(Number(this.event.playSpace.latitude)) && isFinite(Number(this.event.playSpace.longitude));
  }

  public eventLocationLabel(): string {
    if (this.event && this.event.playSpace && this.event.playSpace.name) {
      return this.event.playSpace.address
        ? `${this.event.playSpace.name}, ${this.event.playSpace.address}`
        : this.event.playSpace.name;
    }

    return this.event && this.event.locationName ? this.event.locationName : this.translate.instant("events.locationTbd");
  }

  public matchSettingsLocationStatus(): string {
    return this.eventLocationLabel();
  }

  public matchSettingsMaxPlayersStatus(): string {
    const maxPlayers = this.event && Number(this.event.maxPlayers);
    if (!Number.isFinite(maxPlayers) || maxPlayers <= 0) {
      return this.translate.instant("events.maxPlayersNotSet");
    }

    return `${Math.floor(maxPlayers)} ${this.translate.instant("events.players")}`;
  }

  public matchSettingsOccurrenceStatus(): string {
    const recurringType = this.event && this.event.recurringType ? this.event.recurringType : "ONE_OFF";
    const option = this.recurringTypeOptions.find(item => item.value === recurringType || (recurringType === "ONCE" && item.value === "ONE_OFF"));
    return option ? this.translate.instant(option.labelKey) : recurringType;
  }

  public matchSettingsRulesStatus(): string {
    return this.hasEnabledRulebook(this.event)
      ? this.translate.instant("events.rulesAdded")
      : this.translate.instant("events.rulesNotSet");
  }

  public matchRulesIntroCopyKey(): string {
    if (this.rulesReadOnly) {
      return this.rulesEnabledDraft ? "events.rulesReadOnlyIntroCopy" : "events.rulesReadOnlyEmptyCopy";
    }

    if (!this.rulesEnabledDraft) {
      return "events.rulesEmptyIntroCopy";
    }

    return this.hasEnabledRulebook(this.event) ? "events.rulesDefinedIntroCopy" : "events.rulesEditIntroCopy";
  }

  public shouldShowMatchRulesSave(): boolean {
    if (this.rulesReadOnly) {
      return false;
    }

    return this.rulesEnabledDraft || this.hasEnabledRulebook(this.event);
  }

  public matchSettingsVisibilityStatus(): string {
    return this.event && this.event.openToPublic === true
      ? this.translate.instant("events.openMatch")
      : this.translate.instant("events.visibilityClosedTitle");
  }

  public matchSettingsManagerStatus(): string {
    if (!this.event || !this.event.manager) {
      return this.translate.instant("events.managerNotSet");
    }

    return this.event.manager.nickName || this.event.manager.name || this.translate.instant("events.managerNotSet");
  }

  public matchSettingsSeasonsStatus(): string {
    const seasonMode = this.eventSeasonMode();
    switch (seasonMode) {
      case "INFINITE":
        return this.translate.instant("events.seasonModeInfinite");
      case "CUSTOM":
        return this.translate.instant("events.seasonModeCustom");
      case "YEARLY":
      default:
        return this.translate.instant("events.seasonModeYearly");
    }
  }

  public matchSettingsPlayersStatus(): string {
    if (this.inactiveCleanupSummaryLoading) {
      return this.translate.instant("playerManagement.noShowsChecking");
    }

    if (this.inactiveCleanupSummaryCount === null || this.inactiveCleanupSummaryEventId !== (this.event && this.event.id)) {
      return this.translate.instant("playerManagement.noShowsUnavailable");
    }

    if (this.inactiveCleanupSummaryCount === 0) {
      return this.translate.instant("playerManagement.noShowsNone");
    }

    return `${this.inactiveCleanupSummaryCount} ${this.translate.instant("playerManagement.noShowsSuffix")}`;
  }

  public hasMatchTime(): boolean {
    return !!(this.event && this.event.nextOccurrenceTimestamp);
  }

  public isMatchWithinNextWeek(): boolean {
    if (!this.event || !this.event.nextOccurrenceTimestamp) {
      return false;
    }

    const matchTime = new Date(this.event.nextOccurrenceTimestamp).getTime();
    if (!isFinite(matchTime)) {
      return false;
    }

    const now = Date.now();
    const oneWeekFromNow = now + (7 * 24 * 60 * 60 * 1000);
    return matchTime >= now && matchTime <= oneWeekFromNow;
  }

  public canEditMatchInfo(): boolean {
    return !!this.event && this.event.viewedByManager && this.canUseLiveMatchActions(this.event);
  }

  public canShowSettingsButton(event: Event): boolean {
    return !!event && (
      (event.viewedByManager && this.canUseLiveMatchActions(event)) ||
      (event.viewedByManager && event.cancelled === true) ||
      this.canUsePlayerSettings(event)
    );
  }

  public canUsePlayerSettings(event: Event): boolean {
    const playerEventInfo = this.getCurrentPlayerEventInfo(event);
    return !!event &&
      !event.viewedByManager &&
      this.canUseLiveMatchActions(event) &&
      !!playerEventInfo;
  }

  public isCurrentPlayerInEvent(event: Event): boolean {
    return !!event && !!event.playerEventInfos && event.playerEventInfos.some((playerEventInfo) => this.isCurrentPlayerEventInfo(playerEventInfo));
  }

  public isCurrentPlayerPendingTeamInvite(event: Event): boolean {
    if (!this.canUsePlayerSettings(event)) {
      return false;
    }

    const playerEventInfo = this.getCurrentPlayerEventInfo(event);
    return !!playerEventInfo &&
      playerEventInfo.status === this.playerEventInfoStatus.NOT_ANSWERED &&
      playerEventInfo.source === this.playerEventInfoSource.INVITE;
  }

  public leaveTeamActionKey(event: Event): string {
    return this.isCurrentPlayerPendingTeamInvite(event) ? "events.declineTeamInvite" : "events.leaveTeam";
  }

  public leaveTeamConfirmTitleKey(event: Event): string {
    return this.isCurrentPlayerPendingTeamInvite(event) ? "events.declineTeamInviteConfirmTitle" : "events.leaveTeam";
  }

  public leaveTeamConfirmDescriptionKey(event: Event): string {
    return this.isCurrentPlayerPendingTeamInvite(event) ? "events.declineTeamInviteConfirmDescription" : "events.leaveTeamConfirmDescription";
  }

  public openLeaveTeamDialog(event: Event): void {
    if (!this.canUsePlayerSettings(event) || this.leaveTeamInProgress) {
      return;
    }

    this.responseConfirmStatus = null;
    this.responseResetOpen = false;
    this.showLeaveTeamDialog = true;
  }

  public canViewStatsAndHistory(event: Event): boolean {
    return !!event && (event.viewedByManager || event.viewedByPlayer);
  }

  public hasEnabledRulebook(event: Event): boolean {
    return !!event && !!event.rulebook && event.rulebook.trim().length > 0;
  }

  public openStats(event): void {
    this.spinner.show();
    this.inlineStatsErrorMsg = null;
    this.activeStatsMetric = "playerScore";
    this.activeStatsPeriod = "season";
    this.loadInlineStats(event);
  }

  public openHistory(event: Event): void {
    this.inlineHistoryParentEvent = event;
    this.spinner.show();
    this.inlineHistoryPage = 0;
    this.inlineHistoryEvents = [];
    this.inlineHistoryErrorMsg = null;
    this.loadInlineHistory(event);
  }

  public openPlayerManagement(event: Event): void {
    if (!event || !event.viewedByManager || !this.canUseLiveMatchActions(event)) {
      return;
    }

    this.router.navigate(["/event-player-management", event.id]);
  }

  public recruitmentSaving = false;
  public recruitmentError = '';
  public recruitmentSent = false;

  public campaignUnavailableKey(campaign: RecruitmentCampaign): string {
    return ({SETUP_REQUIRED: 'events.managerLaunchCampaignSetupRequired', LOCATION_REQUIRED: 'events.managerLaunchCampaignLocationRequired', TIME_REQUIRED: 'events.managerLaunchCampaignTimeRequired', NO_ELIGIBLE_RECIPIENTS: 'events.managerLaunchCampaignNoEligible', TEAM_ALREADY_STARTED: 'events.managerLaunchCampaignTeamStarted', MATCH_FULL: 'events.managerTeamFull'})[campaign?.unavailableReason] || 'events.managerLaunchCampaignUnavailable';
  }

  public confirmRecruitment(): void {
    if (this.recruitmentSaving || !this.event.viewedByManager) return;
    this.recruitmentSaving = true;
    this.recruitmentError = '';
    this.spinner.show();
    this.eventService.getRecruitmentCampaign(this.event.id).subscribe({
      next: campaign => {
        this.spinner.hide();
        this.recruitmentSaving = false;
        this.event.managerHome.launchCampaign = campaign;
        if (campaign.status !== 'AVAILABLE') return;
        this.dialogService.alert({
          title: this.translate.instant('events.managerLaunchCampaignConfirmTitle'),
          text: this.translate.instant('events.managerLaunchCampaignConfirmCountMessage', {count: campaign.eligibleRecipientCount || 0}),
          closeLabel: this.translate.instant('common.cancel'), actionLabel: this.translate.instant('events.managerLaunchCampaignAction'),
          action: () => {
            this.recruitmentSaving = true;
            this.eventService.launchRecruitmentCampaign(this.event.id).subscribe({
              next: result => { this.event.managerHome.launchCampaign = result; this.recruitmentSaving = false; this.recruitmentSent = true; },
              error: () => { this.recruitmentSaving = false; this.recruitmentError = this.translate.instant('errors.generic'); }
            });
          }
        });
      },
      error: () => { this.spinner.hide(); this.recruitmentSaving = false; this.recruitmentError = this.translate.instant('errors.generic'); }
    });
  }

  public homeChat: Chat;
  public announcementText = '';
  public announcementSaving = false;
  public announcementOpen = false;
  public announcementError = '';

  public confirmAnnouncement(): void {
    const text = this.announcementText.trim();
    if (!this.event.viewedByManager || !this.homeChat?.id || !text || text.length > 500 || this.announcementSaving) return;
    this.dialogService.alert({
      title: this.translate.instant('events.managerAnnouncementConfirmTitle'),
      text: this.translate.instant('events.managerAnnouncementConfirmMessage'),
      closeLabel: this.translate.instant('common.cancel'), actionLabel: this.translate.instant('events.managerAnnouncementAction'),
      action: () => {
        this.announcementSaving = true;
        this.announcementError = '';
        this.chatService.sendManagerAnnouncement(this.homeChat.id, text).subscribe({
          next: message => { this.homeChat.managerAnnouncement = message; this.announcementSaving = false; this.announcementOpen = false; this.announcementText = ''; },
          error: error => { this.announcementSaving = false; this.announcementError = this.translate.instant(error?.status === 429 ? 'events.managerAnnouncementTooSoon' : 'errors.generic'); }
        });
      }
    });
  }

  public removeAnnouncement(): void {
    if (!this.event.viewedByManager || !this.homeChat?.id || this.announcementSaving) return;
    this.dialogService.alert({
      title: this.translate.instant('events.managerAnnouncementRemove'), text: this.homeChat.managerAnnouncement?.text,
      closeLabel: this.translate.instant('common.cancel'), actionLabel: this.translate.instant('events.managerAnnouncementRemove'),
      action: () => {
        this.announcementSaving = true;
        this.chatService.removeManagerAnnouncement(this.homeChat.id).subscribe({
          next: () => { this.homeChat.managerAnnouncement = null; this.announcementSaving = false; },
          error: () => { this.announcementSaving = false; this.dialogService.alert({title: this.translate.instant('common.alert'), text: this.translate.instant('errors.generic')}); }
        });
      }
    });
  }

  public changesSaving = false;
  public acknowledgeImportantChanges(): void {
    if (this.changesSaving || !this.event.viewedByManager) return;
    const ids = (this.event.managerHome?.importantChanges || []).map(change => change.id).filter(Boolean);
    if (!ids.length) { this.closeMatchInfoEditor(); return; }
    this.changesSaving = true;
    this.playerService.markClientNotificationsRead(ids).subscribe({
      next: () => {
        this.changesSaving = false;
        this.event.managerHome.importantChanges = [];
        this.clientNotifications.refresh();
        this.closeMatchInfoEditor();
      },
      error: () => { this.changesSaving = false; this.dialogService.alert({title: this.translate.instant('common.alert'), text: this.translate.instant('errors.generic')}); }
    });
  }

  public importantChangeText(change: {type: string, playerName?: string}): string {
    const key = change.type === 'managerPlayerReturned' ? 'managerPlayerReturned' : change.type === 'managerJoinRequest' ? 'managerPlayerRequestedJoin' : 'managerPlayerCancelled';
    return this.translate.instant('events.' + key, {player: change.playerName || ''});
  }

  public preparedBlockedPlayers: EventPlayerBlock[] = [];

  public openPlayerManagementEditor(event: Event): void {
    if (!event || !event.viewedByManager || !this.canUseLiveMatchActions(event)) {
      return;
    }

    this.matchInfoErrorMsg = null;
    this.playerManagementListChanged = false;
    this.returnToSettingsAfterMatchInfoEdit = true;
    this.spinner.show();
    forkJoin({players: this.playerEventInfoService.fetchForEvent(event.id), blocked: this.eventService.getBlockedPlayers(event.id)}).subscribe({
      next: ({players, blocked}) => {
        this.spinner.hide();
        if (this.destroyed) return;
        this.applyPlayerEventInfos(players);
        this.preparedBlockedPlayers = blocked || [];
        this.setMatchInfoEditorMode("playerManagement");
      },
      error: () => { this.spinner.hide(); this.dialogService.alert({title: this.translate.instant('common.alert'), text: this.translate.instant('errors.generic')}); }
    });
  }

  public handlePlayerManagementListChanged(players: PlayerEventInfo[]): void {
    this.applyPlayerEventInfos(players);
    this.realtimePending = true;
  }

  private returnToRosterAfterPlayerDetail = false;
  public openRosterPlayer(player: PlayerEventInfo): void {
    this.returnToRosterAfterPlayerDetail = true;
    this.openMngPlayerDetail(player, this.event);
  }

  public leaveEvent(event: Event): void {
    if (this.leaveTeamInProgress || !this.canUsePlayerSettings(event)) {
      return;
    }

    if (!event.playerEventInfos.some((playerEventInfo) => playerEventInfo.player.id === this.currentPlayer.id)) {
      return;
    }

    this.showLeaveTeamDialog = false;
    this.leaveTeamInProgress = true;
    this.loading = true;
    this.spinner.show();
    this.eventService.requestToLeaveEvent(event, this.currentPlayer).subscribe(
      () => {
        this.spinner.hide();
        this.loading = false;
        this.leaveTeamInProgress = false;
        this.router.navigate(["/event-list"]);
      },
      (res) => {
        console.log(res.error);
        this.spinner.hide();
        this.loading = false;
        this.leaveTeamInProgress = false;
      }
    );
  }

  public respondToInvite(event: Event, status: string): void {
    if (this.responseSaving || !this.canRespondToInvite(event)) {
      return;
    }

    this.responseError = false;
    this.lastFailedInviteStatus = null;

    if (event.currentPlayerInviteStatus === status) {
      this.responseConfirmStatus = null;
      this.clearResponseFeedbackTimer();
      this.responseFeedbackStatus = null;
      this.responseResetOpen = true;
      return;
    }

    this.responseResetOpen = false;

    if (this.hasSavedInviteResponse(event) && event.currentPlayerInviteStatus !== status) {
      this.responseConfirmStatus = status;
      return;
    }

    this.saveInviteResponse(event, status);
  }

  public confirmInviteResponseChange(event: Event): void {
    if (!this.responseConfirmStatus || this.responseSaving || !this.canRespondToInvite(event)) {
      return;
    }

    this.saveInviteResponse(event, this.responseConfirmStatus);
  }

  public cancelInviteResponseChange(): void {
    this.responseConfirmStatus = null;
  }

  public resetInviteResponse(event: Event): void {
    if (!this.responseResetOpen || this.responseSaving || !this.canRespondToInvite(event)) {
      return;
    }

    this.saveInviteResponse(event, this.playerEventInfoStatus.NOT_ANSWERED);
  }

  public cancelInviteResponseReset(): void {
    this.responseResetOpen = false;
  }

  public changeSavedInviteResponse(event: Event): void {
    const displayedStatus = this.inviteResponseStatusToDisplay(event);
    if (!displayedStatus || this.responseSaving || !this.canRespondToInvite(event)) {
      return;
    }

    const nextStatus = displayedStatus === this.playerEventInfoStatus.CONFIRMED
      ? this.playerEventInfoStatus.DECLINED
      : this.playerEventInfoStatus.CONFIRMED;

    this.clearResponseFeedbackTimer();
    this.responseFeedbackStatus = null;
    this.respondToInvite(event, nextStatus);
  }

  public retryInviteResponse(event: Event): void {
    if (!this.lastFailedInviteStatus || this.responseSaving || !this.canRespondToInvite(event)) {
      return;
    }

    this.saveInviteResponse(event, this.lastFailedInviteStatus);
  }

  public selectPlayerListStatus(status: string): void {
    this.selectedPlayerListStatus = status;
  }

  public togglePlayerListSearch(): void {
    this.showPlayerListSearch = !this.showPlayerListSearch;
    if (this.showPlayerListSearch) {
      this.selectNextPopulatedPlayerListStatusIfCurrentIsEmpty();
    } else {
      this.playerListSearchText = "";
    }
  }

  public clearPlayerListSearch(): void {
    this.playerListSearchText = "";
  }

  public playerListCount(status: string): number {
    return this.getPlayerEventInfosForStatus(status).length;
  }

  public filteredPlayerListCount(status: string): number {
    return this.filterPlayerEventInfos(this.getPlayerEventInfosForStatus(status)).length;
  }

  public getPlayerEventInfosForStatus(status: string): PlayerEventInfo[] {
    if (!this.event || !this.event.playerEventInfos) {
      return [];
    }

    return this.event.playerEventInfos.filter((playerEventInfo) => {
      if (playerEventInfo.status !== status) {
        return false;
      }

      return status === this.playerEventInfoStatus.CONFIRMED ||
        playerEventInfo.teamMemberType !== this.teamMemberType.CANDIDATE;
    });
  }

  private selectNextPopulatedPlayerListStatusIfCurrentIsEmpty(): void {
    if (this.playerListCount(this.selectedPlayerListStatus) > 0) {
      return;
    }

    const statuses = [
      this.playerEventInfoStatus.CONFIRMED,
      this.playerEventInfoStatus.DECLINED,
      this.playerEventInfoStatus.NOT_ANSWERED,
      this.playerEventInfoStatus.NOT_NOTIFIED
    ];
    const selectedStatusIndex = statuses.indexOf(this.selectedPlayerListStatus);
    const startIndex = selectedStatusIndex > -1 ? selectedStatusIndex : 0;

    for (let offset = 1; offset < statuses.length; offset++) {
      const candidateStatus = statuses[(startIndex + offset) % statuses.length];
      if (this.playerListCount(candidateStatus) > 0) {
        this.selectedPlayerListStatus = candidateStatus;
        return;
      }
    }
  }

  public visiblePlayerEventInfos(playerEventInfos: PlayerEventInfo[], status: string): PlayerEventInfo[] {
    const visiblePlayerEventInfos = (playerEventInfos || []).filter((playerEventInfo) => {
      return status === this.playerEventInfoStatus.CONFIRMED ||
        playerEventInfo.teamMemberType !== this.teamMemberType.CANDIDATE;
    });

    return this.filterPlayerEventInfos(visiblePlayerEventInfos);
  }

  public visiblePlayerEventInfosForDisplay(playerEventInfos: PlayerEventInfo[], status: string): PlayerEventInfo[] {
    const visiblePlayerEventInfos = this.visiblePlayerEventInfos(playerEventInfos, status).slice();
    return visiblePlayerEventInfos.sort((a, b) => {
      const teamOrderDifference = status === this.playerEventInfoStatus.CONFIRMED
        ? this.jerseyDisplayOrder(a.jersey) - this.jerseyDisplayOrder(b.jersey)
        : this.teamMemberDisplayOrder(a.teamMemberType) - this.teamMemberDisplayOrder(b.teamMemberType);
      if (teamOrderDifference !== 0) {
        return teamOrderDifference;
      }

      const firstNickname = a.player && a.player.nickName ? a.player.nickName : "";
      const secondNickname = b.player && b.player.nickName ? b.player.nickName : "";
      return firstNickname.localeCompare(secondNickname);
    });
  }

  private teamMemberDisplayOrder(teamMemberType: string): number {
    if (teamMemberType === this.teamMemberType.FIRST_TEAM) {
      return 0;
    }
    if (teamMemberType === this.teamMemberType.RESERVE) {
      return 1;
    }
    return 2;
  }

  private jerseyDisplayOrder(jersey: string): number {
    if (jersey === this.playerEventInfoJersey.WHITE) {
      return 0;
    }
    if (jersey === this.playerEventInfoJersey.BLACK) {
      return 1;
    }
    return 2;
  }

  public confirmedTeamsAreDivided(playerEventInfos: PlayerEventInfo[]): boolean {
    const confirmedPlayerEventInfos = (playerEventInfos || []).filter((playerEventInfo) =>
      playerEventInfo && playerEventInfo.status === this.playerEventInfoStatus.CONFIRMED);
    return confirmedPlayerEventInfos.some((playerEventInfo) => playerEventInfo.jersey === this.playerEventInfoJersey.WHITE) &&
      confirmedPlayerEventInfos.some((playerEventInfo) => playerEventInfo.jersey === this.playerEventInfoJersey.BLACK);
  }

  public playerTeamMemberLabel(playerEventInfo: PlayerEventInfo): string {
    if (!playerEventInfo) {
      return "";
    }
    if (playerEventInfo.teamMemberType === this.teamMemberType.FIRST_TEAM) {
      return this.translate.instant("notifications.firstTeam");
    }
    if (playerEventInfo.teamMemberType === this.teamMemberType.RESERVE) {
      return this.translate.instant("players.reserve");
    }
    return "";
  }

  public playerJerseyLabel(playerEventInfo: PlayerEventInfo): string {
    if (!playerEventInfo) {
      return "";
    }
    if (playerEventInfo.jersey === this.playerEventInfoJersey.WHITE) {
      return this.translate.instant("events.whiteTeam");
    }
    if (playerEventInfo.jersey === this.playerEventInfoJersey.BLACK) {
      return this.translate.instant("events.blackTeam");
    }
    return "";
  }

  public isFirstTeamPlayer(playerEventInfo: PlayerEventInfo): boolean {
    return !!playerEventInfo && playerEventInfo.teamMemberType === this.teamMemberType.FIRST_TEAM;
  }

  public hasFirstTeamPlayers(playerEventInfos: PlayerEventInfo[], status: string): boolean {
    return this.visiblePlayerEventInfosForDisplay(playerEventInfos, status).some((playerEventInfo) =>
      this.isFirstTeamPlayer(playerEventInfo));
  }

  public isReservePlayer(playerEventInfo: PlayerEventInfo): boolean {
    return !!playerEventInfo && playerEventInfo.teamMemberType === this.teamMemberType.RESERVE;
  }

  public isManagerPlayer(playerEventInfo: PlayerEventInfo): boolean {
    return !!playerEventInfo && !!playerEventInfo.player && !!this.event && !!this.event.manager &&
      playerEventInfo.player.id === this.event.manager.id;
  }

  public isWhiteTeamPlayer(playerEventInfo: PlayerEventInfo): boolean {
    return !!playerEventInfo && playerEventInfo.jersey === this.playerEventInfoJersey.WHITE;
  }

  public isBlackTeamPlayer(playerEventInfo: PlayerEventInfo): boolean {
    return !!playerEventInfo && playerEventInfo.jersey === this.playerEventInfoJersey.BLACK;
  }

  private filterPlayerEventInfos(playerEventInfos: PlayerEventInfo[]): PlayerEventInfo[] {
    const query = (this.playerListSearchText || "").trim().toLowerCase();
    if (!query) {
      return playerEventInfos || [];
    }

    return (playerEventInfos || []).filter((playerEventInfo) => {
      const player = playerEventInfo && playerEventInfo.player;
      const searchable = [
        player && player.nickName,
        player && player.name
      ].filter(Boolean).join(" ").toLowerCase();

      return searchable.indexOf(query) > -1;
    });
  }

  public canRespondToInvite(event: Event): boolean {
    return this.canUseLiveMatchActions(event) &&
      (event.currentPlayerInviteStatus !== this.playerEventInfoStatus.NOT_NOTIFIED || event.viewedByManager);
  }

  public shouldHighlightInviteResponse(event: Event): boolean {
    return this.canRespondToInvite(event) &&
      (
        event.currentPlayerInviteStatus === this.playerEventInfoStatus.NOT_ANSWERED ||
        event.currentPlayerInviteStatus === this.playerEventInfoStatus.NOT_NOTIFIED
      ) &&
      !this.responseSaving &&
      !this.responseConfirmStatus &&
      !this.responseResetOpen;
  }

  public hasSavedInviteResponse(event: Event): boolean {
    return event && (
      event.currentPlayerInviteStatus === this.playerEventInfoStatus.CONFIRMED ||
      event.currentPlayerInviteStatus === this.playerEventInfoStatus.DECLINED
    );
  }

  public inviteResponseStatusToDisplay(event: Event): string {
    if (this.responseSaving || this.responseConfirmStatus || this.responseResetOpen) {
      return null;
    }

    if (this.responseFeedbackStatus) {
      return this.responseFeedbackStatus;
    }

    return this.hasSavedInviteResponse(event) ? event.currentPlayerInviteStatus : null;
  }

  public canEnterResult(event: Event): boolean {
    return event && event.historyEvent === true && event.active === false && event.viewedByManager;
  }

  public hasResult(event: Event): boolean {
    return event && event.whiteScore !== null && event.whiteScore !== undefined &&
      event.blackScore !== null && event.blackScore !== undefined;
  }

  public displayGameResults(event: Event): EventGameResult[] {
    if (!event || !this.hasResult(event)) {
      return [];
    }

    if (event.gameResults && event.gameResults.length > 0) {
      return event.gameResults.map((gameResult, index) => this.normalizeGameResult(gameResult, index + 1));
    }

    return [this.defaultGameResult(event, 1)];
  }

  public displayHistoryRosterGames(event: Event): EventGameResult[] {
    if (!event) {
      return [];
    }

    if (this.hasResult(event)) {
      return this.displayGameResults(event);
    }

    const fallbackGame = this.defaultGameResult(event, 1);
    return fallbackGame.whitePlayerIds.length > 0 || fallbackGame.blackPlayerIds.length > 0 ? [fallbackGame] : [];
  }

  public hasHistoryRoster(event: Event): boolean {
    return this.displayHistoryRosterGames(event).length > 0;
  }

  public historyWhenLabel(event: Event): string {
    if (!event || !event.nextOccurrenceTimestamp) {
      return "-";
    }

    const date = new Date(event.nextOccurrenceTimestamp);
    const locale = this.translate.currentLang === "hr" ? "hr-HR" : "en-US";
    const timeZone = event.nextOccurrenceTimestampZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dateLabel = new Intl.DateTimeFormat(locale, this.isWithinSevenDays(date)
      ? { weekday: "long", timeZone }
      : { day: "numeric", month: "short", year: "numeric", timeZone }).format(date);
    const timeLabel = new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone
    }).format(date);
    return `${dateLabel} @ ${timeLabel}`;
  }

  public historyDateTimeLabel(event: Event): string {
    if (!event || !event.nextOccurrenceTimestamp) {
      return "-";
    }

    const date = new Date(event.nextOccurrenceTimestamp);
    const locale = this.translate.currentLang === "hr" ? "hr-HR" : "en-US";
    const timeZone = event.nextOccurrenceTimestampZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentYear = new Date().getFullYear();
    const eventYear = Number(new Intl.DateTimeFormat("en-US", { year: "numeric", timeZone }).format(date));
    const dateOptions: Intl.DateTimeFormatOptions = this.isWithinSevenDays(date)
      ? { weekday: "long", timeZone }
      : { day: "numeric", month: "long", year: eventYear === currentYear ? undefined : "numeric", timeZone };
    const dateLabel = new Intl.DateTimeFormat(locale, dateOptions).format(date).toUpperCase();
    const timeLabel = new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone
    }).format(date);

    return `${dateLabel} at ${timeLabel}`;
  }

  public canOpenHistoryEventDetails(event: Event): boolean {
    return !!(event && (event.viewedByPlayer || event.viewedByManager));
  }

  public openHistoryEventDetails(event: Event): void {
    if (!this.canOpenHistoryEventDetails(event)) {
      return;
    }

    this.eventPlayers(event);
  }

  public historyConfirmedCount(event: Event): number {
    if (!event) {
      return 0;
    }

    if (event.playerEventInfos && event.playerEventInfos.length > 0) {
      return this.getConfirmedPlayers(event).length;
    }

    if (event.confirmedCount !== undefined && event.confirmedCount !== null) {
      return Number(event.confirmedCount) || 0;
    }

    return this.eventService.getConfirmedCount(event);
  }

  public historyMaxPlayers(event: Event): number {
    if (!event) {
      return 0;
    }

    if (event.maxPlayers !== undefined && event.maxPlayers !== null) {
      return Number(event.maxPlayers) || 0;
    }

    return event.attendance && event.attendance.max !== undefined && event.attendance.max !== null
      ? Number(event.attendance.max) || 0
      : 0;
  }

  public historyRoundOutcomeKey(game: EventGameResult): string {
    if (!game || game.whiteScore === null || game.whiteScore === undefined ||
      game.blackScore === null || game.blackScore === undefined) {
      return "nothing";
    }

    if (!this.currentPlayer) {
      return "nothing";
    }

    const currentPlayerJersey = this.gamePlayerJersey(game, this.currentPlayer.id);
    if (!currentPlayerJersey) {
      return "nothing";
    }

    if (game.whiteScore === game.blackScore) {
      return "drew";
    }

    const currentPlayerScore = currentPlayerJersey === this.playerEventInfoJersey.WHITE ? game.whiteScore : game.blackScore;
    const opponentScore = currentPlayerJersey === this.playerEventInfoJersey.WHITE ? game.blackScore : game.whiteScore;
    return currentPlayerScore > opponentScore ? "won" : "lost";
  }

  public historyRoundOutcomeLabel(game: EventGameResult): string {
    const key = this.historyRoundOutcomeKey(game);
    if (key === "won") {
      return this.translate.instant("events.roundWon");
    }
    if (key === "lost") {
      return this.translate.instant("events.roundLost");
    }
    if (key === "drew") {
      return this.translate.instant("events.roundDraw");
    }

    return this.translate.instant("events.roundNotPlayed");
  }

  public gameTeamPlayers(event: Event, game: EventGameResult, jersey: string): PlayerEventInfo[] {
    const playerIds = jersey === this.playerEventInfoJersey.BLACK
      ? ((game && game.blackPlayerIds) || [])
      : ((game && game.whitePlayerIds) || []);

    return playerIds
      .map((playerId) => this.findPlayerEventInfo(event, playerId))
      .filter((playerEventInfo) => !!playerEventInfo);
  }

  public loadInlineStats(event: Event): void {
    if (!event || !event.originalEventId) {
      return;
    }

    this.inlineStatsLoading = true;
    this.inlineStatsErrorMsg = null;
    this.inlineStatsOpenSeasonIndexes = {};
    this.inlineEventStats = new EventStats();
    this.inlineEventStats.event = event;

    this.statsService.getEventStats(event.originalEventId, true).subscribe(
      (stats) => {
        const seasons = stats || [];
        const seasonNumbers = seasons
          .filter((statsRow) => this.statsRowPeriod(statsRow) === "season")
          .map((statsRow) => statsRow.season);
        const maxSeason = seasonNumbers.length > 0 ? Math.max.apply(Math, seasonNumbers) : -1;
        this.inlineEventStats.seasonStats = [];
        const allTimeRows = seasons.filter((statsRow) => this.statsRowPeriod(statsRow) === "allTime");

        if (allTimeRows.length > 0) {
          const allTimeStats = new SeasonStats();
          allTimeStats.stats = allTimeRows;
          allTimeStats.statsPeriod = "ALL_TIME";
          this.inlineEventStats.seasonStats.push(allTimeStats);
        }

        for (let currentSeason = maxSeason; currentSeason >= 0; currentSeason--) {
          const seasonRows = seasons.filter((statsRow) => this.statsRowPeriod(statsRow) === "season" && statsRow.season === currentSeason);
          if (seasonRows.length === 0) {
            continue;
          }

          const seasonStats = new SeasonStats();
          seasonStats.stats = seasonRows;
          seasonStats.statsPeriod = "SEASON";
          seasonStats.seasonStart = seasonRows[0].seasonStart;
          seasonStats.seasonEnd = seasonRows[0].seasonEnd;
          this.inlineEventStats.seasonStats.push(seasonStats);
        }

        this.inlineStatsOpenSeasonIndexes = this.visibleStatsSeasons(this.inlineEventStats).length > 0 ? {0: true} : {};
        this.inlineStatsLoading = false;
        this.spinner.hide();
        if (!this.destroyed) this.setMatchInfoEditorMode("stats");
      },
      () => {
        this.inlineStatsErrorMsg = this.translate.instant('events.inlineStatsLoadFailed');
        this.inlineStatsLoading = false;
        this.spinner.hide();
        this.dialogService.alert({title: this.translate.instant('common.alert'), text: this.inlineStatsErrorMsg});
      }
    );
  }

  public isInlineStatsSeasonOpen(seasonIndex: number): boolean {
    return this.inlineStatsOpenSeasonIndexes[seasonIndex] === true;
  }

  public setInlineStatsSeasonOpen(seasonIndex: number, event: any): void {
    const target = event && event.target as HTMLDetailsElement;
    this.inlineStatsOpenSeasonIndexes[seasonIndex] = !!(target && target.open);
  }

  public topSeasonStat(seasonStats: SeasonStats): Stats {
    const rankedStats = this.rankedSeasonStats(seasonStats);
    return rankedStats.length > 0 ? rankedStats[0] : null;
  }

  public hasSeasonRankedStats(seasonStats: SeasonStats): boolean {
    return this.rankedSeasonStats(seasonStats).length > 0;
  }

  public hasStatsSeasons(eventStats: EventStats): boolean {
    return this.visibleStatsSeasons(eventStats).length > 0;
  }

  public setStatsMetric(metric: StatsMetric): void {
    this.activeStatsMetric = metric;
  }

  public setStatsPeriod(period: StatsPeriod): void {
    this.activeStatsPeriod = period;
    this.inlineStatsOpenSeasonIndexes = this.visibleStatsSeasons(this.inlineEventStats).length > 0 ? {0: true} : {};
  }

  public exportableStatsSeasons(): SeasonStats[] {
    return (this.inlineEventStats?.seasonStats || []).filter(season => season.statsPeriod !== "ALL_TIME" && season.stats?.length > 0);
  }

  public statsExportSeasonLabel(season: SeasonStats): string {
    const dates = seasonExportDates(season);
    const formatter = new Intl.DateTimeFormat(this.translate.currentLang === "hr" ? "hr-HR" : "en-GB", { timeZone: "UTC" });
    return `${formatter.format(new Date(dates.start))} – ${formatter.format(new Date(dates.end))}`;
  }

  public openStatsExport(): void {
    if (!this.event?.viewedByManager || this.statsExportBusy) return;
    this.selectedStatsExportSeason = this.exportableStatsSeasons()[0] || null;
    this.statsExportError = "";
    this.showStatsExportDialog = true;
  }

  public async exportStatsSeason(): Promise<void> {
    if (!this.event?.viewedByManager || this.statsExportBusy || !this.exportableStatsSeasons().includes(this.selectedStatsExportSeason)) return;
    this.statsExportBusy = true;
    this.statsExportError = "";
    this.spinner.show();
    try {
      await downloadSeasonStats(this.selectedStatsExportSeason, this.inlineEventStats.event.name, key => this.translate.instant(key));
      this.showStatsExportDialog = false;
    } catch (_) {
      this.statsExportError = this.translate.instant("stats.export.failed");
    } finally {
      this.statsExportBusy = false;
      this.spinner.hide();
    }
  }

  public statsInfoTitleKey(): string {
    return this.activeStatsMetric === "teamBoost"
      ? (this.activeStatsPeriod === "allTime" ? "stats.infoTeamBoostAllTimeTitle" : "stats.infoTeamBoostSeasonTitle")
      : (this.activeStatsPeriod === "allTime" ? "stats.infoPlayerScoreAllTimeTitle" : "stats.infoPlayerScoreSeasonTitle");
  }

  public statsInfoDescriptionKey(): string {
    return this.statsInfoKey("Description");
  }

  public statsInfoFormulaKey(): string {
    return this.statsInfoKey("Formula");
  }

  public statsInfoFormulaDetailKey(): string {
    return this.statsInfoKey("FormulaDetail");
  }

  public statsInfoMeaningKey(): string {
    return this.statsInfoKey("Meaning");
  }

  public statsInfoAlgorithmKey(): string {
    return this.statsInfoKey("Algorithm");
  }

  public showPraviFudbaleriAllTimeEasterEgg(): boolean {
    const event = this.inlineEventStats && this.inlineEventStats.event ? this.inlineEventStats.event : this.event;
    return this.activeStatsPeriod === "allTime" && event && event.originalEventId === PRAVI_FUDBALERI_ORIGINAL_EVENT_ID;
  }

  private statsInfoKey(suffix: string): string {
    const metric = this.activeStatsMetric === "teamBoost" ? "TeamBoost" : "PlayerScore";
    const period = this.activeStatsPeriod === "allTime" ? "AllTime" : "Season";
    return `stats.info${metric}${period}${suffix}`;
  }

  public visibleStatsSeasons(eventStats: EventStats): SeasonStats[] {
    if (!eventStats || !eventStats.seasonStats) {
      return [];
    }
    return eventStats.seasonStats.filter((seasonStats) => this.seasonStatsPeriod(seasonStats) === this.activeStatsPeriod);
  }

  public seasonStatsPeriod(seasonStats: SeasonStats): StatsPeriod {
    if (!seasonStats) {
      return "season";
    }
    return seasonStats.statsPeriod === "ALL_TIME" ? "allTime" : "season";
  }

  public statsRowPeriod(stats: Stats): StatsPeriod {
    if (!stats) {
      return "season";
    }
    return stats.statsPeriod === "ALL_TIME" ? "allTime" : "season";
  }

  public statsSeasonCaption(seasonStats: SeasonStats): string {
    if (this.seasonStatsPeriod(seasonStats) === "allTime") {
      return this.translate.instant("stats.allTime");
    }
    const locale = this.translate.currentLang === "hr" ? "hr-HR" : "en-US";
    const start = seasonStats && seasonStats.seasonStart ? new Intl.DateTimeFormat(locale, { month: "short", day: "numeric", year: "numeric" }).format(new Date(seasonStats.seasonStart)) : "";
    const end = seasonStats && seasonStats.seasonEnd ? new Intl.DateTimeFormat(locale, { month: "short", day: "numeric", year: "numeric" }).format(new Date(seasonStats.seasonEnd)) : "";
    return `${start} - ${end}`;
  }

  public rankedSeasonStats(seasonStats: SeasonStats): Stats[] {
    if (!seasonStats || !seasonStats.stats) {
      return [];
    }
    return seasonStats.stats
      .filter((stats) => stats && this.statsMetricScore(stats) > 0)
      .slice()
      .sort((left, right) => {
        const scoreDiff = this.statsMetricScore(right) - this.statsMetricScore(left);
        if (scoreDiff !== 0) {
          return scoreDiff;
        }
        return (left.playerName || "").localeCompare(right.playerName || "");
      });
  }

  public statsMetricScore(stats: Stats): number {
    if (!stats) {
      return 0;
    }
    return this.activeStatsMetric === "teamBoost" ? (stats.teamBoostScore || 0) : (stats.playerScore || 0);
  }

  public loadInlineHistory(event: Event): void {
    if (!event || !event.originalEventId) {
      return;
    }

    this.inlineHistoryLoading = true;
    this.inlineHistoryErrorMsg = null;

    this.eventService.fetchHistory(event.originalEventId).pipe(
      switchMap(archived => {
        const page = (archived || []).filter(item => item?.active === false)
          .sort((a, b) => this.historyEventTimestamp(b) - this.historyEventTimestamp(a))
          .slice(this.inlineHistoryPage * this.inlineHistoryPageSize, (this.inlineHistoryPage + 1) * this.inlineHistoryPageSize);
        return page.length ? forkJoin(page.map(item => forkJoin({
          players: this.playerEventInfoService.fetchForEvent(item.id),
          results: this.hasResult(item) ? this.eventService.getGameResults(item.id) : of([])
        }).pipe(map(({players, results}) => {
          item.playerEventInfos = players || [];
          item.gameResults = (results || []).map((result, index) => this.normalizeGameResult(result, index + 1));
          item.confirmedCount = this.getConfirmedPlayers(item).length;
          item.historyEvent = true;
          item.viewedByManager = item.manager?.id === this.currentPlayer?.id;
          item.viewedByPlayer = item.playerEventInfos.some(p => p.player?.id === this.currentPlayer?.id);
          this.setWonLostDrewNothing(item);
          return item;
        })))) : of([]);
      })
    ).subscribe({
      next: events => {
        this.inlineHistoryLoading = false;
        this.spinner.hide();
        if (this.destroyed) return;
        this.inlineHistoryEvents = [...this.inlineHistoryEvents, ...events.filter(item => !this.inlineHistoryEvents.some(old => old.id === item.id))];
        this.setMatchInfoEditorMode("history");
      },
      error: () => {
        this.inlineHistoryLoading = false;
        this.spinner.hide();
        this.inlineHistoryErrorMsg = this.translate.instant('events.inlineHistoryLoadFailed');
        this.dialogService.alert({title: this.translate.instant('common.alert'), text: this.inlineHistoryErrorMsg});
      }
    });
  }

  private addInlineHistoryEvent(historyEvent: Event): void {
    if (!historyEvent || this.inlineHistoryEvents.some((existingEvent) => existingEvent.id === historyEvent.id)) {
      return;
    }

    this.inlineHistoryEvents.push(historyEvent);
    this.inlineHistoryEvents.sort((first, second) => this.historyEventTimestamp(second) - this.historyEventTimestamp(first));
    this.loadHistoryGameResults(historyEvent);
  }

  public loadMoreInlineHistory(): void {
    if (this.inlineHistoryLoading) {
      return;
    }

    this.inlineHistoryPage++;
    this.loadInlineHistory(this.event);
  }

  public openResultDialog(event: Event): void {
    if (this.destroyed || this.resultLoading || this.resultSaving || !this.canEnterResult(event)) {
      return;
    }

    const sourceMode = this.matchInfoEditorMode;
    const sourceEventId = this.event?.id;
    const playerId = this.currentPlayer?.id;
    const request = new Subscription();
    this.resultLoadSubscription = request;
    this.resultLoading = true;
    const finishLoading = this.spinner.acquire();
    const current = () => !this.destroyed && this.resultLoadSubscription === request &&
      this.event?.id === sourceEventId && this.currentPlayer?.id === playerId &&
      this.matchInfoEditorMode === sourceMode;

    request.add(this.eventService.getGameResults(event.id).pipe(timeout(10000), finalize(() => {
      finishLoading();
      if (this.resultLoadSubscription === request) {
        this.resultLoadSubscription = null;
        this.resultLoading = false;
      }
    })).subscribe({
      next: gameResults => {
        if (!current()) return;
        this.resultGames = gameResults?.length
          ? gameResults.map((gameResult, index) => this.normalizeGameResult(gameResult, index + 1))
          : [this.defaultGameResult(event, 1)];
        this.resultEvent = event;
        this.resultErrorMsg = null;
        this.showResultDialog = false;
        this.resultReturnMode = sourceMode === "result" ? null : sourceMode;
        this.resultLoading = false;
        this.setMatchInfoEditorMode("result");
      },
      error: () => {
        if (!current()) return;
        this.dialogService.alert({title: this.translate.instant('common.alert'), text: this.translate.instant('events.gameRoundsLoadFailed')});
      }
    }));
  }

  private cancelResultLoad(): void {
    const request = this.resultLoadSubscription;
    this.resultLoadSubscription = null;
    this.resultLoading = false;
    request?.unsubscribe();
  }

  private loadHistoryGameResults(event: Event): void {
    if (!event || event.historyEvent !== true || !this.hasResult(event)) {
      return;
    }

    if (event.gameResults && event.gameResults.length > 0) {
      return;
    }

    this.eventService.getGameResults(event.id).pipe(timeout(10000)).subscribe(
      (gameResults) => {
        event.gameResults = (gameResults || []).map((gameResult, index) => this.normalizeGameResult(gameResult, index + 1));
if (this.event && this.event.id === event.id) {
  this.event.gameResults = event.gameResults;
  localStorage.setItem("event", JSON.stringify(this.event));
}
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public closeResultDialog(): void {
    if (this.resultSaving) {
      return;
    }
    this.cancelResultLoad();

    this.showResultDialog = false;
    this.resultEvent = null;
    this.resultGames = [];
    this.resultErrorMsg = null;
    if (this.matchInfoEditorMode === "result") {
      this.closeResultEditorOneStepBack();
    }
  }

  public saveResult(): void {
    let targetEvent = this.resultEvent || this.event;
    if (!targetEvent || this.resultSaving || this.resultLoading || !this.canSaveResult()) {
      return;
    }

    this.matchInfoSaved = false;
    this.resultSaving = true;
    this.resultErrorMsg = null;
    const gameResults = this.resultGames.map((game) => ({
      ...game,
      whiteScore: this.resultScoreNumber(game.whiteScore),
      blackScore: this.resultScoreNumber(game.blackScore)
    }));

    this.eventService.saveGameResults(targetEvent.id, gameResults).pipe(timeout(15000)).subscribe(
      (gameResults) => {
        targetEvent.gameResults = gameResults || [];
if (gameResults && gameResults.length > 0) {
  targetEvent.whiteScore = gameResults[0].whiteScore;
  targetEvent.blackScore = gameResults[0].blackScore;
}
targetEvent.viewedByManager = true;
targetEvent.historyEvent = true;
this.setWonLostDrewNothing(targetEvent);
if (this.event && this.event.id === targetEvent.id) {
  localStorage.setItem("event", JSON.stringify(targetEvent));
}
this.resultSaving = false;
this.resultEvent = targetEvent;
this.resultGames = (gameResults || []).map(game => ({...game}));
this.matchInfoSaved = true;
      },
      (error) => {
        console.log(error);
        this.resultErrorMsg = this.translate.instant('events.resultSaveFailed');
this.resultSaving = false;
      }
    );
  }

  private closeResultEditorOneStepBack(): void {
    if (this.viewHistory?.back()) return;
    const returnMode = this.resultReturnMode;
    this.resultReturnMode = null;
    this.setMatchInfoEditorMode(returnMode);
    window.scrollTo(0, 0);
  }

  public addResultGame(): void {
    const previousGame = this.resultGames.length > 0 ? this.resultGames[this.resultGames.length - 1] : this.defaultGameResult(this.resultEvent, 0);
    this.resultGames.push({
      roundNumber: this.resultGames.length + 1,
      whiteScore: null,
      blackScore: null,
      whitePlayerIds: [...previousGame.whitePlayerIds],
      blackPlayerIds: [...previousGame.blackPlayerIds]
    });
  }

  public resultRoundLabel(game: EventGameResult): string {
    const round = game ? game.roundNumber : "";
    return `${this.translate.instant("events.gameRound")} ${round}`.trim();
  }

  public removeResultGame(index: number): void {
    if (this.resultSaving || this.resultGames.length <= 1) {
      return;
    }
    this.resultGames.splice(index, 1);
    this.renumberResultGames();
  }

  public setGamePlayerJersey(game: EventGameResult, playerId: string, jersey: string): void {
    game.whitePlayerIds = (game.whitePlayerIds || []).filter((id) => id !== playerId);
    game.blackPlayerIds = (game.blackPlayerIds || []).filter((id) => id !== playerId);

    if (jersey === this.playerEventInfoJersey.WHITE) {
      game.whitePlayerIds.push(playerId);
    } else if (jersey === this.playerEventInfoJersey.BLACK) {
      game.blackPlayerIds.push(playerId);
    }
  }

  public toggleGamePlayerJersey(game: EventGameResult, playerId: string): void {
    const currentJersey = this.gamePlayerJersey(game, playerId);
    this.setGamePlayerJersey(
      game,
      playerId,
      currentJersey === this.playerEventInfoJersey.BLACK ? this.playerEventInfoJersey.WHITE : this.playerEventInfoJersey.BLACK
    );
  }

  public removeGamePlayer(game: EventGameResult, playerId: string): void {
    if (!game || !playerId) {
      return;
    }

    game.whitePlayerIds = (game.whitePlayerIds || []).filter((id) => id !== playerId);
    game.blackPlayerIds = (game.blackPlayerIds || []).filter((id) => id !== playerId);
  }

  public gameAvailablePlayers(event: Event, game: EventGameResult): PlayerEventInfo[] {
    const whitePlayerIds = game && game.whitePlayerIds || [];
    const blackPlayerIds = game && game.blackPlayerIds || [];
    return this.getConfirmedPlayers(event).filter((playerEventInfo) =>
      playerEventInfo && playerEventInfo.player &&
      !whitePlayerIds.includes(playerEventInfo.player.id) &&
      !blackPlayerIds.includes(playerEventInfo.player.id)
    );
  }

  public gamePlayerJersey(game: EventGameResult, playerId: string): string {
    if (game && game.blackPlayerIds && game.blackPlayerIds.includes(playerId)) {
      return this.playerEventInfoJersey.BLACK;
    }
    if (game && game.whitePlayerIds && game.whitePlayerIds.includes(playerId)) {
      return this.playerEventInfoJersey.WHITE;
    }
    return null;
  }

  public canSaveResult(): boolean {
    if (!this.resultGames || this.resultGames.length === 0) {
      return false;
    }

    return this.resultGames.every((game) =>
      this.isResultScoreValid(game.whiteScore) &&
      this.isResultScoreValid(game.blackScore) &&
      this.hasResultTeamPlayers(game)
    );
  }

  public resultValidationMessage(): string {
    if (this.resultLoading || !this.resultGames || this.resultGames.length === 0 || this.canSaveResult()) {
      return null;
    }

    if (this.resultGames.some((game) => !this.isResultScoreValid(game.whiteScore) || !this.isResultScoreValid(game.blackScore))) {
      return this.translate.instant("events.resultValidation");
    }

    if (this.resultGames.some((game) => !this.hasResultTeamPlayers(game))) {
      return this.translate.instant(
        this.canAddHistoryAttendees(this.resultEvent || this.event)
          ? "events.resultRosterValidationWithAdd"
          : "events.resultRosterValidation"
      );
    }

    return null;
  }

  private hasResultTeamPlayers(game: EventGameResult): boolean {
    return (game && game.whitePlayerIds || []).length > 0 && (game && game.blackPlayerIds || []).length > 0;
  }

  private isResultScoreValid(value: number): boolean {
    const numericValue = this.resultScoreNumber(value);
    return numericValue !== null && Number.isInteger(numericValue) && numericValue >= 0;
  }

  private resultScoreNumber(value: number): number {
    if (value === null || value === undefined || `${value}`.trim() === "") {
      return null;
    }

    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
  }

  private openResultDialogFromReminderIfNeeded(): void {
    let eventIdForResultDialog = localStorage.getItem("openResultDialogForEventId");

    if (!eventIdForResultDialog || !this.event || this.event.id !== eventIdForResultDialog) {
      return;
    }

    localStorage.removeItem("openResultDialogForEventId");
    this.openResultDialog(this.event);
  }

  private setWonLostDrewNothing(event: Event): void {
    if (!event || !event.playerEventInfos) {
      return;
    }

    let didPlay: boolean = false;
    for (let playerEventInfo of event.playerEventInfos) {
      if (playerEventInfo.player.id === this.currentPlayer.id && playerEventInfo.status === this.playerEventInfoStatus.CONFIRMED) {
        didPlay = true;
        break;
      }
    }

    let isWhite: boolean = true;
    for (let playerEventInfo of event.playerEventInfos) {
      if (playerEventInfo.player.id === this.currentPlayer.id && playerEventInfo.jersey === this.playerEventInfoJersey.BLACK) {
        isWhite = false;
        break;
      }
    }

    if (!didPlay) {
      event.wonLostDrewNothing = "nothing";
    } else if (event.whiteScore === event.blackScore) {
      event.wonLostDrewNothing = "drew";
    } else if (isWhite) {
      event.teamWhite = true;
      event.wonLostDrewNothing = event.whiteScore > event.blackScore ? "won" : "lost";
    } else {
      event.teamWhite = false;
      event.wonLostDrewNothing = event.blackScore > event.whiteScore ? "won" : "lost";
    }
  }

  public getCurrentPlayerEventInfo(event: Event): PlayerEventInfo {
    if (!event || !event.playerEventInfos) {
      return null;
    }

    for (let playerEventInfo of event.playerEventInfos) {
      if (this.isCurrentPlayerEventInfo(playerEventInfo)) {
        return playerEventInfo;
      }
    }

    return null;
  }

  private saveInviteResponse(event: Event, status: string): void {
    if (this.destroyed || this.responseSaving || !this.canRespondToInvite(event)) {
      return;
    }

    let playerEventInfoForUpdate: PlayerEventInfo = this.getCurrentPlayerEventInfo(event);

    if (!playerEventInfoForUpdate) {
      playerEventInfoForUpdate = new PlayerEventInfo();
      playerEventInfoForUpdate.eventId = event.id;
      playerEventInfoForUpdate.player = this.currentPlayer;
      playerEventInfoForUpdate.jersey = this.playerEventInfoJersey.WHITE;
      playerEventInfoForUpdate.teamMemberType = this.teamMemberType.RESERVE;
    } else {
      playerEventInfoForUpdate = Object.assign(new PlayerEventInfo(), playerEventInfoForUpdate);
    }

    playerEventInfoForUpdate.status = status;
    this.responseSaving = true;
    this.pendingInviteStatus = status;
    this.responseFeedbackStatus = null;
    this.responseError = false;
    this.lastFailedInviteStatus = null;
    this.responseResetOpen = false;

    const saveRequest = playerEventInfoForUpdate.id ?
      this.playerEventInfoService.update(playerEventInfoForUpdate, this.currentPlayer) :
      this.playerEventInfoService.create(playerEventInfoForUpdate, this.currentPlayer);

    const playerId = this.currentPlayer.id;
    const request = new Subscription();
    this.inviteResponseSubscription = request;
    const current = () => !this.destroyed && this.inviteResponseSubscription === request &&
      this.event === event && this.currentPlayer?.id === playerId &&
      this.playerService.peekCurrentPlayer()?.id === playerId;
    const failed = (error?: any) => {
      if (!current()) return;
      this.responseSaving = false;
      this.pendingInviteStatus = null;
      this.responseConfirmStatus = null;
      this.responseError = true;
      this.lastFailedInviteStatus = status;
      if (error?.status === 406 || error?.error?.code === 'PARTICIPATION_CHANGED') {
        this.dialogService.alert({
          title: this.translate.instant('common.alert'),
          text: this.translate.instant(participationErrorKey(error))
        });
      }
    };

    request.add(saveRequest.pipe(timeout(15000), first(), finalize(() => {
      if (this.inviteResponseSubscription === request) {
        this.inviteResponseSubscription = null;
        this.responseSaving = false;
        this.pendingInviteStatus = null;
      }
    })).subscribe({
      next: saved => {
        if (!current()) return;
        if (!saved?.id || saved.status !== status || saved.eventId !== event.id ||
            saved.player?.id !== playerId ||
            (playerEventInfoForUpdate.id && saved.id !== playerEventInfoForUpdate.id)) {
          failed();
          return;
        }
        this.handleInviteResponseSaved(event, saved);
      },
      // A timeout says nothing about whether the server committed the write.
      error: failed
    }));
  }

  private cancelInviteResponse(): void {
    const request = this.inviteResponseSubscription;
    this.inviteResponseSubscription = null;
    this.responseSaving = false;
    this.pendingInviteStatus = null;
    request?.unsubscribe();
  }

  private handleInviteResponseSaved(event: Event, savedPlayerEventInfo: PlayerEventInfo): void {
    event.currentPlayerInviteStatus = savedPlayerEventInfo.status;
    this.responseSaving = false;
    this.pendingInviteStatus = null;
    this.responseConfirmStatus = null;
    this.responseResetOpen = false;
    this.responseError = false;
    this.lastFailedInviteStatus = null;
    if (savedPlayerEventInfo.status !== this.playerEventInfoStatus.NOT_ANSWERED) {
      this.showTemporaryResponseFeedback(savedPlayerEventInfo.status);
    }
    if (event.playerEventInfos?.some(participation => participation.id === savedPlayerEventInfo.id)) {
      this.updateEventPlayerEventInfo(savedPlayerEventInfo);
    } else {
      event.playerEventInfos = [...(event.playerEventInfos || []), savedPlayerEventInfo];
      this.refreshEventPlayerState();
    }

    if (savedPlayerEventInfo.status === this.playerEventInfoStatus.CONFIRMED) {
      this.analytics.track("match_joined", {
        screen: "match_players",
        entityType: "event",
        entityId: event.id,
        properties: { responseType: "invite_response" }
      });
    }
  }

  private showTemporaryResponseFeedback(status: string): void {
    this.clearResponseFeedbackTimer();
    this.responseFeedbackStatus = status;
    this.responseFeedbackTimer = setTimeout(() => {
      this.responseFeedbackStatus = null;
this.responseFeedbackTimer = null;
    }, 5000);
  }

  private clearResponseFeedbackTimer(): void {
    if (!this.responseFeedbackTimer) {
      return;
    }

    clearTimeout(this.responseFeedbackTimer);
    this.responseFeedbackTimer = null;
  }

  public eventLocationValue(): string {
    if (this.event && this.event.playSpace && this.event.playSpace.name) {
      return this.event.playSpace.name;
    }

    return this.event && this.event.locationName ? this.event.locationName : "";
  }

  public eventLocationSecondaryValue(): string {
    if (this.event && this.event.playSpace && this.event.playSpace.address) {
      return this.event.playSpace.address;
    }

    return "";
  }

  public eventLocationLine(): string {
    const primary = this.eventLocationValue();
    const secondary = this.eventLocationSecondaryValue();
    if (primary && secondary) {
      return `${primary}, ${secondary}`;
    }

    return primary || this.translate.instant("events.locationTbd");
  }

  public eventLocationMapHref(): string {
    if (this.hasPrecisePlaySpaceLocation()) {
      return "https://www.google.com/maps/search/?api=1&query=" +
        encodeURIComponent(`${this.event.playSpace.latitude},${this.event.playSpace.longitude}`);
    }

    const location = this.eventLocationLine();
    if (!location || location === this.translate.instant("events.locationTbd")) {
      return null;
    }

    return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(location);
  }

  public getHistoryLocation(event: Event): string {
    return event && event.playSpace && event.playSpace.name
      ? event.playSpace.name
      : event && event.locationName
      ? event.locationName
      : "-";
  }

  public getHistoryManager(event: Event): string {
    if (!event || !event.manager) {
      return "-";
    }

    return event.manager.nickName || event.manager.name || "-";
  }

  public getConfirmedPlayers(event: Event): PlayerEventInfo[] {
    return (event && event.playerEventInfos ? event.playerEventInfos : []).filter((playerEventInfo) =>
      playerEventInfo && playerEventInfo.player && playerEventInfo.status === this.playerEventInfoStatus.CONFIRMED
    );
  }

  private currentPlayerPlayedEvent(event: Event): boolean {
    if (!event || !this.currentPlayer || !event.playerEventInfos) {
      return false;
    }

    return event.playerEventInfos.some((playerEventInfo) =>
      playerEventInfo &&
      playerEventInfo.player &&
      playerEventInfo.player.id === this.currentPlayer.id &&
      playerEventInfo.status === this.playerEventInfoStatus.CONFIRMED
    );
  }

  private isWithinSevenDays(date: Date): boolean {
    if (!date || isNaN(date.getTime())) {
      return false;
    }

    const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
    return Math.abs(Date.now() - date.getTime()) < sevenDaysMs;
  }

  public getTeamPlayers(event: Event, jersey: string): PlayerEventInfo[] {
    return this.getConfirmedPlayers(event).filter((playerEventInfo) => playerEventInfo.jersey === jersey);
  }

  public getPlayerDisplayName(playerEventInfo: PlayerEventInfo): string {
    const player = playerEventInfo && playerEventInfo.player;
    return player ? player.nickName || player.name || "-" : "-";
  }

  public getPlayerInitials(playerEventInfo: PlayerEventInfo): string {
    const displayName = this.getPlayerDisplayName(playerEventInfo).trim();
    if (!displayName || displayName === "-") {
      return "?";
    }

    const parts = displayName.split(/[\s._-]+/).filter(Boolean);
    if (parts.length > 1) {
      return parts.slice(0, 2).map((name) => name.charAt(0).toUpperCase()).join("");
    }

    return displayName.slice(0, 2).toUpperCase();
  }

  public playerInitials(player: Partial<Player> | null | undefined): string {
    const displayName = player ? (player.nickName || player.name || player.email || "").trim() : "";
    if (!displayName) {
      return "?";
    }

    const parts = displayName.split(/[\s._-]+/).filter(Boolean);
    if (parts.length > 1) {
      return parts.slice(0, 2).map((name) => name.charAt(0).toUpperCase()).join("");
    }

    return displayName.slice(0, 2).toUpperCase();
  }

  public playerEventInfoAvatarTone(playerEventInfo: PlayerEventInfo): string {
    return this.playerAvatarTone(playerEventInfo ? playerEventInfo.player : null);
  }

  public playerAvatarTone(player: Partial<Player> | null | undefined): string {
    const displayName = player ? (player.nickName || player.name || player.email || "").trim() : "";
    const hash = displayName.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);
    return "avatar-initial-tone-" + (hash % 6);
  }

  private findPlayerEventInfo(event: Event, playerId: string): PlayerEventInfo {
    return event && event.playerEventInfos
      ? event.playerEventInfos.find((playerEventInfo) => playerEventInfo && playerEventInfo.player && playerEventInfo.player.id === playerId)
      : null;
  }

  private defaultGameResult(event: Event, roundNumber: number): EventGameResult {
    return {
      roundNumber,
      whiteScore: event ? event.whiteScore : null,
      blackScore: event ? event.blackScore : null,
      whitePlayerIds: this.getTeamPlayers(event, this.playerEventInfoJersey.WHITE).map((playerEventInfo) => playerEventInfo.player.id),
      blackPlayerIds: this.getTeamPlayers(event, this.playerEventInfoJersey.BLACK).map((playerEventInfo) => playerEventInfo.player.id)
    };
  }

  private normalizeGameResult(gameResult: EventGameResult, roundNumber: number): EventGameResult {
    return {
      id: gameResult.id,
      roundNumber: gameResult.roundNumber || roundNumber,
      whiteScore: gameResult.whiteScore,
      blackScore: gameResult.blackScore,
      whitePlayerIds: gameResult.whitePlayerIds || [],
      blackPlayerIds: gameResult.blackPlayerIds || []
    };
  }

  private renumberResultGames(): void {
    this.resultGames.forEach((game, index) => game.roundNumber = index + 1);
  }

  private historyEventTimestamp(event: Event): number {
    const occurrence = event && (event.nextOccurrenceTimestamp || event.nextOccurrence);
    if (!occurrence) {
      return 0;
    }

    const timestamp = new Date(occurrence).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  private buildSelectedOccurrence(): Date {
    const occurrence = this.selectedDate ? new Date(this.selectedDate) : new Date();
    occurrence.setHours(this.selectedHour || 0);
    occurrence.setMinutes(this.selectedMinute || 0);
    occurrence.setSeconds(0);
    occurrence.setMilliseconds(0);
    return occurrence;
  }

  private static todayAtStartOfDay(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  private cloneEventForUpdate(): Event {
    const updatedEvent = Object.assign(new Event(), this.event);
    if (updatedEvent.playSpace) {
      updatedEvent.playSpace = Object.assign(new PlaySpace(), updatedEvent.playSpace);
      updatedEvent.playSpace.location = null;
    }
    updatedEvent.locationId = updatedEvent.playSpace && updatedEvent.playSpace.id ? updatedEvent.playSpace.id : updatedEvent.locationId;
    return updatedEvent;
  }

  public showIncompleteSetupNotice(): boolean {
    return this.canEditMatchInfo() && !!this.event && this.event.incompleteSetup === true;
  }

  public saveIncompleteSetupMatch(): void {
    if (!this.showIncompleteSetupNotice()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.incompleteSetup = false;
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  private saveMatchInfo(updatedEvent: Event, onSuccess: () => void): void {
    this.matchInfoSaving = true;
    this.matchInfoSaved = false;
    this.matchInfoErrorMsg = null;
    if (this.event && this.event.incompleteSetup === true) {
      updatedEvent.incompleteSetup = false;
    }
    this.eventService.updateRichEvent(this.toRichUpdateRequest(updatedEvent)).subscribe(
      (event) => {
        this.event = this.mergeRichEventUpdate(event, updatedEvent);
this.event.viewedByManager = true;
localStorage.setItem("event", JSON.stringify(this.event));
this.matchInfoSaving = false;
onSuccess();
      },
      (response) => {
        this.matchInfoErrorMsg = this.getErrorMessage(response);
this.matchInfoSaving = false;
      }
    );
  }

  private saveFullMatchInfo(updatedEvent: Event, onSuccess: () => void): void {
    this.matchInfoSaving = true;
    this.matchInfoSaved = false;
    this.matchInfoErrorMsg = null;
    this.eventService.updateEvent(updatedEvent).subscribe(
      (event) => {
        this.event = Object.assign(new Event(), event);
this.event.viewedByManager = true;
if (this.event.season1StartDate) {
  this.event.season1StartDate = new Date(this.event.season1StartDate);
}
if (this.event.season2StartDate) {
  this.event.season2StartDate = new Date(this.event.season2StartDate);
}
if (this.event.seasonStartDates) {
  this.event.seasonStartDates = this.event.seasonStartDates.map((date) => new Date(date));
}
localStorage.setItem("event", JSON.stringify(this.event));
this.matchInfoSaving = false;
onSuccess();
      },
      (response) => {
        this.matchInfoErrorMsg = this.getErrorMessage(response);
this.matchInfoSaving = false;
      }
    );
  }

  private applyReturnedPlaySpaceIfPresent(): void {
    let returningFromPlayspaceCreation = false;
    try {
      returningFromPlayspaceCreation = JSON.parse(sessionStorage.getItem("returningFromNewPlayspaceForm"));
    } catch (error) {
      returningFromPlayspaceCreation = false;
    }

    if (!returningFromPlayspaceCreation) {
      return;
    }

    const newLocation: PlaySpace = JSON.parse(sessionStorage.getItem("newPlayspace"));
    sessionStorage.removeItem("returningFromNewPlayspaceForm");
    sessionStorage.removeItem("newPlayspace");
    sessionStorage.removeItem("playspaceReturnRoute");

    if (!newLocation || !this.canEditMatchInfo()) {
      return;
    }

    const updatedEvent = this.cloneEventForUpdate();
    updatedEvent.playSpace = newLocation;
    updatedEvent.locationName = newLocation.name || null;
    updatedEvent.locationId = newLocation.id || null;
    this.saveMatchInfo(updatedEvent, () => {
      this.completeMatchInfoSave();
    });
  }

  private toRichUpdateRequest(event: Event): any {
    return {
      id: event.id,
      name: event.name,
      note: event.note,
      rulebook: event.rulebook,
      locationName: event.locationName,
      maxPlayers: event.maxPlayers,
      incompleteSetup: event.incompleteSetup,
      nextOccurrence: event.nextOccurrenceTimestamp ? new Date(event.nextOccurrenceTimestamp).toISOString() : null,
      nextOccurrenceTimestampZone: event.nextOccurrenceTimestampZone,
      recurringType: event.recurringType,
      openToPublic: event.openToPublic === true,
      playSpace: this.playSpaceForUpdate(event.playSpace)
    };
  }

  private playSpaceForUpdate(playSpace: PlaySpace): PlaySpace {
    if (!playSpace) {
      return null;
    }

    const playSpaceForUpdate = Object.assign(new PlaySpace(), playSpace);
    playSpaceForUpdate.location = null;
    return playSpaceForUpdate;
  }

  private mergeRichEventUpdate(response: any, request: Event): Event {
    const mergedEvent = Object.assign(new Event(), this.event);
    mergedEvent.name = response && response.name ? response.name : request.name;
    mergedEvent.note = response ? response.note : request.note;
    mergedEvent.rulebook = response ? response.rulebook : request.rulebook;
    mergedEvent.locationName = response ? response.locationName : request.locationName;
    mergedEvent.maxPlayers = response && response.maxPlayers !== undefined ? response.maxPlayers : request.maxPlayers;
    mergedEvent.nextOccurrenceTimestamp = response && response.nextOccurrence ? new Date(response.nextOccurrence) : request.nextOccurrenceTimestamp;
    mergedEvent.nextOccurrence = response && response.nextOccurrence ? response.nextOccurrence : request.nextOccurrence;
    mergedEvent.nextOccurrenceTimestampZone = response && response.nextOccurrenceTimestampZone !== undefined
      ? response.nextOccurrenceTimestampZone
      : request.nextOccurrenceTimestampZone;
    mergedEvent.recurringType = response && response.recurringType ? response.recurringType : request.recurringType;
    mergedEvent.playSpace = response && response.playSpace !== undefined ? response.playSpace : request.playSpace;
    mergedEvent.openToPublic = response && response.openToPublic !== undefined ? response.openToPublic : request.openToPublic;
    mergedEvent.incompleteSetup = response && response.incompleteSetup !== undefined ? response.incompleteSetup : request.incompleteSetup;
    mergedEvent.setupCompletedAt = response && response.setupCompletedAt !== undefined ? response.setupCompletedAt : request.setupCompletedAt;
    mergedEvent.managerLastViewedAt = response && response.managerLastViewedAt !== undefined ? response.managerLastViewedAt : request.managerLastViewedAt;
    mergedEvent.cancelled = response && response.cancelled !== undefined ? response.cancelled : request.cancelled;
    mergedEvent.cancelledAt = response && response.cancelledAt !== undefined ? response.cancelledAt : request.cancelledAt;
    mergedEvent.cancelledByPlayerId = response && response.cancelledByPlayerId !== undefined ? response.cancelledByPlayerId : request.cancelledByPlayerId;
    mergedEvent.cancelReason = response && response.cancelReason !== undefined ? response.cancelReason : request.cancelReason;
    return mergedEvent;
  }

  private getPlaySpacesAsObservable(partialLocationName: string): Observable<any> {
    const query = (partialLocationName || "").trim();
    if (!query || !this.canSelectExistingLocations()) {
      return of([]);
    }

    return this.playSpaceService.getPlaySpaces(query).pipe(
      catchError(() => {
        this.typeaheadLocationLoading = false;
this.typeaheadLocationNoResults = true;
        return of([]);
      })
    );
  }

  private isCurrentPlayerEventInfo(playerEventInfo: PlayerEventInfo): boolean {
    if (!playerEventInfo || !playerEventInfo.player || !this.currentPlayer) {
      return false;
    }

    return this.currentPlayer.id === playerEventInfo.player.id ||
      (!!this.currentPlayer.email && this.currentPlayer.email === playerEventInfo.player.email);
  }

  public fetchPlayerEventInfos(event: Event): void {
    this.fetchPlayerEventInfosInProgress = true;
    this.newCandidatesFound = false;

    this.playerEventInfoService.fetchForEvent(event.id).subscribe(
      (playerEventInfoList) => {
        this.applyPlayerEventInfos(playerEventInfoList);
      },
      (error) => {
        console.log(error);

        this.fetchPlayerEventInfosInProgress = false;
this.spinner.hide();
this.loading = false;
this.eventPlayersReady$.next(true);
      }
    );
  }

  private canUseCachedHistoryPlayerEventInfos(event: Event): boolean {
    return event && event.historyEvent === true && event.active === false &&
      event.playerEventInfos && event.playerEventInfos.length > 0;
  }

  private applyPlayerEventInfos(playerEventInfoList: PlayerEventInfo[]): void {
    this.event.viewedByPlayer = false;
    this.event.viewedByCandidate = false;
    this.event.currentPlayerInviteStatus = null;
    this.event.playerEventInfos = Array<PlayerEventInfo>();
    this.newCandidatesInfoList = [];
    this.newCandidatesFound = false;
    this.countOfConfirmed = 0;
    this.countOfNotAnswered = 0;
    this.countOfDeclined = 0;
    this.countOfNotNotified = 0;

    for (let playerEventInfo of playerEventInfoList || []) {
      if (playerEventInfo.teamMemberType === this.teamMemberType.CANDIDATE) {
        this.newCandidatesFound = true;
        this.newCandidatesInfoList.push(playerEventInfo);
      }

      if (playerEventInfo.player.id === this.currentPlayer.id) {
        this.event.currentPlayerInviteStatus = playerEventInfo.status;
        this.event.viewedByCandidate = playerEventInfo.teamMemberType === this.teamMemberType.CANDIDATE;
        if (playerEventInfo.teamMemberType !== this.teamMemberType.CANDIDATE) {
          this.event.viewedByPlayer = true;
        }
        if (this.event.manager.id === this.currentPlayer.id) {
          this.event.viewedByManager = true;
        }
      }
      this.event.playerEventInfos.push(playerEventInfo);
    }

    this.event.playerEventInfos.forEach((player) => {
      if (player.teamMemberType === this.teamMemberType.CANDIDATE) return;
      if (player.status === "CONFIRMED") {
        this.countOfConfirmed++;
      } else if (player.status === "NOT_ANSWERED") {
        this.countOfNotAnswered++;
      } else if (player.status === "DECLINED") {
        this.countOfDeclined++;
      } else {
        this.countOfNotNotified++;
      }
    });

    this.event.confirmedCount = this.countOfConfirmed;
    this.event.attendance = { ...this.event.attendance, confirmed: this.countOfConfirmed };
    this.sortPlayersByTeamMemberTypeAndNickname();
    this.openResultDialogFromReminderIfNeeded();
    this.restorePlayerDetailAfterChatIfNeeded();
    this.openRequestedPlayerDetailIfNeeded();

    this.fetchPlayerEventInfosInProgress = false;
    this.spinner.hide();
    this.loading = false;
    this.eventPlayersReady$.next(true);
    this.openRulebookFromNotificationIfNeeded();
  }

  private restorePlayerDetailAfterChatIfNeeded(): void {
    if (localStorage.getItem("returnToPlayerDetailAfterChat") !== "true" || !this.event || !this.event.playerEventInfos) {
      return;
    }

    const storedPlayerEventInfo = JSON.parse(localStorage.getItem("peiForPlayerDetail"));
    const storedEvent = JSON.parse(localStorage.getItem("eventForPlayerDetail"));

    if (storedEvent && storedEvent.id && this.event.id && storedEvent.id !== this.event.id) {
      localStorage.removeItem("returnToPlayerDetailAfterChat");
      return;
    }

    const selectedPlayerEventInfo = this.event.playerEventInfos.find((playerEventInfo) =>
      (storedPlayerEventInfo && storedPlayerEventInfo.id && playerEventInfo.id === storedPlayerEventInfo.id) ||
      (storedPlayerEventInfo && storedPlayerEventInfo.player && storedPlayerEventInfo.player.id && playerEventInfo.player && playerEventInfo.player.id === storedPlayerEventInfo.player.id)
    );

    localStorage.removeItem("returnToPlayerDetailAfterChat");

    if (!selectedPlayerEventInfo) {
      return;
    }

    localStorage.setItem("peiForPlayerDetail", JSON.stringify(selectedPlayerEventInfo));
    localStorage.setItem("eventForPlayerDetail", JSON.stringify(this.event));
    this.selectedPlayerDetailEventInfo = selectedPlayerEventInfo;
    this.setMatchInfoEditorMode("playerDetail");
  }

  private openRequestedPlayerDetailIfNeeded(): void {
    const requestedPlayerId = localStorage.getItem("openPlayerDetailForPlayerId");
    if (!requestedPlayerId || !this.event || !this.event.playerEventInfos) {
      return;
    }

    const requestedEventId = localStorage.getItem("openPlayerDetailForEventId");
    if (requestedEventId && this.event.id && requestedEventId !== this.event.id) {
      this.clearRequestedPlayerDetail();
      return;
    }

    const selectedPlayerEventInfo = this.event.playerEventInfos.find((playerEventInfo) =>
      playerEventInfo && playerEventInfo.player && playerEventInfo.player.id === requestedPlayerId
    );

    this.clearRequestedPlayerDetail();

    if (!selectedPlayerEventInfo) {
      return;
    }

    localStorage.setItem("peiForPlayerDetail", JSON.stringify(selectedPlayerEventInfo));
    localStorage.setItem("eventForPlayerDetail", JSON.stringify(this.event));
    this.selectedPlayerDetailEventInfo = selectedPlayerEventInfo;
    this.setMatchInfoEditorMode("playerDetail");
  }

  private clearRequestedPlayerDetail(): void {
    localStorage.removeItem("openPlayerDetailForPlayerId");
    localStorage.removeItem("openPlayerDetailForEventId");
  }

  public switchToTeamMode(): void {
    this.editMode = true;

    this.sortPlayersByTeamMemberType();
    this.router.navigate(["/event-players", false]);
  }

  public switchToMatchMode(): void {
    this.editMode = false;

    this.sortPlayerByStatusAndJerseyColor();
    this.router.navigate(["/event-players", false]);
  }

  public sortPlayersByTeamMemberType(): void {
    if (!this.event.playerEventInfos) {
      return;
    }

    this.event.playerEventInfos.sort((a, b) => a.teamMemberType.localeCompare(b.teamMemberType));
  }

  public sortPlayersByTeamMemberTypeAndNickname(): void {
    if (!this.event.playerEventInfos) {
      return;
    }

    this.event.playerEventInfos.sort((a, b) => {
      if (a.teamMemberType === b.teamMemberType) {
        return a.player.nickName.localeCompare(b.player.nickName);
      } else {
        return a.teamMemberType.localeCompare(b.teamMemberType);
      }
    });
  }

  public sortPlayerByStatusAndJerseyColor(): void {
    if (!this.event.playerEventInfos) {
      return;
    }

    this.event.playerEventInfos.sort((a, b) => {
      if (a.status === b.status) {
        return a.jersey.localeCompare(b.jersey);
      } else {
        return a.status.localeCompare(b.status);
      }
    });
  }

  public animateNotificationInProgress(originalPc: PlayerEventInfo, updatedPc: PlayerEventInfo) {
    let me = this;
    originalPc.notificationInProgress = true;

    setTimeout(() => {
      updatedPc.notificationInProgress = false;
me.event.playerEventInfos[me.event.playerEventInfos.indexOf(originalPc, 0)] = updatedPc;
    }, 2700);
  }

  public sendIndividualMatchInvitation(playerEventInfo: PlayerEventInfo): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    if (this.isGuestPlayer(playerEventInfo.player)) {
      return;
    }

    this.eventService.invitePlayer(playerEventInfo).subscribe(
      (updatedPc) => {
        this.animateNotificationInProgress(playerEventInfo, updatedPc);
      },
      (error) => {
        console.log(error);
        this.animateNotificationInProgress(playerEventInfo, playerEventInfo);
      }
    );
  }

  public changeTypeaheadLoading(e: boolean, fieldName: string = "playerName"): void {
    if (fieldName === "locationName") {
      this.locationNameSelected = false;
      this.typeaheadLocationLoading = e;
      return;
    }

    this.playerNameSelected = false;
    this.typeaheadPlayerLoading = e;
  }

  public changeTypeaheadNoResults(e: boolean, fieldName: string = "playerName"): void {
    if (fieldName === "locationName") {
      this.locationNameSelected = false;
      this.typeaheadLocationNoResults = e;
      return;
    }

    this.playerNameSelected = false;
    this.typeaheadPlayerNoResults = e;
  }

  public typeaheadPlayerNameSelected(selectedObject: any): void {
    this.playerNameSelected = true;
    this.selectedPlayerHolder = selectedObject.item;
    this.nogoshPlayersAddSuccessMsg = null;
    if (!this.selectedPlayers.some((player) => player.id === selectedObject.item.id)) {
      this.selectedPlayers.push(selectedObject.item);
    }
  }

  public typeaheadLocationNameSelected(selectedObject: any): void {
    this.selectExistingPlaySpace(selectedObject.item);
  }

  public checkIfLocationNameIsSelected(): void {
    if (this.locationEditorMode === "existing" && !this.locationNameSelected) {
      this.selectedExistingPlaySpace = null;
      this.autocompletePlayspace = (this.autocompletePlayspace || "").trim();
    }
  }

  public approveJoinRequest(playerEventInfo: PlayerEventInfo): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    playerEventInfo.teamMemberType = this.teamMemberType.RESERVE;

    this.checkIfCandidatesExist();
    this.sortPlayers();

    this.playerEventInfoService.update(playerEventInfo, this.currentPlayer).subscribe(
      (updatedPlayerEventInfo) => {
        this.updateEventPlayerEventInfo(updatedPlayerEventInfo);
this.newCandidatesInfoList = this.newCandidatesInfoList.filter((item) => item.id !== playerEventInfo.id);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public enterOrCreateNewChat(player: Player): void {
    if (this.isGuestPlayer(player)) {
      return;
    }

    this.chatService.openDirectChat(player.id).subscribe(
      (thread) => {
        this.router.navigate(["/messages", { chatId: thread.chat.id }]);
      },
      (response) => {
        console.log(response.error);
        this.spinner.hide();
this.loading = false;
      }
    );
  }

  public addPlayerToTheEvent(email: string): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    if (this.selectedPlayerHolder != null && this.event.playerEventInfos.findIndex((x) => x.player.id === this.selectedPlayerHolder.id) > -1) {
      this.playerNameSelected = false;
      this.autocompleteSelectedPlayer = null;

      return;
    }

    this.addPlayerToPlayerEventInfosList(this.selectedPlayerHolder);

    //this.editMode = true;

    this.autocompleteSelectedPlayer = null;
    this.typeaheadPlayerNoResults = false;
    this.selectedPlayerHolder = null;
  }

  public removePlayerFromTheEvent(playerEventInfo: PlayerEventInfo): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    if (this.isGuestPlayer(playerEventInfo.player)) {
      this.removeGuestFromEvent(playerEventInfo);
      return;
    }

    if (playerEventInfo.id) {
      this.playerEventInfoService.delete(playerEventInfo.id).subscribe(
        () => {
          this.removePlayerEventInfoFromList(playerEventInfo);
this.checkIfCandidatesExist();
this.event.playerEventInfos = this.event.playerEventInfos.filter((item) => item.id !== playerEventInfo.id);
this.newCandidatesInfoList = this.newCandidatesInfoList.filter((item) => item.id !== playerEventInfo.id);
this.refreshEventPlayerState();
        },
        (res) => {
          console.log(res.error);
        }
      );
    } else {
      this.removePlayerEventInfoFromList(playerEventInfo);
      this.checkIfCandidatesExist();
      this.refreshEventPlayerState();
    }
  }

  public removeGuestFromEvent(playerEventInfo: PlayerEventInfo): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    if (!playerEventInfo.id) {
      this.removePlayerEventInfoFromList(playerEventInfo);
      this.checkIfCandidatesExist();
      return;
    }

    this.guestActionInProgress = true;
    this.playerService.removeGuestFromEvent(playerEventInfo.player.id, this.event.id).subscribe(
      () => {
        this.removePlayerEventInfoFromList(playerEventInfo);
this.event.playerEventInfos = this.event.playerEventInfos.filter((item) => item.id !== playerEventInfo.id);
this.newCandidatesInfoList = this.newCandidatesInfoList.filter((item) => item.id !== playerEventInfo.id);
this.refreshEventPlayerState();
this.guestActionInProgress = false;
      },
      (res) => {
        this.guestErrorMsg = this.getErrorMessage(res);
this.guestActionInProgress = false;
      }
    );
  }

  public async toggleSubteamJersey(playerEventInfo: PlayerEventInfo): Promise<void> {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    if (playerEventInfo.jersey == null || playerEventInfo.jersey === this.playerEventInfoJersey.WHITE) {
      playerEventInfo.jersey = this.playerEventInfoJersey.BLACK;
    } else {
      playerEventInfo.jersey = this.playerEventInfoJersey.WHITE;
    }

    // this.sortPlayers();

    try {
      const updateRequest = this.updateParticipation(playerEventInfo)
        .toPromise();
      const updatedPlayerEventInfo = await updateRequest;
      this.updateEventPlayerEventInfo(updatedPlayerEventInfo);
this.clearBalanceTeamsResultAfterManualJerseyChange();
      // console.log("updated:" + updatedPlayerEventInfo.player.name + " " + updatedPlayerEventInfo.jersey);
    } catch (error) {
      console.log(error);
    }
  }

  public toggleStatus(playerEventInfo: PlayerEventInfo): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    let me = this;

    let peiOriginalStatus = playerEventInfo.status;
    const originalCounts = [me.countOfNotAnswered, me.countOfConfirmed, me.countOfDeclined, me.countOfNotNotified];

    if (playerEventInfo.status === me.playerEventInfoStatus.NOT_ANSWERED) {
      me.countOfNotAnswered--;
      me.countOfConfirmed++;
      playerEventInfo.status = me.playerEventInfoStatus.CONFIRMED;
    } else if (playerEventInfo.status === me.playerEventInfoStatus.CONFIRMED) {
      me.countOfConfirmed--;
      me.countOfDeclined++;
      playerEventInfo.status = me.playerEventInfoStatus.DECLINED;
    } else if (playerEventInfo.status === me.playerEventInfoStatus.DECLINED) {
      me.countOfDeclined--;
      me.countOfNotNotified++;
      playerEventInfo.status = me.playerEventInfoStatus.NOT_NOTIFIED;
    } else {
      me.countOfNotNotified--;
      me.countOfNotAnswered++;
      playerEventInfo.status = me.playerEventInfoStatus.NOT_ANSWERED;
    }

    // this.sortPlayers();

    me.updateParticipation(playerEventInfo).subscribe(
      (updatedPlayerEventInfo) => {
        this.updateEventPlayerEventInfo(updatedPlayerEventInfo);
me.spinner.hide();
me.loading = false;
      },
      (error) => {
        playerEventInfo.status = peiOriginalStatus;
        [me.countOfNotAnswered, me.countOfConfirmed, me.countOfDeclined, me.countOfNotNotified] = originalCounts;
        this.fetchPlayerEventInfos(this.event);
this.dialogService.alert({
  title: this.translate.instant('common.alert'),
  text: this.translate.instant(participationErrorKey(error))
});

me.loading = false;
me.spinner.hide();
      }
    );
  }

  // public sendInviteEmail(inviteToNogoshEmailList: string): void {
  //   this.loading = true;
  //   this.eventService.invitePlayersToJoinNogosh(this.sendInviteEmailEvent, inviteToNogoshEmailList).subscribe(
  //     () => {
  //       this.addNewPeopleToNogosh = true;
  //       this.loading = false;
  //     },
  //     (res) => {
  //       console.log(res.error);
  //       this.loading = false;
  //     }
  //   );
  // }

  // public dialogSendInviteEmail(event: Event): void {
  //   this.sendInviteEmailEvent = event;
  // }

  public toogleTeamMemberType(playerEventInfo: PlayerEventInfo): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    if (playerEventInfo.teamMemberType === this.teamMemberType.FIRST_TEAM) {
      playerEventInfo.teamMemberType = this.teamMemberType.RESERVE;
    } else {
      playerEventInfo.teamMemberType = this.teamMemberType.FIRST_TEAM;
    }

    // this.sortPlayers();

    this.updateParticipation(playerEventInfo).subscribe(
      (updatedPlayerEventInfo) => {
        this.updateEventPlayerEventInfo(updatedPlayerEventInfo);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private checkIfCandidatesExist(): void {
    this.newCandidatesFound = false;
    for (let pei of this.event.playerEventInfos) {
      if (pei.teamMemberType === this.teamMemberType.CANDIDATE) {
        this.newCandidatesFound = true;
        break;
      }
    }
  }

  private removePlayerEventInfoFromList(playerEventInfo: PlayerEventInfo) {
    if (!this.event || !this.event.playerEventInfos) {
      return;
    }

    this.event.playerEventInfos = this.event.playerEventInfos.filter((pei) => {
      if (playerEventInfo.id) {
        return pei.id !== playerEventInfo.id;
      }

      return pei !== playerEventInfo;
    });
  }

  private removePlayerEventInfoByPlayerId(playerId: string): void {
    if (!playerId || !this.event || !this.event.playerEventInfos) {
      return;
    }

    this.event.playerEventInfos = this.event.playerEventInfos.filter((playerEventInfo) => {
      return !playerEventInfo.player || playerEventInfo.player.id !== playerId;
    });
    this.refreshEventPlayerState();
  }

  private updateEventPlayerEventInfo(playerEventInfo: PlayerEventInfo): void {
    let newPlayerEventInfos = Array<PlayerEventInfo>();

    for (let pei of this.event.playerEventInfos) {
      if (playerEventInfo.id === pei.id) {
        newPlayerEventInfos.push(playerEventInfo);
      } else {
        newPlayerEventInfos.push(pei);
      }
    }
    this.event.playerEventInfos = newPlayerEventInfos;
    if (playerEventInfo && playerEventInfo.status) {
      this.selectedPlayerListStatus = playerEventInfo.status;
    }
    this.refreshEventPlayerState();
    this.event = Object.assign(new Event(), this.event);
  }

  private sortPlayers(): void {
    if (this.editMode) {
      this.sortPlayersByTeamMemberType();
    } else {
      this.sortPlayerByStatusAndJerseyColor();
    }
  }

  private getPlayersAsObservable(partialPlayerNickName: string): Observable<any> {
    if (this.matchInfoEditorMode === "openProfiles" && !this.canSearchNogoshPlayersByCity()) {
      this.nogoshPlayersSearchErrorMsg = this.translate.instant('events.addNogoshPlayersCityRequired');
      return of([]);
    }

    this.nogoshPlayersSearchErrorMsg = null;
    return this.getAddablePlayersForCurrentInviteScreen(partialPlayerNickName).pipe(
      catchError((error) => {
        this.nogoshPlayersSearchErrorMsg = error && error.status === 400
          ? this.translate.instant('events.addNogoshPlayersCityRequired')
          : this.getErrorMessage(error);
        return of([]);
      })
    );
  }

  private getAddablePlayersForCurrentInviteScreen(partialPlayerNickName: string, mode: MatchInfoEditorMode = this.matchInfoEditorMode): Observable<Player[]> {
    if (mode === "footballNetwork") {
      if (this.footballNetworkSource === "references") {
        return this.playerService.getAddableFootballerNetwork(this.event.id, partialPlayerNickName);
      }
      if (this.footballNetworkSource === "openProfiles") {
        return this.playerService.getAddableOpenProfiles(this.event.id, partialPlayerNickName);
      }
      return this.playerService.getAddableFootballerFriends(this.event.id, partialPlayerNickName);
    }
    if (mode === "footballerFriends") {
      return this.playerService.getAddableFootballerFriends(this.event.id, partialPlayerNickName);
    }
    if (mode === "openProfiles") {
      return this.playerService.getAddableOpenProfiles(this.event.id, partialPlayerNickName);
    }

    return this.playerService.getAddableNogoshPlayers(this.event.id, partialPlayerNickName);
  }

  public searchInviteCandidates(): void {
    this.loadInviteCandidates(this.inviteCandidateSearchText);
  }

  private loadInviteCandidates(partialPlayerNickName: string): void {
    if (!this.canSearchCurrentNogoshInviteSource()) {
      return;
    }

    const searchText = (partialPlayerNickName || "").trim();
    if (!searchText && this.matchInfoEditorMode !== "nogoshPlayers" && this.matchInfoEditorMode !== "footballNetwork") {
      this.inviteCandidatePlayers = [];
      this.typeaheadPlayerNoResults = false;
      return;
    }

    this.inviteCandidateLoading = true;
    this.typeaheadPlayerNoResults = false;
    this.nogoshPlayersSearchErrorMsg = null;
    this.getAddablePlayersForCurrentInviteScreen(searchText).subscribe(
      (players) => {
        this.inviteCandidatePlayers = players || [];
this.typeaheadPlayerNoResults = this.inviteCandidatePlayers.length === 0;
this.inviteCandidateLoading = false;
      },
      (error) => {
        this.nogoshPlayersSearchErrorMsg = error && error.status === 400
  ? this.translate.instant('events.addNogoshPlayersCityRequired')
  : this.getErrorMessage(error);
this.inviteCandidatePlayers = [];
this.inviteCandidateLoading = false;
      }
    );
  }

  public toggleInviteCandidate(player: Player): void {
    if (this.isSelectedInviteCandidate(player)) {
      this.removePlayerFromInviteList(player);
      return;
    }

    this.nogoshPlayersAddSuccessMsg = null;
    this.selectedPlayers.push(player);
  }

  public isSelectedInviteCandidate(player: Player): boolean {
    return !!player && this.selectedPlayers.some((selectedPlayer) => selectedPlayer.id === player.id);
  }

  public canSearchNogoshPlayersByCity(): boolean {
    return !!this.currentPlayer && !!this.currentPlayer.city && this.currentPlayer.city.trim().length > 0;
  }

  public canSearchCurrentNogoshInviteSource(): boolean {
    return this.matchInfoEditorMode !== "openProfiles"
      && !(this.matchInfoEditorMode === "footballNetwork" && this.footballNetworkSource === "openProfiles")
      || this.canSearchNogoshPlayersByCity();
  }

  public selectFootballNetworkSource(source: FootballNetworkSource): void {
    this.footballNetworkSource = source;
    this.inviteCandidateSearchText = "";
    this.inviteCandidatePlayers = [];
    this.selectedPlayers = [];
    this.loadInviteCandidates("");
  }

  public footballNetworkReferenceNames(player: Player): string {
    return (player.networkReferences || []).slice(0, 2)
      .map((reference) => reference.nickName || reference.name)
      .filter((name) => !!name)
      .join(", ");
  }

  public currentNogoshInviteTitleKey(): string {
    if (this.matchInfoEditorMode === "footballNetwork") {
      return "events.footballNetworkTitle";
    }
    return this.matchInfoEditorMode === "openProfiles" ? "events.inviteOpenProfilesTitle" : "events.inviteFootballerFriendsTitle";
  }

  public currentNogoshInviteHintKey(): string {
    if (this.matchInfoEditorMode === "footballNetwork") {
      return "events.footballNetworkHint";
    }
    return this.matchInfoEditorMode === "openProfiles" ? "events.inviteOpenProfilesHint" : "events.inviteFootballerFriendsHint";
  }

  public currentNogoshInvitePlaceholderKey(): string {
    if (this.matchInfoEditorMode === "footballNetwork") {
      return "events.footballNetworkSearchPlaceholder";
    }
    return this.matchInfoEditorMode === "openProfiles" ? "events.inviteOpenProfilesPlaceholder" : "events.searchPlayers";
  }

  public clearInviteCandidateSearch(): void {
    this.inviteCandidateSearchText = "";
    this.inviteCandidatePlayers = [];
    this.typeaheadPlayerNoResults = false;
    this.nogoshPlayersSearchErrorMsg = null;
  }

  public removePlayerFromInviteList(player: Player) {
    let index = 0;

    for (let splayer of this.selectedPlayers) {
      if (player.id === splayer.id) {
        this.selectedPlayers.splice(index, 1);
        break;
      }
      index++;
    }
  }

  public callPlayersFromInviteList(): void {
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    this.invitePlayersToMatch(this.selectedPlayers.slice());
    this.selectedPlayers = [];

    this.editMode = false;

    this.autocompleteSelectedPlayer = null;
    this.typeaheadPlayerNoResults = false;
    this.selectedPlayerHolder = null;
  }

  public addSelectedPlayersFromPage(): void {
    if (!this.canSearchCurrentNogoshInviteSource() || this.selectedPlayers.length === 0) {
      return;
    }

    const playersToAdd = this.selectedPlayers.slice();
    if (this.canAddHistoryAttendees(this.event)) {
      this.addPlayersAsHistoryAttendees(playersToAdd);
    } else {
      this.invitePlayersToMatch(playersToAdd);
    }
    this.appendAddedNogoshPlayers(playersToAdd);
    this.selectedPlayers = [];
    this.nogoshPlayersAddSuccessMsg = this.translate.instant(this.canAddHistoryAttendees(this.event) ? 'events.playersAddedToHistory' : 'events.playersInvited');
  }

  public sendDirectInvite(): void {
    if (!this.canUseLiveMatchActions(this.event) || this.directInviteInProgress) {
      return;
    }

    const email = (this.directInviteEmail || "").trim();
    const nickName = (this.directInviteNickName || "").trim();
    this.directInviteSuccessMsg = null;
    this.directInviteErrorMsg = null;

    if (!email && !nickName) {
      this.directInviteErrorMsg = this.translate.instant("events.directInviteRequired");
      return;
    }

    this.directInviteInProgress = true;
    this.playerService.sendDirectMatchInvite(this.event.id, email, nickName).subscribe(
      (response) => {
if (response && response.type === "EXISTING_PLAYER" && response.player) {
  this.invitePlayersToMatch([response.player]);
  this.appendAddedNogoshPlayers([response.player]);
  this.directInviteSuccessMsg = this.translate.instant("events.directInviteExistingPlayerSent");
} else if (response && response.type === "EXISTING_PARTICIPANT") {
  this.directInviteSuccessMsg = this.translate.instant(response.deliveryType === "REMINDER"
    ? "events.directInviteExistingPlayerReminderSent"
    : "events.directInviteExistingPlayerSent");
} else {
  this.directInviteSuccessMsg = this.translate.instant(response && response.deliveryType === "REMINDER"
    ? "events.directInviteNewUserReminderSent"
    : "events.directInviteNewUserSent");
}
this.directInviteEmail = "";
this.directInviteNickName = "";
this.directInviteInProgress = false;
      },
      (error) => {
        this.directInviteErrorMsg = error && error.status === 409
  ? this.translate.instant("notifications.playerInvitationLimitReached")
  : error && error.status === 404
  ? this.translate.instant("events.directInviteNotFound")
  : this.isDirectInviteAmbiguousError(error)
    ? this.translate.instant("events.directInviteAmbiguous")
  : this.getErrorMessage(error);
this.directInviteInProgress = false;
      }
    );
  }

  private isDirectInviteAmbiguousError(error: any): boolean {
    return !!(error && error.status === 400 && error.error && error.error.message === "DIRECT_INVITE_AMBIGUOUS");
  }

  public sendEmailInvites(): void {
    if (!this.canUseLiveMatchActions(this.event) || this.emailInviteInProgress) {
      return;
    }

    this.emailInviteSuccessMsg = null;
    this.emailInviteErrorMsg = null;

    const emails = this.parseEmailInviteList(this.emailInviteText);
    if (emails.length === 0) {
      this.emailInviteErrorMsg = this.translate.instant("notifications.inviteEmailsRequired");
      return;
    }
    if (emails.length > this.maxEmailInvites) {
      this.emailInviteErrorMsg = this.translate.instant("notifications.inviteEmailsTooMany", { max: this.maxEmailInvites });
      return;
    }

    const invalidEmail = emails.find((email) => !this.isValidInviteEmail(email));
    if (invalidEmail) {
      this.emailInviteErrorMsg = this.translate.instant("notifications.inviteEmailsInvalid", { email: invalidEmail });
      return;
    }

    this.emailInviteInProgress = true;
    this.playerService.sendEmailMatchInvites(this.event.id, emails).subscribe(
      (response) => {
        if (!response || response.sentCount === 0) {
          this.emailInviteErrorMsg = this.translate.instant("notifications.invitationLimitReached");
        } else if (response.skippedCount > 0) {
          this.emailInviteSuccessMsg = this.translate.instant("notifications.inviteEmailsPartiallySent", {
            count: response.sentCount,
            skipped: response.skippedCount
          });
        } else {
          this.emailInviteSuccessMsg = this.translate.instant("notifications.inviteEmailsSent", { count: response.sentCount });
        }
this.emailInviteText = "";
this.emailInviteInProgress = false;
      },
      (error) => {
        this.emailInviteErrorMsg = this.getErrorMessage(error);
this.emailInviteInProgress = false;
      }
    );
  }

  private parseEmailInviteList(value: string): string[] {
    const emailsByKey = new Map<string, string>();
    (value || "").split(/[\s,;]+/).forEach((email) => {
      const trimmedEmail = email.trim().toLowerCase();
      if (trimmedEmail) {
        emailsByKey.set(trimmedEmail, trimmedEmail);
      }
    });
    return Array.from(emailsByKey.values());
  }

  private isValidInviteEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  private loadNewUserInviteLink(): void {
    if (!this.event || !this.event.id || this.newUserInviteLinkLoading) {
      return;
    }

    this.newUserInviteLinkLoading = true;
    this.newUserInviteLinkErrorMsg = null;
    this.newUserInviteLinkCopiedMsg = null;
    this.eventService.ensureInviteLink(this.event.id).subscribe(
      (invite) => {
        this.newUserInviteLinkUrl = this.publicInviteUrl(invite && invite.invitePath ? invite.invitePath : "");
this.newUserInviteLinkLoading = false;
      },
      (error) => {
        this.newUserInviteLinkErrorMsg = this.getErrorMessage(error);
this.newUserInviteLinkLoading = false;
      }
    );
  }

  private publicInviteUrl(invitePath: string): string {
    if (!invitePath) {
      return "";
    }
    if (invitePath.indexOf("http") === 0) {
      return invitePath;
    }

    const path = invitePath.charAt(0) === "/" ? invitePath : "/" + invitePath;
    return `${window.location.origin}/#${path}`;
  }

  private appendAddedNogoshPlayers(players: Player[]): void {
    for (let player of players) {
      if (!this.addedNogoshPlayers.some((addedPlayer) => addedPlayer.id === player.id)) {
        this.addedNogoshPlayers.push(player);
      }
    }
  }

  private addPlayerToPlayerEventInfosList(player: Player): void {
    this.addPlayerToPlayerEventInfosListWithStatus(player, this.playerEventInfoStatus.NOT_NOTIFIED, this.playerEventInfoSource.MANAGER, false);
  }

  private invitePlayersToMatch(players: Player[]): void {
    for (let player of players) {
	  this.addPlayerToPlayerEventInfosListWithStatus(player, this.playerEventInfoStatus.NOT_NOTIFIED, this.playerEventInfoSource.INVITE, true);
    }
  }

  private addPlayersAsHistoryAttendees(players: Player[]): void {
    for (let player of players) {
      this.addPlayerToPlayerEventInfosListWithStatus(player, this.playerEventInfoStatus.CONFIRMED, this.playerEventInfoSource.MANAGER, false);
    }
  }

  private addPlayerToPlayerEventInfosListWithStatus(player: Player, status: string, source: string, sendInvitation: boolean): void {
    if (!this.canUseLiveMatchActions(this.event) && !this.canAddHistoryAttendees(this.event)) {
      return;
    }

    let currentPlayerEventInfosList = this.event.playerEventInfos;
    let playerEventInfoFound: boolean = false;

    for (let playerEventInfo of currentPlayerEventInfosList) {
      if (player.id === playerEventInfo.player.id) {
        playerEventInfoFound = true;
        break;
      }
    }

    if (!playerEventInfoFound) {
      let newPlayerEventInfo: PlayerEventInfo = new PlayerEventInfo();
      newPlayerEventInfo.eventId = this.event.id;
      newPlayerEventInfo.player = player;
      newPlayerEventInfo.jersey = this.playerEventInfoJersey.WHITE;
      newPlayerEventInfo.status = status;
      newPlayerEventInfo.teamMemberType = this.teamMemberType.RESERVE;
      newPlayerEventInfo.source = source;

      if (newPlayerEventInfo.eventId) {
        this.loadingPlayersList = true;
        this.playerEventInfoService.create(newPlayerEventInfo, this.currentPlayer).subscribe(
          (playerEventInfo) => {
            if (sendInvitation) {
              this.eventService.invitePlayer(playerEventInfo).subscribe(
                (invitedPlayerEventInfo) => {
                  this.event.playerEventInfos.push(invitedPlayerEventInfo);
                  this.refreshEventPlayerState();
                  this.loadingPlayersList = false;
                },
                (error) => {
                  console.log(error);
                  this.event.playerEventInfos.push(playerEventInfo);
this.refreshEventPlayerState();
this.loadingPlayersList = false;
                }
              );
              return;
            }

            this.event.playerEventInfos.push(playerEventInfo);
this.refreshEventPlayerState();
this.loadingPlayersList = false;
          },
          (error) => {
            console.log(error);
            this.loadingPlayersList = false;
          }
        );
      } else {
        this.event.playerEventInfos.push(newPlayerEventInfo);
      }
    }
  }

  public copyNogoshInviteMessage(): void {
    const message = this.inviteMessageText();
    if (!message) {
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(message).then(
        () => this.newUserInviteLinkCopiedMsg = this.translate.instant("guestOwner.messages.inviteCopied"),
        () => this.copyNogoshMessageFallback(message)
      );
      return;
    }

    this.copyNogoshMessageFallback(message);
  }

  private inviteMessageText(): string {
    if (!this.newUserInviteLinkUrl) {
      return "";
    }
    return `${this.translate.instant('notifications.shareInvite', { matchName: this.event.name })}\n${this.newUserInviteLinkUrl}`;
  }

  private copyNogoshMessageFallback(value: string): void {
    let selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    this.newUserInviteLinkCopiedMsg = this.translate.instant("guestOwner.messages.inviteCopied");
  }

  public openShareMenu(){
    if (!this.canUseLiveMatchActions(this.event)) {
      return;
    }

    if (!this.newUserInviteLinkUrl) {
      this.loadNewUserInviteLink();
      this.showNewNogoshUserDialog = true;
      return;
    }

    const shareData = {
      title: this.translate.instant('notifications.shareTitle'),
      text: this.inviteMessageText(),
    }

    try {
      navigator.share(shareData)
    } catch(err) {
      console.log('Error: ' + err);
      this.showNewNogoshUserDialog = true;
    }
  }

  public goBack(): void {
    if (this.event && this.event.historyEvent === true && this.inlineHistoryParentEvent) {
      this.event = this.inlineHistoryParentEvent;
      localStorage.setItem("event", JSON.stringify(this.event));
      this.setMatchInfoEditorMode("history");
      this.eventPlayersReady$.next(true);
      window.scrollTo(0, 0);
      return;
    }

    navigateBackOrFallback(this._location, this.router, ["/event-list"]);
  }

  public assignTeams(): void {
    if (!this.canUseLiveMatchActions(this.event) || this.balanceTeamsInProgress) {
      return;
    }

    this.analytics.track("team_balance_opened", {
      screen: "match_players",
      entityType: "event",
      entityId: this.event && this.event.id
    });
    this.balanceTeamsInProgress = true;
    this.balanceTeamsErrorMsg = null;

    this.eventService.balanceTeams(this.event.id).subscribe(
      (result) => {
        this.applyBalanceTeamsResult(result);
this.balanceTeamsResult = result;
this.showBalanceTeamsDetails = false;
this.fetchPlayerEventInfos(this.event);
this.balanceTeamsInProgress = false;
      },
      (error) => {
        console.log(error);
        this.balanceTeamsErrorMsg = this.getBalanceTeamsErrorMessage(error);
this.balanceTeamsInProgress = false;
      }
    );
  }

  private clearBalanceTeamsResultAfterManualJerseyChange(): void {
    this.balanceTeamsResult = null;
    this.balanceTeamsErrorMsg = null;
    this.showBalanceTeamsDetails = false;
  }

  private applyBalanceTeamsResult(result: BalanceTeamsResult): void {
    if (!result || !this.event || !this.event.playerEventInfos) {
      return;
    }

    const jerseyByPlayerId: { [playerId: string]: string } = {};
    (result.whiteTeam || []).forEach((playerResult) => jerseyByPlayerId[playerResult.playerId] = this.playerEventInfoJersey.WHITE);
    (result.blackTeam || []).forEach((playerResult) => jerseyByPlayerId[playerResult.playerId] = this.playerEventInfoJersey.BLACK);

    this.event.playerEventInfos.forEach((playerEventInfo) => {
      if (playerEventInfo.player && jerseyByPlayerId[playerEventInfo.player.id]) {
        playerEventInfo.jersey = jerseyByPlayerId[playerEventInfo.player.id];
      }
    });
  }

  private getBalanceTeamsErrorMessage(error: any): string {
    if (error?.status === 409 && error?.error?.code === 'PARTICIPATION_CHANGED') {
      return this.translate.instant('guestOwner.notices.participationChangedMessage');
    }
    if (error && error.status === 400) {
      return this.translate.instant('errors.balanceTeamsMinPlayers');
    }
    if (error && error.status === 403) {
      return this.translate.instant('errors.balanceTeamsManagerOnly');
    }
    if (error && error.status === 404) {
      return this.translate.instant('errors.balanceTeamsEventMissing');
    }

    return this.translate.instant('errors.balanceTeamsGeneric');
  }

  public closeBalanceTeamsDialog(): void {
    this.showBalanceTeamsDialog = false;
    this.showBalanceTeamsDetails = false;
  }

  public toggleBalanceTeamsDetails(): void {
    this.showBalanceTeamsDetails = !this.showBalanceTeamsDetails;
  }

  public formatBalanceNumber(value: number): string {
    if (value === null || value === undefined) {
      return '-';
    }

    return Number(value).toLocaleString(undefined, { maximumFractionDigits: 1 });
  }

  public isGreedyBalanceAlgorithm(result: BalanceTeamsResult): boolean {
    return !!result && !!result.algorithm && result.algorithm.indexOf('GREEDY_LIMIT') === 0;
  }

  public isGuestPlayer(player: Player): boolean {
    return !!player && (
      player.guest === true ||
      player.playerType === this.playerType.MANAGED_PLAYER ||
      player.playerType === this.playerType.GUEST
    );
  }

  public isManagedPlayer(player: Player): boolean {
    return !!player && (
      player.managedPlayer === true ||
      player.playerType === this.playerType.MANAGED_PLAYER
    );
  }

  public accountlessPlayerLabel(player: Player): string {
    return this.translate.instant(this.isManagedPlayer(player) ? 'guests.managedPlayer' : 'guests.guest');
  }

  public isCurrentPlayer(playerEventInfo: PlayerEventInfo): boolean {
    return !!playerEventInfo && !!playerEventInfo.player && !!this.currentPlayer
      && playerEventInfo.player.id === this.currentPlayer.id;
  }

  public loadGuestPlayers(): void {
    if (!this.canUseLiveMatchActions(this.event) && !this.canAddHistoryAttendees(this.event)) {
      return;
    }

    this.guestErrorMsg = null;
    this.playerService.getGuestPlayers(this.event.id).subscribe(
      (players) => {
        this.guestPlayers = (players || []).filter((player) => this.canAddGuestToEvents(player));
      },
      (res) => {
        this.guestErrorMsg = this.getErrorMessage(res);
      }
    );
  }

  public isGuestAlreadyOnEvent(guest: Player): boolean {
    return !!this.findGuestPlayerEventInfo(guest);
  }

  public canAddGuestToEvents(guest: Player): boolean {
    if (!this.isGuestPlayer(guest) || guest.active === false || guest.claimed === true || guest.merged === true) {
      return false;
    }

    return guest.claimStatus !== "CLAIMED" && guest.claimStatus !== "MERGED";
  }

  private findGuestPlayerEventInfo(guest: Player): PlayerEventInfo {
    if (!this.event || !this.event.playerEventInfos) {
      return null;
    }

    return this.event.playerEventInfos.find((playerEventInfo) => playerEventInfo.player.id === guest.id);
  }

  public startEditGuest(guest: Player): void {
    this.selectedGuestForEdit = guest;
    this.guestForm = { name: this.getGuestDisplayName(guest), nickName: this.getGuestDisplayName(guest) };
    this.guestErrorMsg = null;
  }

  public openGuestDetail(guest: Player): void {
    this.selectedGuestForEdit = guest;
    this.guestForm = { name: "", nickName: "" };
    this.guestErrorMsg = null;
  }

  public closeGuestDetail(): void {
    this.selectedGuestForEdit = null;
    this.guestErrorMsg = null;
  }

  public onEmbeddedPlayerRemoved(): void {
    this.refreshEventPlayerState();
    if (this.selectedGuestForEdit) this.closeGuestDetail();
    else this.closeMatchInfoEditor();
  }

  public selectedGuestPlayerEventInfo(): PlayerEventInfo {
    if (!this.selectedGuestForEdit) {
      return null;
    }

    const existingPlayerEventInfo = this.findGuestPlayerEventInfo(this.selectedGuestForEdit);
    if (existingPlayerEventInfo) {
      return existingPlayerEventInfo;
    }

    const playerEventInfo = new PlayerEventInfo();
    playerEventInfo.player = this.selectedGuestForEdit;
    playerEventInfo.eventId = this.event ? this.event.id : null;
    playerEventInfo.status = this.playerEventInfoStatus.NOT_NOTIFIED;
    playerEventInfo.jersey = this.playerEventInfoJersey.WHITE;
    playerEventInfo.teamMemberType = this.teamMemberType.RESERVE;
    return playerEventInfo;
  }

  public cancelGuestEdit(): void {
    this.selectedGuestForEdit = null;
    this.guestForm = { name: "", nickName: "" };
    this.guestErrorMsg = null;
  }

  public saveGuest(): void {
    if (!this.canUseLiveMatchActions(this.event) && !this.canAddHistoryAttendees(this.event)) {
      return;
    }

    const request = this.buildGuestRequest();
    if (!request) {
      return;
    }

    this.guestActionInProgress = true;
    const saveRequest = this.selectedGuestForEdit
      ? this.playerService.updateGuestPlayer(this.selectedGuestForEdit.id, this.event.id, request)
      : this.playerService.createGuestPlayer(this.event.id, {
          ...request,
          status: this.canAddHistoryAttendees(this.event) ? this.playerEventInfoStatus.CONFIRMED : this.playerEventInfoStatus.NOT_NOTIFIED,
          jersey: this.playerEventInfoJersey.WHITE,
          teamMemberType: this.teamMemberType.RESERVE
        });

    saveRequest.subscribe(
      (guest) => {
        this.upsertGuest(guest);
        this.cancelGuestEdit();
        this.fetchPlayerEventInfos(this.event);
        this.guestActionInProgress = false;
      },
      (res) => {
        this.guestErrorMsg = this.getErrorMessage(res);
        this.guestActionInProgress = false;
      }
    );
  }

  public createGuestOnEvent(): void {
    if (!this.canUseLiveMatchActions(this.event) && !this.canAddHistoryAttendees(this.event)) {
      return;
    }

    const request = this.buildGuestRequest();
    if (!request) {
      return;
    }

    this.guestActionInProgress = true;
    this.playerService.createGuestPlayer(this.event.id, {
      ...request,
      status: this.canAddHistoryAttendees(this.event) ? this.playerEventInfoStatus.CONFIRMED : this.playerEventInfoStatus.NOT_NOTIFIED,
      jersey: this.playerEventInfoJersey.WHITE,
      teamMemberType: this.teamMemberType.RESERVE
    }).subscribe(
      (guest) => {
        this.upsertGuest(guest);
        this.cancelGuestEdit();
        this.loadGuestPlayers();
        this.fetchPlayerEventInfos(this.event);
        this.guestActionInProgress = false;
      },
      (res) => {
        this.guestErrorMsg = this.getErrorMessage(res);
        this.guestActionInProgress = false;
      }
    );
  }

  public dialogDeactivateGuest(guest: Player): void {
    this.guestForDeactivate = guest;
    this.showDeactivateGuestDialog = true;
  }

  public deactivateGuest(): void {
    if (!this.canUseLiveMatchActions(this.event) || !this.guestForDeactivate) {
      return;
    }

    const guest = this.guestForDeactivate;
    this.guestActionInProgress = true;
    this.playerService.removeGuestFromEvent(guest.id, this.event.id).subscribe(
      () => {
        this.guestPlayers = this.guestPlayers.filter((item) => item.id !== guest.id);
        this.event.playerEventInfos = this.event.playerEventInfos.filter((item) => item.player.id !== guest.id);
        this.refreshEventPlayerState();
        this.closeGuestDetail();
        this.guestForDeactivate = null;
        this.showDeactivateGuestDialog = false;
        this.guestActionInProgress = false;
      },
      (res) => {
        this.guestErrorMsg = this.getErrorMessage(res);
        this.guestActionInProgress = false;
      }
    );
  }

  private buildGuestRequest(): GuestPlayerRequest {
    const name = this.guestForm.name ? this.guestForm.name.trim() : "";
    if (!name) {
      this.guestErrorMsg = this.translate.instant('guestOwner.notices.guestNameRequired');
      return null;
    }

    return { name, nickName: name };
  }

  private upsertGuest(guest: Player): void {
    const existingIndex = this.guestPlayers.findIndex((item) => item.id === guest.id);
    if (existingIndex > -1) {
      this.guestPlayers[existingIndex] = guest;
    } else {
      this.guestPlayers.push(guest);
    }
    this.guestPlayers.sort((a, b) => this.getGuestDisplayName(a).localeCompare(this.getGuestDisplayName(b)));
  }

  public getGuestDisplayName(guest: Player): string {
    if (!guest) {
      return "";
    }

    return (guest.name || guest.nickName || "").trim();
  }

  private updateParticipation(playerEventInfo: PlayerEventInfo): Observable<PlayerEventInfo> {
    if (this.isGuestPlayer(playerEventInfo.player)) {
      const request: GuestParticipationRequest = {
        status: playerEventInfo.status,
        jersey: playerEventInfo.jersey,
        teamMemberType: playerEventInfo.teamMemberType,
      };
      return this.playerService.updateGuestParticipation(playerEventInfo.player.id, this.event.id, request);
    }

    return this.playerEventInfoService.update(playerEventInfo, this.currentPlayer);
  }

  private refreshEventPlayerState(): void {
    this.countOfConfirmed = 0;
    this.countOfNotAnswered = 0;
    this.countOfDeclined = 0;
    this.countOfNotNotified = 0;
    this.newCandidatesInfoList = [];
    this.newCandidatesFound = false;

    for (let playerEventInfo of this.event.playerEventInfos) {
      if (playerEventInfo.teamMemberType === this.teamMemberType.CANDIDATE) {
        this.newCandidatesFound = true;
        this.newCandidatesInfoList.push(playerEventInfo);
        continue;
      }

      if (playerEventInfo.status === this.playerEventInfoStatus.CONFIRMED) {
        this.countOfConfirmed++;
      } else if (playerEventInfo.status === this.playerEventInfoStatus.NOT_ANSWERED) {
        this.countOfNotAnswered++;
      } else if (playerEventInfo.status === this.playerEventInfoStatus.DECLINED) {
        this.countOfDeclined++;
      } else {
        this.countOfNotNotified++;
      }
    }

    this.event.confirmedCount = this.countOfConfirmed;
    this.event.attendance = { ...this.event.attendance, confirmed: this.countOfConfirmed };
    this.sortPlayers();
  }

  private getErrorMessage(response: any): string {
    if (response?.error?.code === "EVENT_MANAGER_CHANGED") {
      return this.translate.instant("events.settingsManagerChanged");
    }
    if (response && response.error) {
      if (response.error.message) {
        return response.error.message;
      }
      if (response.error.errorMsg) {
        return response.error.errorMsg;
      }
      if (typeof response.error === "string") {
        return response.error;
      }
    }

    return this.translate.instant('playerManagement.errors.actionFailed');
  }
}
